var Nu = Object.defineProperty, Iu = Object.defineProperties;
var Cu = Object.getOwnPropertyDescriptors;
var Me = Object.getOwnPropertySymbols, Mu = Object.getPrototypeOf, Ri = Object.prototype.hasOwnProperty, Li = Object.prototype.propertyIsEnumerable, xu = Reflect.get;
var Pi = (e) => {
  throw TypeError(e);
};
var wr = (e, t, r) => t in e ? Nu(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, E = (e, t) => {
  for (var r in t || (t = {}))
    Ri.call(t, r) && wr(e, r, t[r]);
  if (Me)
    for (var r of Me(t))
      Li.call(t, r) && wr(e, r, t[r]);
  return e;
}, C = (e, t) => Iu(e, Cu(t));
var Rr = (e, t) => {
  var r = {};
  for (var n in e)
    Ri.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && Me)
    for (var n of Me(e))
      t.indexOf(n) < 0 && Li.call(e, n) && (r[n] = e[n]);
  return r;
};
var O = (e, t, r) => wr(e, typeof t != "symbol" ? t + "" : t, r), Ni = (e, t, r) => t.has(e) || Pi("Cannot " + r);
var Ii = (e, t, r) => (Ni(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Ci = (e, t, r) => t.has(e) ? Pi("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Mi = (e, t, r, n) => (Ni(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r);
var Lr = (e, t, r) => xu(Mu(e), r, t);
var B = (e, t, r) => new Promise((n, i) => {
  var o = (c) => {
    try {
      u(r.next(c));
    } catch (s) {
      i(s);
    }
  }, a = (c) => {
    try {
      u(r.throw(c));
    } catch (s) {
      i(s);
    }
  }, u = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(o, a);
  u((r = r.apply(e, t)).next());
});
import { U as ma, W as Du, X as On, Y as Uu, s as _e, Z as ut, _ as Ta, $ as Sa, a0 as Oa, a1 as ht, P as Bu, a2 as ku, a3 as ba, x as Gu, a4 as $u, a5 as Hu, a6 as ju, a7 as Vu, a8 as Fu, a9 as We, q as Xu, aa as Pr, ab as Nr, ac as zu, ad as qu, c as Ku, n as Wu, o as Yu, L as Ju, h as Zu, t as Qu, ae as tc, E as ec, af as rc, ag as nc, I as Ir, J as xi, ah as ic, ai as oc, K as ac, N as sc, O as uc, Q as cc, R as lc, T as fc, aj as dc, ak as pc, al as Di, am as hc, an as _c, ao as vc } from "./common-Bb1m6MTi.js";
import { a as gc, i as Aa } from "./buffer-DIFxvF2Q.js";
import { LDObserve as yc } from "./LDObserve.js";
const wa = [
  "assert",
  "count",
  "countReset",
  "debug",
  "dir",
  "dirxml",
  "error",
  "group",
  "groupCollapsed",
  "groupEnd",
  "info",
  "log",
  "table",
  "time",
  "timeEnd",
  "timeLog",
  "trace",
  "warn"
];
var j = /* @__PURE__ */ ((e) => (e.DeviceMemory = "DeviceMemory", e.ViewportHeight = "ViewportHeight", e.ViewportWidth = "ViewportWidth", e.ScreenHeight = "ScreenHeight", e.ScreenWidth = "ScreenWidth", e.ViewportArea = "ViewportArea", e))(j || {}), F = /* @__PURE__ */ ((e) => (e.Device = "Device", e.WebVital = "WebVital", e.Performance = "Performance", e.Frontend = "Frontend", e.Backend = "Backend", e))(F || {}), Ra = { exports: {} }, Cr = { exports: {} }, Ui;
function Ec() {
  return Ui || (Ui = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(ma, function() {
      function r(h) {
        return !isNaN(parseFloat(h)) && isFinite(h);
      }
      function n(h) {
        return h.charAt(0).toUpperCase() + h.substring(1);
      }
      function i(h) {
        return function() {
          return this[h];
        };
      }
      var o = ["isConstructor", "isEval", "isNative", "isToplevel"], a = ["columnNumber", "lineNumber"], u = ["fileName", "functionName", "source"], c = ["args"], s = ["evalOrigin"], l = o.concat(a, u, c, s);
      function f(h) {
        if (h)
          for (var g = 0; g < l.length; g++)
            h[l[g]] !== void 0 && this["set" + n(l[g])](h[l[g]]);
      }
      f.prototype = {
        getArgs: function() {
          return this.args;
        },
        setArgs: function(h) {
          if (Object.prototype.toString.call(h) !== "[object Array]")
            throw new TypeError("Args must be an Array");
          this.args = h;
        },
        getEvalOrigin: function() {
          return this.evalOrigin;
        },
        setEvalOrigin: function(h) {
          if (h instanceof f)
            this.evalOrigin = h;
          else if (h instanceof Object)
            this.evalOrigin = new f(h);
          else
            throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
          var h = this.getFileName() || "", g = this.getLineNumber() || "", y = this.getColumnNumber() || "", m = this.getFunctionName() || "";
          return this.getIsEval() ? h ? "[eval] (" + h + ":" + g + ":" + y + ")" : "[eval]:" + g + ":" + y : m ? m + " (" + h + ":" + g + ":" + y + ")" : h + ":" + g + ":" + y;
        }
      }, f.fromString = function(g) {
        var y = g.indexOf("("), m = g.lastIndexOf(")"), A = g.substring(0, y), w = g.substring(y + 1, m).split(","), L = g.substring(m + 1);
        if (L.indexOf("@") === 0)
          var I = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(L, ""), tt = I[1], M = I[2], et = I[3];
        return new f({
          functionName: A,
          args: w || void 0,
          fileName: tt,
          lineNumber: M || void 0,
          columnNumber: et || void 0
        });
      };
      for (var d = 0; d < o.length; d++)
        f.prototype["get" + n(o[d])] = i(o[d]), f.prototype["set" + n(o[d])] = /* @__PURE__ */ function(h) {
          return function(g) {
            this[h] = !!g;
          };
        }(o[d]);
      for (var p = 0; p < a.length; p++)
        f.prototype["get" + n(a[p])] = i(a[p]), f.prototype["set" + n(a[p])] = /* @__PURE__ */ function(h) {
          return function(g) {
            if (!r(g))
              throw new TypeError(h + " must be a Number");
            this[h] = Number(g);
          };
        }(a[p]);
      for (var _ = 0; _ < u.length; _++)
        f.prototype["get" + n(u[_])] = i(u[_]), f.prototype["set" + n(u[_])] = /* @__PURE__ */ function(h) {
          return function(g) {
            this[h] = String(g);
          };
        }(u[_]);
      return f;
    });
  }(Cr)), Cr.exports;
}
(function(e, t) {
  (function(r, n) {
    e.exports = n(Ec());
  })(ma, function(n) {
    var i = /(^|@)\S+:\d+/, o = /^\s*at .*(\S+:\d+|\(native\))/m, a = /^(eval@)?(\[native code])?$/;
    return {
      /**
       * Given an Error object, extract the most information from it.
       *
       * @param {Error} error object
       * @return {Array} of StackFrames
       */
      parse: function(c) {
        if (typeof c.stacktrace != "undefined" || typeof c["opera#sourceloc"] != "undefined")
          return this.parseOpera(c);
        if (c.stack && c.stack.match(o))
          return this.parseV8OrIE(c);
        if (c.stack)
          return this.parseFFOrSafari(c);
        throw new Error("Cannot parse given Error object");
      },
      // Separate line and column numbers from a string of the form: (URI:Line:Column)
      extractLocation: function(c) {
        if (c.indexOf(":") === -1)
          return [c];
        var s = /(.+?)(?::(\d+))?(?::(\d+))?$/, l = s.exec(c.replace(/[()]/g, ""));
        return [l[1], l[2] || void 0, l[3] || void 0];
      },
      parseV8OrIE: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !!l.match(o);
        }, this);
        return s.map(function(l) {
          l.indexOf("(eval ") > -1 && (l = l.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
          var f = l.replace(/^\s+/, "").replace(/\(eval code/g, "("), d = f.match(/ (\((.+):(\d+):(\d+)\)$)/);
          f = d ? f.replace(d[0], "") : f;
          var p = f.split(/\s+/).slice(1), _ = this.extractLocation(d ? d[1] : p.pop()), h = p.join(" ") || void 0, g = ["eval", "<anonymous>"].indexOf(_[0]) > -1 ? void 0 : _[0];
          return new n({
            functionName: h,
            fileName: g,
            lineNumber: _[1],
            columnNumber: _[2],
            source: l
          });
        }, this);
      },
      parseFFOrSafari: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !l.match(a);
        }, this);
        return s.map(function(l) {
          if (l.indexOf(" > eval") > -1 && (l = l.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), l.indexOf("@") === -1 && l.indexOf(":") === -1)
            return new n({
              functionName: l
            });
          var f = /((.*".+"[^@]*)?[^@]*)(?:@)/, d = l.match(f), p = d && d[1] ? d[1] : void 0, _ = this.extractLocation(l.replace(f, ""));
          return new n({
            functionName: p,
            fileName: _[0],
            lineNumber: _[1],
            columnNumber: _[2],
            source: l
          });
        }, this);
      },
      parseOpera: function(c) {
        return !c.stacktrace || c.message.indexOf(`
`) > -1 && c.message.split(`
`).length > c.stacktrace.split(`
`).length ? this.parseOpera9(c) : c.stack ? this.parseOpera11(c) : this.parseOpera10(c);
      },
      parseOpera9: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)/i, l = c.message.split(`
`), f = [], d = 2, p = l.length; d < p; d += 2) {
          var _ = s.exec(l[d]);
          _ && f.push(new n({
            fileName: _[2],
            lineNumber: _[1],
            source: l[d]
          }));
        }
        return f;
      },
      parseOpera10: function(c) {
        for (var s = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, l = c.stacktrace.split(`
`), f = [], d = 0, p = l.length; d < p; d += 2) {
          var _ = s.exec(l[d]);
          _ && f.push(
            new n({
              functionName: _[3] || void 0,
              fileName: _[2],
              lineNumber: _[1],
              source: l[d]
            })
          );
        }
        return f;
      },
      // Opera 10.65+ Error.stack very similar to FF/Safari
      parseOpera11: function(c) {
        var s = c.stack.split(`
`).filter(function(l) {
          return !!l.match(i) && !l.match(/^Error created at/);
        }, this);
        return s.map(function(l) {
          var f = l.split("@"), d = this.extractLocation(f.pop()), p = f.shift() || "", _ = p.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0, h;
          p.match(/\(([^)]*)\)/) && (h = p.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
          var g = h === void 0 || h === "[arguments not available]" ? void 0 : h.split(",");
          return new n({
            functionName: _,
            args: g,
            fileName: d[0],
            lineNumber: d[1],
            columnNumber: d[2],
            source: l
          });
        }, this);
      }
    };
  });
})(Ra);
var mc = Ra.exports;
const Bi = /* @__PURE__ */ Du(mc);
function _r(e) {
  try {
    return Bi.parse(e);
  } catch (t) {
    try {
      return Bi.parse(new Error());
    } catch (r) {
      return console.warn("Highlight Warning: failed to parse error", {
        originalError: t,
        secondaryError: r
      }), [];
    }
  }
}
const VT = {
  level: [...wa],
  logger: "console",
  stringifyOptions: {
    depthOfLimit: 10,
    numOfKeysLimit: 100,
    stringLengthLimit: 1e3
  }
};
function Tc(e, t) {
  const r = t.logger;
  if (!r)
    return () => {
    };
  let n;
  typeof r == "string" ? n = window[r] : n = r;
  const i = [];
  if (t.level.includes("error") && window) {
    const a = (u) => {
      const { message: c, error: s } = u;
      let l = [];
      s && (l = _r(s));
      const f = [
        On(c, t.stringifyOptions)
      ];
      e({
        type: "Error",
        trace: l,
        time: Date.now(),
        value: f
      });
    };
    window.addEventListener("error", a), i.push(() => {
      window && window.removeEventListener("error", a);
    });
  }
  for (const a of t.level)
    i.push(o(n, a));
  return () => {
    i.forEach((a) => a());
  };
  function o(a, u) {
    return a[u] ? Uu(a, u, (c) => (...s) => {
      c.apply(this, s);
      try {
        e(Sc(u, t, ...s));
      } catch (l) {
        c("highlight logger error:", l, ...s);
      }
    }) : () => {
    };
  }
}
function Sc(e, t, ...r) {
  const n = _r(new Error()), i = t.serializeConsoleAttributes ? r.map(
    (o) => typeof o == "object" ? On(o, t.stringifyOptions) : o
  ) : r.filter((o) => typeof o != "object").map((o) => `${o}`);
  return {
    type: e,
    trace: n,
    value: i,
    attributes: On(
      r.filter((o) => typeof o == "object").reduce((o, a) => E(E({}, o), a), {}),
      t.stringifyOptions
    ),
    time: Date.now()
  };
}
const Oc = {
  start: 0,
  end: 3
}, bc = {
  start: 4,
  end: 5
}, Mr = {
  start: 6,
  end: 7
}, xr = {
  start: 8,
  end: 8
}, Ac = {
  start: 9,
  end: 9
}, wc = {
  start: 10,
  end: 15
};
function Rc() {
  if (crypto && crypto.getRandomValues) {
    const t = new Uint8Array(16);
    return crypto.getRandomValues(t), [...t.values()];
  }
  const e = [];
  for (let t = 0; t < 16; t += 1)
    e.push(Math.floor(Math.random() * 256));
  return e;
}
function xt(e, t) {
  let r = "";
  for (let n = t.start; n <= t.end; n += 1)
    r += e[n].toString(16).padStart(2, "0");
  return r;
}
function Lc(e) {
  return e[xr.start] = (e[xr.start] | 128) & 191, e[Mr.start] = e[Mr.start] & 15 | 64, `${xt(e, Oc)}-${xt(e, bc)}-${xt(e, Mr)}-${xt(e, xr)}${xt(e, Ac)}-${xt(e, wc)}`;
}
function Pc() {
  const e = Rc();
  return Lc(e);
}
function bn() {
  return typeof crypto != "undefined" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : Pc();
}
function Dr(e, t, r, n) {
  var c, s, l, f;
  let i = n != null ? n : t, o = _r(i), a = {};
  t instanceof Error && (t = t.message, t.cause && (a = { "exception.cause": t.cause }));
  const u = Ic(o);
  e({
    error: i,
    event: _e(t),
    type: "window.onerror",
    url: window.location.href,
    source: r != null ? r : "",
    lineNumber: (c = u[0]) != null && c.lineNumber ? (s = u[0]) == null ? void 0 : s.lineNumber : 0,
    columnNumber: (l = u[0]) != null && l.columnNumber ? (f = u[0]) == null ? void 0 : f.columnNumber : 0,
    stackTrace: u,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    payload: a ? _e(a) : void 0,
    id: bn()
  });
}
const Nc = (e, { enablePromisePatch: t }) => {
  if (typeof window == "undefined") return () => {
  };
  const r = window.onerror = (a, u, c, s, l) => {
    Dr(e, a, u, l);
  }, n = window.onunhandledrejection = (a) => {
    if (a.reason) {
      const u = a.promise;
      u.getStack ? Dr(
        e,
        a.reason,
        a.type,
        u.getStack()
      ) : Dr(e, a.reason, a.type);
    }
  }, i = window.Promise, o = class extends i {
    constructor(c) {
      super(c);
      O(this, "promiseCreationError");
      this.promiseCreationError = new Error();
    }
    getStack() {
      return this.promiseCreationError;
    }
    static shouldPatch() {
      const c = typeof window.Zone == "undefined";
      return t && c;
    }
  };
  return o.shouldPatch() && (window.Promise = o), () => {
    window.Promise = i, window.onunhandledrejection = n, window.onerror = r;
  };
}, Ic = (e) => {
  var r, n;
  if (e.length === 0)
    return e;
  const t = e[0];
  return (r = t.fileName) != null && r.includes("highlight.run") || (n = t.fileName) != null && n.includes("highlight.io") || t.functionName === "new highlightPromise" ? e.slice(1) : e;
}, Cc = [
  '["\\"Script error.\\""]',
  '"Script error."',
  '["\\"Load failed.\\""]',
  '"Load failed."',
  '["\\"Network request failed.\\""]',
  '"Network request failed."',
  '["\\"Document is not focused.\\""]',
  '"Document is not focused."',
  '["\\"Failed to fetch\\""]',
  '"Failed to fetch"',
  '[{"isTrusted":true}]',
  '{"isTrusted":true}',
  '["{}"]',
  '"{}"',
  '[""]',
  '""',
  '["\\"\\""]',
  '""'
], Mc = [
  "websocket error",
  '\\"ResizeObserver loop'
];
var xc = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, St = "1.9.0", ki = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function Dc(e) {
  var t = /* @__PURE__ */ new Set([e]), r = /* @__PURE__ */ new Set(), n = e.match(ki);
  if (!n)
    return function() {
      return !1;
    };
  var i = {
    major: +n[1],
    minor: +n[2],
    patch: +n[3],
    prerelease: n[4]
  };
  if (i.prerelease != null)
    return function(c) {
      return c === e;
    };
  function o(u) {
    return r.add(u), !1;
  }
  function a(u) {
    return t.add(u), !0;
  }
  return function(c) {
    if (t.has(c))
      return !0;
    if (r.has(c))
      return !1;
    var s = c.match(ki);
    if (!s)
      return o(c);
    var l = {
      major: +s[1],
      minor: +s[2],
      patch: +s[3],
      prerelease: s[4]
    };
    return l.prerelease != null || i.major !== l.major ? o(c) : i.major === 0 ? i.minor === l.minor && i.patch <= l.patch ? a(c) : o(c) : i.minor <= l.minor ? a(c) : o(c);
  };
}
var Uc = Dc(St), Bc = St.split(".")[0], ve = Symbol.for("opentelemetry.js.api." + Bc), ge = xc;
function we(e, t, r, n) {
  var i;
  n === void 0 && (n = !1);
  var o = ge[ve] = (i = ge[ve]) !== null && i !== void 0 ? i : {
    version: St
  };
  if (!n && o[e]) {
    var a = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + e);
    return r.error(a.stack || a.message), !1;
  }
  if (o.version !== St) {
    var a = new Error("@opentelemetry/api: Registration of version v" + o.version + " for " + e + " does not match previously registered API v" + St);
    return r.error(a.stack || a.message), !1;
  }
  return o[e] = t, r.debug("@opentelemetry/api: Registered a global for " + e + " v" + St + "."), !0;
}
function At(e) {
  var t, r, n = (t = ge[ve]) === null || t === void 0 ? void 0 : t.version;
  if (!(!n || !Uc(n)))
    return (r = ge[ve]) === null || r === void 0 ? void 0 : r[e];
}
function Re(e, t) {
  t.debug("@opentelemetry/api: Unregistering a global for " + e + " v" + St + ".");
  var r = ge[ve];
  r && delete r[e];
}
var kc = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Gc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, $c = (
  /** @class */
  function() {
    function e(t) {
      this._namespace = t.namespace || "DiagComponentLogger";
    }
    return e.prototype.debug = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return ee("debug", this._namespace, t);
    }, e.prototype.error = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return ee("error", this._namespace, t);
    }, e.prototype.info = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return ee("info", this._namespace, t);
    }, e.prototype.warn = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return ee("warn", this._namespace, t);
    }, e.prototype.verbose = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return ee("verbose", this._namespace, t);
    }, e;
  }()
);
function ee(e, t, r) {
  var n = At("diag");
  if (n)
    return r.unshift(t), n[e].apply(n, Gc([], kc(r), !1));
}
var P;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.ERROR = 30] = "ERROR", e[e.WARN = 50] = "WARN", e[e.INFO = 60] = "INFO", e[e.DEBUG = 70] = "DEBUG", e[e.VERBOSE = 80] = "VERBOSE", e[e.ALL = 9999] = "ALL";
})(P || (P = {}));
function Hc(e, t) {
  e < P.NONE ? e = P.NONE : e > P.ALL && (e = P.ALL), t = t || {};
  function r(n, i) {
    var o = t[n];
    return typeof o == "function" && e >= i ? o.bind(t) : function() {
    };
  }
  return {
    error: r("error", P.ERROR),
    warn: r("warn", P.WARN),
    info: r("info", P.INFO),
    debug: r("debug", P.DEBUG),
    verbose: r("verbose", P.VERBOSE)
  };
}
var jc = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Vc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Fc = "diag", Z = (
  /** @class */
  function() {
    function e() {
      function t(i) {
        return function() {
          for (var o = [], a = 0; a < arguments.length; a++)
            o[a] = arguments[a];
          var u = At("diag");
          if (u)
            return u[i].apply(u, Vc([], jc(o), !1));
        };
      }
      var r = this, n = function(i, o) {
        var a, u, c;
        if (o === void 0 && (o = { logLevel: P.INFO }), i === r) {
          var s = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
          return r.error((a = s.stack) !== null && a !== void 0 ? a : s.message), !1;
        }
        typeof o == "number" && (o = {
          logLevel: o
        });
        var l = At("diag"), f = Hc((u = o.logLevel) !== null && u !== void 0 ? u : P.INFO, i);
        if (l && !o.suppressOverrideMessage) {
          var d = (c = new Error().stack) !== null && c !== void 0 ? c : "<failed to generate stacktrace>";
          l.warn("Current logger will be overwritten from " + d), f.warn("Current logger will overwrite one already registered from " + d);
        }
        return we("diag", f, r, !0);
      };
      r.setLogger = n, r.disable = function() {
        Re(Fc, r);
      }, r.createComponentLogger = function(i) {
        return new $c(i);
      }, r.verbose = t("verbose"), r.debug = t("debug"), r.info = t("info"), r.warn = t("warn"), r.error = t("error");
    }
    return e.instance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e;
  }()
), Xc = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, zc = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, qc = (
  /** @class */
  function() {
    function e(t) {
      this._entries = t ? new Map(t) : /* @__PURE__ */ new Map();
    }
    return e.prototype.getEntry = function(t) {
      var r = this._entries.get(t);
      if (r)
        return Object.assign({}, r);
    }, e.prototype.getAllEntries = function() {
      return Array.from(this._entries.entries()).map(function(t) {
        var r = Xc(t, 2), n = r[0], i = r[1];
        return [n, i];
      });
    }, e.prototype.setEntry = function(t, r) {
      var n = new e(this._entries);
      return n._entries.set(t, r), n;
    }, e.prototype.removeEntry = function(t) {
      var r = new e(this._entries);
      return r._entries.delete(t), r;
    }, e.prototype.removeEntries = function() {
      for (var t, r, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = new e(this._entries);
      try {
        for (var a = zc(n), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          o._entries.delete(c);
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          u && !u.done && (r = a.return) && r.call(a);
        } finally {
          if (t) throw t.error;
        }
      }
      return o;
    }, e.prototype.clear = function() {
      return new e();
    }, e;
  }()
), Kc = Symbol("BaggageEntryMetadata"), Wc = Z.instance();
function Yc(e) {
  return e === void 0 && (e = {}), new qc(new Map(Object.entries(e)));
}
function La(e) {
  return typeof e != "string" && (Wc.error("Cannot create baggage metadata from unknown type: " + typeof e), e = ""), {
    __TYPE__: Kc,
    toString: function() {
      return e;
    }
  };
}
function vr(e) {
  return Symbol.for(e);
}
var Jc = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var r = this;
      r._currentContext = t ? new Map(t) : /* @__PURE__ */ new Map(), r.getValue = function(n) {
        return r._currentContext.get(n);
      }, r.setValue = function(n, i) {
        var o = new e(r._currentContext);
        return o._currentContext.set(n, i), o;
      }, r.deleteValue = function(n) {
        var i = new e(r._currentContext);
        return i._currentContext.delete(n), i;
      };
    }
    return e;
  }()
), yt = new Jc(), Lt = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Zc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.createGauge = function(t, r) {
      return sl;
    }, e.prototype.createHistogram = function(t, r) {
      return ul;
    }, e.prototype.createCounter = function(t, r) {
      return al;
    }, e.prototype.createUpDownCounter = function(t, r) {
      return cl;
    }, e.prototype.createObservableGauge = function(t, r) {
      return fl;
    }, e.prototype.createObservableCounter = function(t, r) {
      return ll;
    }, e.prototype.createObservableUpDownCounter = function(t, r) {
      return dl;
    }, e.prototype.addBatchObservableCallback = function(t, r) {
    }, e.prototype.removeBatchObservableCallback = function(t) {
    }, e;
  }()
), gr = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
    }
    return e;
  }()
), Qc = (
  /** @class */
  function(e) {
    Lt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(gr)
), tl = (
  /** @class */
  function(e) {
    Lt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(gr)
), el = (
  /** @class */
  function(e) {
    Lt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(gr)
), rl = (
  /** @class */
  function(e) {
    Lt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(gr)
), ii = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.addCallback = function(t) {
    }, e.prototype.removeCallback = function(t) {
    }, e;
  }()
), nl = (
  /** @class */
  function(e) {
    Lt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(ii)
), il = (
  /** @class */
  function(e) {
    Lt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(ii)
), ol = (
  /** @class */
  function(e) {
    Lt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(ii)
), Pa = new Zc(), al = new Qc(), sl = new el(), ul = new rl(), cl = new tl(), ll = new nl(), fl = new il(), dl = new ol();
function pl() {
  return Pa;
}
var _t;
(function(e) {
  e[e.INT = 0] = "INT", e[e.DOUBLE = 1] = "DOUBLE";
})(_t || (_t = {}));
var hl = {
  get: function(e, t) {
    if (e != null)
      return e[t];
  },
  keys: function(e) {
    return e == null ? [] : Object.keys(e);
  }
}, _l = {
  set: function(e, t, r) {
    e != null && (e[t] = r);
  }
}, vl = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, gl = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, yl = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.active = function() {
      return yt;
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      return r.call.apply(r, gl([n], vl(i), !1));
    }, e.prototype.bind = function(t, r) {
      return r;
    }, e.prototype.enable = function() {
      return this;
    }, e.prototype.disable = function() {
      return this;
    }, e;
  }()
), El = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ml = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Ur = "context", Tl = new yl(), yr = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalContextManager = function(t) {
      return we(Ur, t, Z.instance());
    }, e.prototype.active = function() {
      return this._getContextManager().active();
    }, e.prototype.with = function(t, r, n) {
      for (var i, o = [], a = 3; a < arguments.length; a++)
        o[a - 3] = arguments[a];
      return (i = this._getContextManager()).with.apply(i, ml([t, r, n], El(o), !1));
    }, e.prototype.bind = function(t, r) {
      return this._getContextManager().bind(t, r);
    }, e.prototype._getContextManager = function() {
      return At(Ur) || Tl;
    }, e.prototype.disable = function() {
      this._getContextManager().disable(), Re(Ur, Z.instance());
    }, e;
  }()
), Q;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SAMPLED = 1] = "SAMPLED";
})(Q || (Q = {}));
var Na = "0000000000000000", Ia = "00000000000000000000000000000000", Ca = {
  traceId: Ia,
  spanId: Na,
  traceFlags: Q.NONE
}, fe = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = Ca), this._spanContext = t;
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return this;
    }, e.prototype.setAttributes = function(t) {
      return this;
    }, e.prototype.addEvent = function(t, r) {
      return this;
    }, e.prototype.addLink = function(t) {
      return this;
    }, e.prototype.addLinks = function(t) {
      return this;
    }, e.prototype.setStatus = function(t) {
      return this;
    }, e.prototype.updateName = function(t) {
      return this;
    }, e.prototype.end = function(t) {
    }, e.prototype.isRecording = function() {
      return !1;
    }, e.prototype.recordException = function(t, r) {
    }, e;
  }()
), oi = vr("OpenTelemetry Context Key SPAN");
function ai(e) {
  return e.getValue(oi) || void 0;
}
function Sl() {
  return ai(yr.getInstance().active());
}
function si(e, t) {
  return e.setValue(oi, t);
}
function Ol(e) {
  return e.deleteValue(oi);
}
function bl(e, t) {
  return si(e, new fe(t));
}
function Ma(e) {
  var t;
  return (t = ai(e)) === null || t === void 0 ? void 0 : t.spanContext();
}
var Al = /^([0-9a-f]{32})$/i, wl = /^[0-9a-f]{16}$/i;
function xa(e) {
  return Al.test(e) && e !== Ia;
}
function Rl(e) {
  return wl.test(e) && e !== Na;
}
function Le(e) {
  return xa(e.traceId) && Rl(e.spanId);
}
function Ll(e) {
  return new fe(e);
}
var Br = yr.getInstance(), Da = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.startSpan = function(t, r, n) {
      n === void 0 && (n = Br.active());
      var i = !!(r != null && r.root);
      if (i)
        return new fe();
      var o = n && Ma(n);
      return Pl(o) && Le(o) ? new fe(o) : new fe();
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = r : arguments.length === 3 ? (o = r, u = n) : (o = r, a = n, u = i);
        var c = a != null ? a : Br.active(), s = this.startSpan(t, o, c), l = si(c, s);
        return Br.with(l, u, void 0, s);
      }
    }, e;
  }()
);
function Pl(e) {
  return typeof e == "object" && typeof e.spanId == "string" && typeof e.traceId == "string" && typeof e.traceFlags == "number";
}
var Nl = new Da(), Il = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.startSpan = function(t, r, n) {
      return this._getTracer().startSpan(t, r, n);
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o = this._getTracer();
      return Reflect.apply(o.startActiveSpan, o, arguments);
    }, e.prototype._getTracer = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateTracer(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : Nl;
    }, e;
  }()
), Cl = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      return new Da();
    }, e;
  }()
), Ml = new Cl(), Gi = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i;
      return (i = this.getDelegateTracer(t, r, n)) !== null && i !== void 0 ? i : new Il(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : Ml;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateTracer = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getTracer(t, r, n);
    }, e;
  }()
), rr;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(rr || (rr = {}));
var ye;
(function(e) {
  e[e.INTERNAL = 0] = "INTERNAL", e[e.SERVER = 1] = "SERVER", e[e.CLIENT = 2] = "CLIENT", e[e.PRODUCER = 3] = "PRODUCER", e[e.CONSUMER = 4] = "CONSUMER";
})(ye || (ye = {}));
var nr;
(function(e) {
  e[e.UNSET = 0] = "UNSET", e[e.OK = 1] = "OK", e[e.ERROR = 2] = "ERROR";
})(nr || (nr = {}));
var b = yr.getInstance(), v = Z.instance(), xl = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getMeter = function(t, r, n) {
      return Pa;
    }, e;
  }()
), Dl = new xl(), kr = "metrics", Ul = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalMeterProvider = function(t) {
      return we(kr, t, Z.instance());
    }, e.prototype.getMeterProvider = function() {
      return At(kr) || Dl;
    }, e.prototype.getMeter = function(t, r, n) {
      return this.getMeterProvider().getMeter(t, r, n);
    }, e.prototype.disable = function() {
      Re(kr, Z.instance());
    }, e;
  }()
), qt = Ul.getInstance(), Bl = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r) {
    }, e.prototype.extract = function(t, r) {
      return t;
    }, e.prototype.fields = function() {
      return [];
    }, e;
  }()
), ui = vr("OpenTelemetry Baggage Key");
function Ua(e) {
  return e.getValue(ui) || void 0;
}
function kl() {
  return Ua(yr.getInstance().active());
}
function Gl(e, t) {
  return e.setValue(ui, t);
}
function $l(e) {
  return e.deleteValue(ui);
}
var Gr = "propagation", Hl = new Bl(), jl = (
  /** @class */
  function() {
    function e() {
      this.createBaggage = Yc, this.getBaggage = Ua, this.getActiveBaggage = kl, this.setBaggage = Gl, this.deleteBaggage = $l;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalPropagator = function(t) {
      return we(Gr, t, Z.instance());
    }, e.prototype.inject = function(t, r, n) {
      return n === void 0 && (n = _l), this._getGlobalPropagator().inject(t, r, n);
    }, e.prototype.extract = function(t, r, n) {
      return n === void 0 && (n = hl), this._getGlobalPropagator().extract(t, r, n);
    }, e.prototype.fields = function() {
      return this._getGlobalPropagator().fields();
    }, e.prototype.disable = function() {
      Re(Gr, Z.instance());
    }, e.prototype._getGlobalPropagator = function() {
      return At(Gr) || Hl;
    }, e;
  }()
), G = jl.getInstance(), $r = "trace", Vl = (
  /** @class */
  function() {
    function e() {
      this._proxyTracerProvider = new Gi(), this.wrapSpanContext = Ll, this.isSpanContextValid = Le, this.deleteSpan = Ol, this.getSpan = ai, this.getActiveSpan = Sl, this.getSpanContext = Ma, this.setSpan = si, this.setSpanContext = bl;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalTracerProvider = function(t) {
      var r = we($r, this._proxyTracerProvider, Z.instance());
      return r && this._proxyTracerProvider.setDelegate(t), r;
    }, e.prototype.getTracerProvider = function() {
      return At($r) || this._proxyTracerProvider;
    }, e.prototype.getTracer = function(t, r) {
      return this.getTracerProvider().getTracer(t, r);
    }, e.prototype.disable = function() {
      Re($r, Z.instance()), this._proxyTracerProvider = new Gi();
    }, e;
  }()
), R = Vl.getInstance(), Ba = vr("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function Fl(e) {
  return e.setValue(Ba, !0);
}
function ka(e) {
  return e.getValue(Ba) === !0;
}
var Xl = "=", An = ";", wn = ",", Hr = "baggage", zl = 180, ql = 4096, Kl = 8192, Wl = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Yl(e) {
  return e.reduce(function(t, r) {
    var n = "" + t + (t !== "" ? wn : "") + r;
    return n.length > Kl ? t : n;
  }, "");
}
function Jl(e) {
  return e.getAllEntries().map(function(t) {
    var r = Wl(t, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += An + i.metadata.toString()), o;
  });
}
function Zl(e) {
  var t = e.split(An);
  if (!(t.length <= 0)) {
    var r = t.shift();
    if (r) {
      var n = r.indexOf(Xl);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return t.length > 0 && (a = La(t.join(An))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var Ql = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = G.getBaggage(t);
      if (!(!i || ka(t))) {
        var o = Jl(i).filter(function(u) {
          return u.length <= ql;
        }).slice(0, zl), a = Yl(o);
        a.length > 0 && n.set(r, Hr, a);
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, Hr), o = Array.isArray(i) ? i.join(wn) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var u = o.split(wn);
      return u.forEach(function(c) {
        var s = Zl(c);
        if (s) {
          var l = { value: s.value };
          s.metadata && (l.metadata = s.metadata), a[s.key] = l;
        }
      }), Object.entries(a).length === 0 ? t : G.setBaggage(t, G.createBaggage(a));
    }, e.prototype.fields = function() {
      return [Hr];
    }, e;
  }()
);
function tf() {
  return function(e) {
    v.error(ef(e));
  };
}
function ef(e) {
  return typeof e == "string" ? e : JSON.stringify(rf(e));
}
function rf(e) {
  for (var t = {}, r = e; r !== null; )
    Object.getOwnPropertyNames(r).forEach(function(n) {
      if (!t[n]) {
        var i = r[n];
        i && (t[n] = String(i));
      }
    }), r = Object.getPrototypeOf(r);
  return t;
}
var nf = tf();
function $i(e) {
  try {
    nf(e);
  } catch (t) {
  }
}
var Rn;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(Rn || (Rn = {}));
var of = ",", af = ["OTEL_SDK_DISABLED"];
function sf(e) {
  return af.indexOf(e) > -1;
}
var uf = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function cf(e) {
  return uf.indexOf(e) > -1;
}
var lf = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function ff(e) {
  return lf.indexOf(e) > -1;
}
var jr = 1 / 0, Vr = 128, df = 128, pf = 128, Ga = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: P.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: jr,
  OTEL_ATTRIBUTE_COUNT_LIMIT: Vr,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: jr,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: Vr,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: jr,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: Vr,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: df,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: pf,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: Rn.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function hf(e, t, r) {
  if (typeof r[e] != "undefined") {
    var n = String(r[e]);
    t[e] = n.toLowerCase() === "true";
  }
}
function _f(e, t, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[e] != "undefined") {
    var o = Number(r[e]);
    isNaN(o) || (o < n ? t[e] = n : o > i ? t[e] = i : t[e] = o);
  }
}
function vf(e, t, r, n) {
  n === void 0 && (n = of);
  var i = r[e];
  typeof i == "string" && (t[e] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var gf = {
  ALL: P.ALL,
  VERBOSE: P.VERBOSE,
  DEBUG: P.DEBUG,
  INFO: P.INFO,
  WARN: P.WARN,
  ERROR: P.ERROR,
  NONE: P.NONE
};
function yf(e, t, r) {
  var n = r[e];
  if (typeof n == "string") {
    var i = gf[n.toUpperCase()];
    i != null && (t[e] = i);
  }
}
function Ef(e) {
  var t = {};
  for (var r in Ga) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        yf(n, t, e);
        break;
      default:
        if (sf(n))
          hf(n, t, e);
        else if (cf(n))
          _f(n, t, e);
        else if (ff(n))
          vf(n, t, e);
        else {
          var i = e[n];
          typeof i != "undefined" && i !== null && (t[n] = String(i));
        }
    }
  }
  return t;
}
var mf = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function Tf() {
  var e = Ef(mf);
  return Object.assign({}, Ga, e);
}
function Hi(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 97 && e <= 102 ? e - 87 : e - 55;
}
function ci(e) {
  for (var t = new Uint8Array(e.length / 2), r = 0, n = 0; n < e.length; n += 2) {
    var i = Hi(e.charCodeAt(n)), o = Hi(e.charCodeAt(n + 1));
    t[r++] = i << 4 | o;
  }
  return t;
}
var Ln = performance, Sf = "1.30.1", Of = "process.runtime.name", bf = "telemetry.sdk.name", Af = "telemetry.sdk.language", wf = "telemetry.sdk.version", Rf = Of, Lf = bf, Pf = Af, Nf = wf, If = "webjs", Cf = If, Dt, Fr = (Dt = {}, Dt[Lf] = "opentelemetry", Dt[Rf] = "browser", Dt[Pf] = Cf, Dt[Nf] = Sf, Dt), Mf = 9, xf = 6, Df = Math.pow(10, xf), Pn = Math.pow(10, Mf);
function Ee(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * Df);
  return [r, n];
}
function Uf() {
  var e = Ln.timeOrigin;
  if (typeof e != "number") {
    var t = Ln;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function Bf(e) {
  var t = Ee(Uf()), r = Ee(Ln.now());
  return Gf(t, r);
}
function kf(e) {
  return e[0] * Pn + e[1];
}
function xe(e) {
  return e[0] * 1e6 + e[1] / 1e3;
}
function Gf(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= Pn && (r[1] -= Pn, r[0] += 1), r;
}
var N;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(N || (N = {}));
var $f = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Hf = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r;
      this._propagators = (r = t.propagators) !== null && r !== void 0 ? r : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return e.prototype.inject = function(t, r, n) {
      var i, o;
      try {
        for (var a = $f(this._propagators), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          try {
            c.inject(t, r, n);
          } catch (s) {
            v.warn("Failed to inject with " + c.constructor.name + ". Err: " + s.message);
          }
        }
      } catch (s) {
        i = { error: s };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, e.prototype.extract = function(t, r, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, r, n);
        } catch (a) {
          v.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, e.prototype.fields = function() {
      return this._fields.slice();
    }, e;
  }()
), Nn = "[_0-9a-z-*/]", jf = "[a-z]" + Nn + "{0,255}", Vf = "[a-z0-9]" + Nn + "{0,240}@[a-z]" + Nn + "{0,13}", Ff = new RegExp("^(?:" + jf + "|" + Vf + ")$"), Xf = /^[ -~]{0,255}[!-~]$/, zf = /,|=/;
function qf(e) {
  return Ff.test(e);
}
function Kf(e) {
  return Xf.test(e) && !zf.test(e);
}
var ji = 32, Wf = 512, Vi = ",", Fi = "=", Yf = (
  /** @class */
  function() {
    function e(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return e.prototype.set = function(t, r) {
      var n = this._clone();
      return n._internalState.has(t) && n._internalState.delete(t), n._internalState.set(t, r), n;
    }, e.prototype.unset = function(t) {
      var r = this._clone();
      return r._internalState.delete(t), r;
    }, e.prototype.get = function(t) {
      return this._internalState.get(t);
    }, e.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + Fi + t.get(n)), r;
      }, []).join(Vi);
    }, e.prototype._parse = function(t) {
      t.length > Wf || (this._internalState = t.split(Vi).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(Fi);
        if (o !== -1) {
          var a = i.slice(0, o), u = i.slice(o + 1, n.length);
          qf(a) && Kf(u) && r.set(a, u);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > ji && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, ji))));
    }, e.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
      var t = new e();
      return t._internalState = new Map(this._internalState), t;
    }, e;
  }()
), Xr = "traceparent", zr = "tracestate", Jf = "00", Zf = "(?!ff)[\\da-f]{2}", Qf = "(?![0]{32})[\\da-f]{32}", td = "(?![0]{16})[\\da-f]{16}", ed = "[\\da-f]{2}", rd = new RegExp("^\\s?(" + Zf + ")-(" + Qf + ")-(" + td + ")-(" + ed + ")(-.*)?\\s?$");
function nd(e) {
  var t = rd.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var id = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = R.getSpanContext(t);
      if (!(!i || ka(t) || !Le(i))) {
        var o = Jf + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || Q.NONE).toString(16);
        n.set(r, Xr, o), i.traceState && n.set(r, zr, i.traceState.serialize());
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, Xr);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = nd(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var u = n.get(r, zr);
      if (u) {
        var c = Array.isArray(u) ? u.join(",") : u;
        a.traceState = new Yf(typeof c == "string" ? c : void 0);
      }
      return R.setSpanContext(t, a);
    }, e.prototype.fields = function() {
      return [Xr, zr];
    }, e;
  }()
), od = "[object Object]", ad = "[object Null]", sd = "[object Undefined]", ud = Function.prototype, $a = ud.toString, cd = $a.call(Object), ld = fd(Object.getPrototypeOf, Object), Ha = Object.prototype, ja = Ha.hasOwnProperty, Et = Symbol ? Symbol.toStringTag : void 0, Va = Ha.toString;
function fd(e, t) {
  return function(r) {
    return e(t(r));
  };
}
function Xi(e) {
  if (!dd(e) || pd(e) !== od)
    return !1;
  var t = ld(e);
  if (t === null)
    return !0;
  var r = ja.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && $a.call(r) === cd;
}
function dd(e) {
  return e != null && typeof e == "object";
}
function pd(e) {
  return e == null ? e === void 0 ? sd : ad : Et && Et in Object(e) ? hd(e) : _d(e);
}
function hd(e) {
  var t = ja.call(e, Et), r = e[Et], n = !1;
  try {
    e[Et] = void 0, n = !0;
  } catch (o) {
  }
  var i = Va.call(e);
  return n && (t ? e[Et] = r : delete e[Et]), i;
}
function _d(e) {
  return Va.call(e);
}
var vd = 20;
function gd() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e.shift(), n = /* @__PURE__ */ new WeakMap(); e.length > 0; )
    r = Fa(r, e.shift(), 0, n);
  return r;
}
function qr(e) {
  return ir(e) ? e.slice() : e;
}
function Fa(e, t, r, n) {
  r === void 0 && (r = 0);
  var i;
  if (!(r > vd)) {
    if (r++, Ye(e) || Ye(t) || Xa(t))
      i = qr(t);
    else if (ir(e)) {
      if (i = e.slice(), ir(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(qr(t[o]));
      else if (re(t))
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o];
          i[c] = qr(t[c]);
        }
    } else if (re(e))
      if (re(t)) {
        if (!yd(e, t))
          return t;
        i = Object.assign({}, e);
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o], s = t[c];
          if (Ye(s))
            typeof s == "undefined" ? delete i[c] : i[c] = s;
          else {
            var l = i[c], f = s;
            if (zi(e, c, n) || zi(t, c, n))
              delete i[c];
            else {
              if (re(l) && re(f)) {
                var d = n.get(l) || [], p = n.get(f) || [];
                d.push({ obj: e, key: c }), p.push({ obj: t, key: c }), n.set(l, d), n.set(f, p);
              }
              i[c] = Fa(i[c], s, r, n);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function zi(e, t, r) {
  for (var n = r.get(e[t]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === t && a.obj === e)
      return !0;
  }
  return !1;
}
function ir(e) {
  return Array.isArray(e);
}
function Xa(e) {
  return typeof e == "function";
}
function re(e) {
  return !Ye(e) && !ir(e) && !Xa(e) && typeof e == "object";
}
function Ye(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "undefined" || e instanceof Date || e instanceof RegExp || e === null;
}
function yd(e, t) {
  return !(!Xi(e) || !Xi(t));
}
function Ed(e, t) {
  return new Promise(function(r) {
    b.with(Fl(b.active()), function() {
      e.export(t, function(n) {
        r(n);
      });
    });
  });
}
var md = {
  _export: Ed
}, za = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), Td = new za(), Sd = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      return new za();
    }, e;
  }()
), qa = new Sd(), Od = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.emit = function(t) {
      this._getLogger().emit(t);
    }, e.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : Td;
    }, e;
  }()
), qi = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      var i;
      return (i = this.getDelegateLogger(t, r, n)) !== null && i !== void 0 ? i : new Od(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : qa;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateLogger = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, r, n);
    }, e;
  }()
), bd = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, De = Symbol.for("io.opentelemetry.js.api.logs"), ne = bd;
function Ad(e, t, r) {
  return function(n) {
    return n === e ? t : r;
  };
}
var Ki = 1, wd = (
  /** @class */
  function() {
    function e() {
      this._proxyLoggerProvider = new qi();
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return ne[De] ? this.getLoggerProvider() : (ne[De] = Ad(Ki, t, qa), this._proxyLoggerProvider.setDelegate(t), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, r;
      return (r = (t = ne[De]) === null || t === void 0 ? void 0 : t.call(ne, Ki)) !== null && r !== void 0 ? r : this._proxyLoggerProvider;
    }, e.prototype.getLogger = function(t, r, n) {
      return this.getLoggerProvider().getLogger(t, r, n);
    }, e.prototype.disable = function() {
      delete ne[De], this._proxyLoggerProvider = new qi();
    }, e;
  }()
), Ka = wd.getInstance();
function Rd(e, t, r, n) {
  for (var i = 0, o = e.length; i < o; i++) {
    var a = e[i];
    t && a.setTracerProvider(t), r && a.setMeterProvider(r), n && a.setLoggerProvider && a.setLoggerProvider(n), a.getConfig().enabled || a.enable();
  }
}
function Ld(e) {
  e.forEach(function(t) {
    return t.disable();
  });
}
function Pd(e) {
  var t, r, n = e.tracerProvider || R.getTracerProvider(), i = e.meterProvider || qt.getMeterProvider(), o = e.loggerProvider || Ka.getLoggerProvider(), a = (r = (t = e.instrumentations) === null || t === void 0 ? void 0 : t.flat()) !== null && r !== void 0 ? r : [];
  return Rd(a, n, i, o), function() {
    Ld(a);
  };
}
function In(e) {
  return typeof e == "function";
}
var $ = console.error.bind(console);
function ie(e, t, r) {
  var n = !!e[t] && e.propertyIsEnumerable(t);
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: n,
    writable: !0,
    value: r
  });
}
function Pe(e) {
  e && e.logger && (In(e.logger) ? $ = e.logger : $("new logger isn't a function, not replacing"));
}
function Wa(e, t, r) {
  if (!e || !e[t]) {
    $("no original function " + t + " to wrap");
    return;
  }
  if (!r) {
    $("no wrapper function"), $(new Error().stack);
    return;
  }
  if (!In(e[t]) || !In(r)) {
    $("original object and wrapper must be functions");
    return;
  }
  var n = e[t], i = r(n, t);
  return ie(i, "__original", n), ie(i, "__unwrap", function() {
    e[t] === i && ie(e, t, n);
  }), ie(i, "__wrapped", !0), ie(e, t, i), i;
}
function Nd(e, t, r) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    $("must provide one or more modules to patch"), $(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    $("must provide one or more functions to wrap on modules");
    return;
  }
  e.forEach(function(n) {
    t.forEach(function(i) {
      Wa(n, i, r);
    });
  });
}
function Ya(e, t) {
  if (!e || !e[t]) {
    $("no function to unwrap."), $(new Error().stack);
    return;
  }
  if (!e[t].__unwrap)
    $("no original to unwrap to -- has " + t + " already been unwrapped?");
  else
    return e[t].__unwrap();
}
function Id(e, t) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    $("must provide one or more modules to patch"), $(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    $("must provide one or more functions to unwrap on modules");
    return;
  }
  e.forEach(function(r) {
    t.forEach(function(n) {
      Ya(r, n);
    });
  });
}
Pe.wrap = Wa;
Pe.massWrap = Nd;
Pe.unwrap = Ya;
Pe.massUnwrap = Id;
var U = Pe, Cn = function() {
  return Cn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Cn.apply(this, arguments);
}, Cd = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = U.wrap, this._unwrap = U.unwrap, this._massWrap = U.massWrap, this._massUnwrap = U.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = R.getTracer(t, r), this._meter = qt.getMeter(t, r), this._logger = Ka.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = Cn({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), Md = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ja = (
  /** @class */
  function(e) {
    Md(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(Cd)
);
function k(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var or = performance, xd = "traceparent", Za = vr("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function Dd(e) {
  return e.setValue(Za, !0);
}
function li(e) {
  return e.getValue(Za) === !0;
}
var Ud = "=", Mn = ";", xn = ",", Kr = "baggage", Bd = 180, kd = 4096, Gd = 8192, $d = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Hd(e) {
  return e.reduce(function(t, r) {
    var n = "" + t + (t !== "" ? xn : "") + r;
    return n.length > Gd ? t : n;
  }, "");
}
function jd(e) {
  return e.getAllEntries().map(function(t) {
    var r = $d(t, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += Mn + i.metadata.toString()), o;
  });
}
function Vd(e) {
  var t = e.split(Mn);
  if (!(t.length <= 0)) {
    var r = t.shift();
    if (r) {
      var n = r.indexOf(Ud);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return t.length > 0 && (a = La(t.join(Mn))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var Fd = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = G.getBaggage(t);
      if (!(!i || li(t))) {
        var o = jd(i).filter(function(u) {
          return u.length <= kd;
        }).slice(0, Bd), a = Hd(o);
        a.length > 0 && n.set(r, Kr, a);
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, Kr), o = Array.isArray(i) ? i.join(xn) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var u = o.split(xn);
      return u.forEach(function(c) {
        var s = Vd(c);
        if (s) {
          var l = { value: s.value };
          s.metadata && (l.metadata = s.metadata), a[s.key] = l;
        }
      }), Object.entries(a).length === 0 ? t : G.setBaggage(t, G.createBaggage(a));
    }, e.prototype.fields = function() {
      return [Kr];
    }, e;
  }()
), Qa = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Xd = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Je(e) {
  var t, r, n = {};
  if (typeof e != "object" || e == null)
    return n;
  try {
    for (var i = Qa(Object.entries(e)), o = i.next(); !o.done; o = i.next()) {
      var a = Xd(o.value, 2), u = a[0], c = a[1];
      if (!zd(u)) {
        v.warn("Invalid attribute key: " + u);
        continue;
      }
      if (!ts(c)) {
        v.warn("Invalid attribute value set for key: " + u);
        continue;
      }
      Array.isArray(c) ? n[u] = c.slice() : n[u] = c;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function zd(e) {
  return typeof e == "string" && e.length > 0;
}
function ts(e) {
  return e == null ? !0 : Array.isArray(e) ? qd(e) : es(e);
}
function qd(e) {
  var t, r, n;
  try {
    for (var i = Qa(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (a != null) {
        if (!n) {
          if (es(a)) {
            n = typeof a;
            continue;
          }
          return !1;
        }
        if (typeof a !== n)
          return !1;
      }
    }
  } catch (u) {
    t = { error: u };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return !0;
}
function es(e) {
  switch (typeof e) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function Kd() {
  return function(e) {
    v.error(Wd(e));
  };
}
function Wd(e) {
  return typeof e == "string" ? e : JSON.stringify(Yd(e));
}
function Yd(e) {
  for (var t = {}, r = e; r !== null; )
    Object.getOwnPropertyNames(r).forEach(function(n) {
      if (!t[n]) {
        var i = r[n];
        i && (t[n] = String(i));
      }
    }), r = Object.getPrototypeOf(r);
  return t;
}
var Jd = Kd();
function Ft(e) {
  try {
    Jd(e);
  } catch (t) {
  }
}
var W;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(W || (W = {}));
var Zd = ",", Qd = ["OTEL_SDK_DISABLED"];
function tp(e) {
  return Qd.indexOf(e) > -1;
}
var ep = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function rp(e) {
  return ep.indexOf(e) > -1;
}
var np = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function ip(e) {
  return np.indexOf(e) > -1;
}
var Ze = 1 / 0, Qe = 128, op = 128, ap = 128, rs = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: P.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: Ze,
  OTEL_ATTRIBUTE_COUNT_LIMIT: Qe,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: Ze,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: Qe,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: Ze,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: Qe,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: op,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: ap,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: W.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function sp(e, t, r) {
  if (typeof r[e] != "undefined") {
    var n = String(r[e]);
    t[e] = n.toLowerCase() === "true";
  }
}
function up(e, t, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[e] != "undefined") {
    var o = Number(r[e]);
    isNaN(o) || (o < n ? t[e] = n : o > i ? t[e] = i : t[e] = o);
  }
}
function cp(e, t, r, n) {
  n === void 0 && (n = Zd);
  var i = r[e];
  typeof i == "string" && (t[e] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var lp = {
  ALL: P.ALL,
  VERBOSE: P.VERBOSE,
  DEBUG: P.DEBUG,
  INFO: P.INFO,
  WARN: P.WARN,
  ERROR: P.ERROR,
  NONE: P.NONE
};
function fp(e, t, r) {
  var n = r[e];
  if (typeof n == "string") {
    var i = lp[n.toUpperCase()];
    i != null && (t[e] = i);
  }
}
function ns(e) {
  var t = {};
  for (var r in rs) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        fp(n, t, e);
        break;
      default:
        if (tp(n))
          sp(n, t, e);
        else if (rp(n))
          up(n, t, e);
        else if (ip(n))
          cp(n, t, e);
        else {
          var i = e[n];
          typeof i != "undefined" && i !== null && (t[n] = String(i));
        }
    }
  }
  return t;
}
var is = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function me() {
  var e = ns(is);
  return Object.assign({}, rs, e);
}
function dp() {
  return ns(is);
}
var Ht = performance, pp = "1.30.1", hp = "exception.type", _p = "exception.message", vp = "exception.stacktrace", gp = "http.response_content_length", yp = "http.response_content_length_uncompressed", Wr = hp, Yr = _p, Ep = vp, mp = gp, Tp = yp, Sp = "process.runtime.name", Op = "service.name", bp = "telemetry.sdk.name", Ap = "telemetry.sdk.language", wp = "telemetry.sdk.version", Rp = Sp, Lp = Op, Dn = bp, Un = Ap, Bn = wp, Pp = "webjs", Np = Pp, Ut, Jr = (Ut = {}, Ut[Dn] = "opentelemetry", Ut[Rp] = "browser", Ut[Un] = Np, Ut[Bn] = pp, Ut), Ip = 9, Cp = 6, Mp = Math.pow(10, Cp), ar = Math.pow(10, Ip);
function dt(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * Mp);
  return [r, n];
}
function fi() {
  var e = Ht.timeOrigin;
  if (typeof e != "number") {
    var t = Ht;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function os(e) {
  var t = dt(fi()), r = dt(typeof e == "number" ? e : Ht.now());
  return as(t, r);
}
function de(e) {
  if (di(e))
    return e;
  if (typeof e == "number")
    return e < fi() ? os(e) : dt(e);
  if (e instanceof Date)
    return dt(e.getTime());
  throw TypeError("Invalid input type");
}
function xp(e, t) {
  var r = t[0] - e[0], n = t[1] - e[1];
  return n < 0 && (r -= 1, n += ar), [r, n];
}
function pt(e) {
  return e[0] * ar + e[1];
}
function di(e) {
  return Array.isArray(e) && e.length === 2 && typeof e[0] == "number" && typeof e[1] == "number";
}
function Wi(e) {
  return di(e) || typeof e == "number" || e instanceof Date;
}
function as(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= ar && (r[1] -= ar, r[0] += 1), r;
}
var kn;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(kn || (kn = {}));
var Dp = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Up = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r;
      this._propagators = (r = t.propagators) !== null && r !== void 0 ? r : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return e.prototype.inject = function(t, r, n) {
      var i, o;
      try {
        for (var a = Dp(this._propagators), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          try {
            c.inject(t, r, n);
          } catch (s) {
            v.warn("Failed to inject with " + c.constructor.name + ". Err: " + s.message);
          }
        }
      } catch (s) {
        i = { error: s };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, e.prototype.extract = function(t, r, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, r, n);
        } catch (a) {
          v.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, e.prototype.fields = function() {
      return this._fields.slice();
    }, e;
  }()
), Gn = "[_0-9a-z-*/]", Bp = "[a-z]" + Gn + "{0,255}", kp = "[a-z0-9]" + Gn + "{0,240}@[a-z]" + Gn + "{0,13}", Gp = new RegExp("^(?:" + Bp + "|" + kp + ")$"), $p = /^[ -~]{0,255}[!-~]$/, Hp = /,|=/;
function jp(e) {
  return Gp.test(e);
}
function Vp(e) {
  return $p.test(e) && !Hp.test(e);
}
var Yi = 32, Fp = 512, Ji = ",", Zi = "=", Xp = (
  /** @class */
  function() {
    function e(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return e.prototype.set = function(t, r) {
      var n = this._clone();
      return n._internalState.has(t) && n._internalState.delete(t), n._internalState.set(t, r), n;
    }, e.prototype.unset = function(t) {
      var r = this._clone();
      return r._internalState.delete(t), r;
    }, e.prototype.get = function(t) {
      return this._internalState.get(t);
    }, e.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + Zi + t.get(n)), r;
      }, []).join(Ji);
    }, e.prototype._parse = function(t) {
      t.length > Fp || (this._internalState = t.split(Ji).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(Zi);
        if (o !== -1) {
          var a = i.slice(0, o), u = i.slice(o + 1, n.length);
          jp(a) && Vp(u) && r.set(a, u);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > Yi && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, Yi))));
    }, e.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
      var t = new e();
      return t._internalState = new Map(this._internalState), t;
    }, e;
  }()
), Zr = "traceparent", Qr = "tracestate", zp = "00", qp = "(?!ff)[\\da-f]{2}", Kp = "(?![0]{32})[\\da-f]{32}", Wp = "(?![0]{16})[\\da-f]{16}", Yp = "[\\da-f]{2}", Jp = new RegExp("^\\s?(" + qp + ")-(" + Kp + ")-(" + Wp + ")-(" + Yp + ")(-.*)?\\s?$");
function Zp(e) {
  var t = Jp.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var Qp = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = R.getSpanContext(t);
      if (!(!i || li(t) || !Le(i))) {
        var o = zp + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || Q.NONE).toString(16);
        n.set(r, Zr, o), i.traceState && n.set(r, Qr, i.traceState.serialize());
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, Zr);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = Zp(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var u = n.get(r, Qr);
      if (u) {
        var c = Array.isArray(u) ? u.join(",") : u;
        a.traceState = new Xp(typeof c == "string" ? c : void 0);
      }
      return R.setSpanContext(t, a);
    }, e.prototype.fields = function() {
      return [Zr, Qr];
    }, e;
  }()
), th = "[object Object]", eh = "[object Null]", rh = "[object Undefined]", nh = Function.prototype, ss = nh.toString, ih = ss.call(Object), oh = ah(Object.getPrototypeOf, Object), us = Object.prototype, cs = us.hasOwnProperty, mt = Symbol ? Symbol.toStringTag : void 0, ls = us.toString;
function ah(e, t) {
  return function(r) {
    return e(t(r));
  };
}
function Qi(e) {
  if (!sh(e) || uh(e) !== th)
    return !1;
  var t = oh(e);
  if (t === null)
    return !0;
  var r = cs.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && ss.call(r) === ih;
}
function sh(e) {
  return e != null && typeof e == "object";
}
function uh(e) {
  return e == null ? e === void 0 ? rh : eh : mt && mt in Object(e) ? ch(e) : lh(e);
}
function ch(e) {
  var t = cs.call(e, mt), r = e[mt], n = !1;
  try {
    e[mt] = void 0, n = !0;
  } catch (o) {
  }
  var i = ls.call(e);
  return n && (t ? e[mt] = r : delete e[mt]), i;
}
function lh(e) {
  return ls.call(e);
}
var fh = 20;
function dh() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e.shift(), n = /* @__PURE__ */ new WeakMap(); e.length > 0; )
    r = fs(r, e.shift(), 0, n);
  return r;
}
function tn(e) {
  return sr(e) ? e.slice() : e;
}
function fs(e, t, r, n) {
  r === void 0 && (r = 0);
  var i;
  if (!(r > fh)) {
    if (r++, tr(e) || tr(t) || ds(t))
      i = tn(t);
    else if (sr(e)) {
      if (i = e.slice(), sr(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(tn(t[o]));
      else if (oe(t))
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o];
          i[c] = tn(t[c]);
        }
    } else if (oe(e))
      if (oe(t)) {
        if (!ph(e, t))
          return t;
        i = Object.assign({}, e);
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o], s = t[c];
          if (tr(s))
            typeof s == "undefined" ? delete i[c] : i[c] = s;
          else {
            var l = i[c], f = s;
            if (to(e, c, n) || to(t, c, n))
              delete i[c];
            else {
              if (oe(l) && oe(f)) {
                var d = n.get(l) || [], p = n.get(f) || [];
                d.push({ obj: e, key: c }), p.push({ obj: t, key: c }), n.set(l, d), n.set(f, p);
              }
              i[c] = fs(i[c], s, r, n);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function to(e, t, r) {
  for (var n = r.get(e[t]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === t && a.obj === e)
      return !0;
  }
  return !1;
}
function sr(e) {
  return Array.isArray(e);
}
function ds(e) {
  return typeof e == "function";
}
function oe(e) {
  return !tr(e) && !sr(e) && !ds(e) && typeof e == "object";
}
function tr(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "undefined" || e instanceof Date || e instanceof RegExp || e === null;
}
function ph(e, t) {
  return !(!Qi(e) || !Qi(t));
}
function hh(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
var _h = (
  /** @class */
  function() {
    function e() {
      var t = this;
      this._promise = new Promise(function(r, n) {
        t._resolve = r, t._reject = n;
      });
    }
    return Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolve = function(t) {
      this._resolve(t);
    }, e.prototype.reject = function(t) {
      this._reject(t);
    }, e;
  }()
), vh = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, gh = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, yh = (
  /** @class */
  function() {
    function e(t, r) {
      this._callback = t, this._that = r, this._isCalled = !1, this._deferred = new _h();
    }
    return Object.defineProperty(e.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.call = function() {
      for (var t, r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((t = this._callback).call.apply(t, gh([this._that], vh(n), !1))).then(function(o) {
            return r._deferred.resolve(o);
          }, function(o) {
            return r._deferred.reject(o);
          });
        } catch (o) {
          this._deferred.reject(o);
        }
      }
      return this._deferred.promise;
    }, e;
  }()
), Eh = "exception", $n = function() {
  return $n = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, $n.apply(this, arguments);
}, mh = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, eo = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Th = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Sh = (
  /** @class */
  function() {
    function e(t, r, n, i, o, a, u, c, s, l) {
      u === void 0 && (u = []), this.attributes = {}, this.links = [], this.events = [], this._droppedAttributesCount = 0, this._droppedEventsCount = 0, this._droppedLinksCount = 0, this.status = {
        code: nr.UNSET
      }, this.endTime = [0, 0], this._ended = !1, this._duration = [-1, -1], this.name = n, this._spanContext = i, this.parentSpanId = a, this.kind = o, this.links = u;
      var f = Date.now();
      this._performanceStartTime = Ht.now(), this._performanceOffset = f - (this._performanceStartTime + fi()), this._startTimeProvided = c != null, this.startTime = this._getTime(c != null ? c : f), this.resource = t.resource, this.instrumentationLibrary = t.instrumentationLibrary, this._spanLimits = t.getSpanLimits(), this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, l != null && this.setAttributes(l), this._spanProcessor = t.getActiveSpanProcessor(), this._spanProcessor.onStart(this, r);
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return r == null || this._isSpanEnded() ? this : t.length === 0 ? (v.warn("Invalid attribute key: " + t), this) : ts(r) ? Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, t) ? (this._droppedAttributesCount++, this) : (this.attributes[t] = this._truncateToSize(r), this) : (v.warn("Invalid attribute value set for key: " + t), this);
    }, e.prototype.setAttributes = function(t) {
      var r, n;
      try {
        for (var i = mh(Object.entries(t)), o = i.next(); !o.done; o = i.next()) {
          var a = eo(o.value, 2), u = a[0], c = a[1];
          this.setAttribute(u, c);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
      return this;
    }, e.prototype.addEvent = function(t, r, n) {
      if (this._isSpanEnded())
        return this;
      if (this._spanLimits.eventCountLimit === 0)
        return v.warn("No events allowed."), this._droppedEventsCount++, this;
      this.events.length >= this._spanLimits.eventCountLimit && (this._droppedEventsCount === 0 && v.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), Wi(r) && (Wi(n) || (n = r), r = void 0);
      var i = Je(r);
      return this.events.push({
        name: t,
        attributes: i,
        time: this._getTime(n),
        droppedAttributesCount: 0
      }), this;
    }, e.prototype.addLink = function(t) {
      return this.links.push(t), this;
    }, e.prototype.addLinks = function(t) {
      var r;
      return (r = this.links).push.apply(r, Th([], eo(t), !1)), this;
    }, e.prototype.setStatus = function(t) {
      return this._isSpanEnded() ? this : (this.status = $n({}, t), this.status.message != null && typeof t.message != "string" && (v.warn("Dropping invalid status.message of type '" + typeof t.message + "', expected 'string'"), delete this.status.message), this);
    }, e.prototype.updateName = function(t) {
      return this._isSpanEnded() ? this : (this.name = t, this);
    }, e.prototype.end = function(t) {
      if (this._isSpanEnded()) {
        v.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
        return;
      }
      this._ended = !0, this.endTime = this._getTime(t), this._duration = xp(this.startTime, this.endTime), this._duration[0] < 0 && (v.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && v.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached"), this._spanProcessor.onEnd(this);
    }, e.prototype._getTime = function(t) {
      if (typeof t == "number" && t <= Ht.now())
        return os(t + this._performanceOffset);
      if (typeof t == "number")
        return dt(t);
      if (t instanceof Date)
        return dt(t.getTime());
      if (di(t))
        return t;
      if (this._startTimeProvided)
        return dt(Date.now());
      var r = Ht.now() - this._performanceStartTime;
      return as(this.startTime, dt(r));
    }, e.prototype.isRecording = function() {
      return this._ended === !1;
    }, e.prototype.recordException = function(t, r) {
      var n = {};
      typeof t == "string" ? n[Yr] = t : t && (t.code ? n[Wr] = t.code.toString() : t.name && (n[Wr] = t.name), t.message && (n[Yr] = t.message), t.stack && (n[Ep] = t.stack)), n[Wr] || n[Yr] ? this.addEvent(Eh, n, r) : v.warn("Failed to record an exception " + t);
    }, Object.defineProperty(e.prototype, "duration", {
      get: function() {
        return this._duration;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ended", {
      get: function() {
        return this._ended;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedAttributesCount", {
      get: function() {
        return this._droppedAttributesCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedEventsCount", {
      get: function() {
        return this._droppedEventsCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedLinksCount", {
      get: function() {
        return this._droppedLinksCount;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._isSpanEnded = function() {
      return this._ended && v.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}"), this._ended;
    }, e.prototype._truncateToLimitUtil = function(t, r) {
      return t.length <= r ? t : t.substring(0, r);
    }, e.prototype._truncateToSize = function(t) {
      var r = this, n = this._attributeValueLengthLimit;
      return n <= 0 ? (v.warn("Attribute value limit must be positive, got " + n), t) : typeof t == "string" ? this._truncateToLimitUtil(t, n) : Array.isArray(t) ? t.map(function(i) {
        return typeof i == "string" ? r._truncateToLimitUtil(i, n) : i;
      }) : t;
    }, e;
  }()
), Xt;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Xt || (Xt = {}));
var ur = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: Xt.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "AlwaysOffSampler";
    }, e;
  }()
), jt = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: Xt.RECORD_AND_SAMPLED
      };
    }, e.prototype.toString = function() {
      return "AlwaysOnSampler";
    }, e;
  }()
), en = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i, o;
      this._root = t.root, this._root || (Ft(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new jt()), this._remoteParentSampled = (r = t.remoteParentSampled) !== null && r !== void 0 ? r : new jt(), this._remoteParentNotSampled = (n = t.remoteParentNotSampled) !== null && n !== void 0 ? n : new ur(), this._localParentSampled = (i = t.localParentSampled) !== null && i !== void 0 ? i : new jt(), this._localParentNotSampled = (o = t.localParentNotSampled) !== null && o !== void 0 ? o : new ur();
    }
    return e.prototype.shouldSample = function(t, r, n, i, o, a) {
      var u = R.getSpanContext(t);
      return !u || !Le(u) ? this._root.shouldSample(t, r, n, i, o, a) : u.isRemote ? u.traceFlags & Q.SAMPLED ? this._remoteParentSampled.shouldSample(t, r, n, i, o, a) : this._remoteParentNotSampled.shouldSample(t, r, n, i, o, a) : u.traceFlags & Q.SAMPLED ? this._localParentSampled.shouldSample(t, r, n, i, o, a) : this._localParentNotSampled.shouldSample(t, r, n, i, o, a);
    }, e.prototype.toString = function() {
      return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    }, e;
  }()
), ro = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = 0), this._ratio = t, this._ratio = this._normalize(t), this._upperBound = Math.floor(this._ratio * 4294967295);
    }
    return e.prototype.shouldSample = function(t, r) {
      return {
        decision: xa(r) && this._accumulate(r) < this._upperBound ? Xt.RECORD_AND_SAMPLED : Xt.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "TraceIdRatioBased{" + this._ratio + "}";
    }, e.prototype._normalize = function(t) {
      return typeof t != "number" || isNaN(t) ? 0 : t >= 1 ? 1 : t <= 0 ? 0 : t;
    }, e.prototype._accumulate = function(t) {
      for (var r = 0, n = 0; n < t.length / 8; n++) {
        var i = n * 8, o = parseInt(t.slice(i, i + 8), 16);
        r = (r ^ o) >>> 0;
      }
      return r;
    }, e;
  }()
), Oh = W.AlwaysOn, Bt = 1;
function ps() {
  var e = me();
  return {
    sampler: hs(e),
    forceFlushTimeoutMillis: 3e4,
    generalLimits: {
      attributeValueLengthLimit: e.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_ATTRIBUTE_COUNT_LIMIT
    },
    spanLimits: {
      attributeValueLengthLimit: e.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
      linkCountLimit: e.OTEL_SPAN_LINK_COUNT_LIMIT,
      eventCountLimit: e.OTEL_SPAN_EVENT_COUNT_LIMIT,
      attributePerEventCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
      attributePerLinkCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
    },
    mergeResourceWithDefaults: !0
  };
}
function hs(e) {
  switch (e === void 0 && (e = me()), e.OTEL_TRACES_SAMPLER) {
    case W.AlwaysOn:
      return new jt();
    case W.AlwaysOff:
      return new ur();
    case W.ParentBasedAlwaysOn:
      return new en({
        root: new jt()
      });
    case W.ParentBasedAlwaysOff:
      return new en({
        root: new ur()
      });
    case W.TraceIdRatio:
      return new ro(no(e));
    case W.ParentBasedTraceIdRatio:
      return new en({
        root: new ro(no(e))
      });
    default:
      return v.error('OTEL_TRACES_SAMPLER value "' + e.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + Oh + '".'), new jt();
  }
}
function no(e) {
  if (e.OTEL_TRACES_SAMPLER_ARG === void 0 || e.OTEL_TRACES_SAMPLER_ARG === "")
    return v.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + Bt + "."), Bt;
  var t = Number(e.OTEL_TRACES_SAMPLER_ARG);
  return isNaN(t) ? (v.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + Bt + "."), Bt) : t < 0 || t > 1 ? (v.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + Bt + "."), Bt) : t;
}
function bh(e) {
  var t = {
    sampler: hs()
  }, r = ps(), n = Object.assign({}, r, t, e);
  return n.generalLimits = Object.assign({}, r.generalLimits, e.generalLimits || {}), n.spanLimits = Object.assign({}, r.spanLimits, e.spanLimits || {}), n;
}
function Ah(e) {
  var t, r, n, i, o, a, u, c, s, l, f, d, p = Object.assign({}, e.spanLimits), _ = dp();
  return p.attributeCountLimit = (a = (o = (i = (r = (t = e.spanLimits) === null || t === void 0 ? void 0 : t.attributeCountLimit) !== null && r !== void 0 ? r : (n = e.generalLimits) === null || n === void 0 ? void 0 : n.attributeCountLimit) !== null && i !== void 0 ? i : _.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && o !== void 0 ? o : _.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && a !== void 0 ? a : Qe, p.attributeValueLengthLimit = (d = (f = (l = (c = (u = e.spanLimits) === null || u === void 0 ? void 0 : u.attributeValueLengthLimit) !== null && c !== void 0 ? c : (s = e.generalLimits) === null || s === void 0 ? void 0 : s.attributeValueLengthLimit) !== null && l !== void 0 ? l : _.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && f !== void 0 ? f : _.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && d !== void 0 ? d : Ze, Object.assign({}, e, { spanLimits: p });
}
var wh = (
  /** @class */
  function() {
    function e(t, r) {
      this._exporter = t, this._isExporting = !1, this._finishedSpans = [], this._droppedSpansCount = 0;
      var n = me();
      this._maxExportBatchSize = typeof (r == null ? void 0 : r.maxExportBatchSize) == "number" ? r.maxExportBatchSize : n.OTEL_BSP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = typeof (r == null ? void 0 : r.maxQueueSize) == "number" ? r.maxQueueSize : n.OTEL_BSP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = typeof (r == null ? void 0 : r.scheduledDelayMillis) == "number" ? r.scheduledDelayMillis : n.OTEL_BSP_SCHEDULE_DELAY, this._exportTimeoutMillis = typeof (r == null ? void 0 : r.exportTimeoutMillis) == "number" ? r.exportTimeoutMillis : n.OTEL_BSP_EXPORT_TIMEOUT, this._shutdownOnce = new yh(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (v.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    return e.prototype.forceFlush = function() {
      return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }, e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
      this._shutdownOnce.isCalled || (t.spanContext().traceFlags & Q.SAMPLED) !== 0 && this._addToBuffer(t);
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.onShutdown();
      }).then(function() {
        return t._flushAll();
      }).then(function() {
        return t._exporter.shutdown();
      });
    }, e.prototype._addToBuffer = function(t) {
      if (this._finishedSpans.length >= this._maxQueueSize) {
        this._droppedSpansCount === 0 && v.debug("maxQueueSize reached, dropping spans"), this._droppedSpansCount++;
        return;
      }
      this._droppedSpansCount > 0 && (v.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached"), this._droppedSpansCount = 0), this._finishedSpans.push(t), this._maybeStartTimer();
    }, e.prototype._flushAll = function() {
      var t = this;
      return new Promise(function(r, n) {
        for (var i = [], o = Math.ceil(t._finishedSpans.length / t._maxExportBatchSize), a = 0, u = o; a < u; a++)
          i.push(t._flushOneBatch());
        Promise.all(i).then(function() {
          r();
        }).catch(n);
      });
    }, e.prototype._flushOneBatch = function() {
      var t = this;
      return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise(function(r, n) {
        var i = setTimeout(function() {
          n(new Error("Timeout"));
        }, t._exportTimeoutMillis);
        b.with(Dd(b.active()), function() {
          var o;
          t._finishedSpans.length <= t._maxExportBatchSize ? (o = t._finishedSpans, t._finishedSpans = []) : o = t._finishedSpans.splice(0, t._maxExportBatchSize);
          for (var a = function() {
            return t._exporter.export(o, function(f) {
              var d;
              clearTimeout(i), f.code === kn.SUCCESS ? r() : n((d = f.error) !== null && d !== void 0 ? d : new Error("BatchSpanProcessor: span export failed"));
            });
          }, u = null, c = 0, s = o.length; c < s; c++) {
            var l = o[c];
            l.resource.asyncAttributesPending && l.resource.waitForAsyncAttributes && (u != null || (u = []), u.push(l.resource.waitForAsyncAttributes()));
          }
          u === null ? a() : Promise.all(u).then(a, function(f) {
            Ft(f), n(f);
          });
        });
      });
    }, e.prototype._maybeStartTimer = function() {
      var t = this;
      if (!this._isExporting) {
        var r = function() {
          t._isExporting = !0, t._flushOneBatch().finally(function() {
            t._isExporting = !1, t._finishedSpans.length > 0 && (t._clearTimer(), t._maybeStartTimer());
          }).catch(function(n) {
            t._isExporting = !1, Ft(n);
          });
        };
        if (this._finishedSpans.length >= this._maxExportBatchSize)
          return r();
        this._timer === void 0 && (this._timer = setTimeout(function() {
          return r();
        }, this._scheduledDelayMillis));
      }
    }, e.prototype._clearTimer = function() {
      this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
    }, e;
  }()
), Rh = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), _s = (
  /** @class */
  function(e) {
    Rh(t, e);
    function t(r, n) {
      var i = e.call(this, r, n) || this;
      return i.onInit(n), i;
    }
    return t.prototype.onInit = function(r) {
      var n = this;
      (r == null ? void 0 : r.disableAutoFlushOnDocumentHide) !== !0 && typeof document != "undefined" && (this._visibilityChangeListener = function() {
        document.visibilityState === "hidden" && n.forceFlush().catch(function(i) {
          Ft(i);
        });
      }, this._pageHideListener = function() {
        n.forceFlush().catch(function(i) {
          Ft(i);
        });
      }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
    }, t.prototype.onShutdown = function() {
      typeof document != "undefined" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
    }, t;
  }(wh)
), Lh = 8, Ph = 16, Nh = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      this.generateTraceId = io(Ph), this.generateSpanId = io(Lh);
    }
    return e;
  }()
), Ue = Array(32);
function io(e) {
  return function() {
    for (var r = 0; r < e * 2; r++)
      Ue[r] = Math.floor(Math.random() * 16) + 48, Ue[r] >= 58 && (Ue[r] += 39);
    return String.fromCharCode.apply(null, Ue.slice(0, e * 2));
  };
}
var Ih = (
  /** @class */
  function() {
    function e(t, r, n) {
      this._tracerProvider = n;
      var i = bh(r);
      this._sampler = i.sampler, this._generalLimits = i.generalLimits, this._spanLimits = i.spanLimits, this._idGenerator = r.idGenerator || new Nh(), this.resource = n.resource, this.instrumentationLibrary = t;
    }
    return e.prototype.startSpan = function(t, r, n) {
      var i, o, a;
      r === void 0 && (r = {}), n === void 0 && (n = b.active()), r.root && (n = R.deleteSpan(n));
      var u = R.getSpan(n);
      if (li(n)) {
        v.debug("Instrumentation suppressed, returning Noop Span");
        var c = R.wrapSpanContext(Ca);
        return c;
      }
      var s = u == null ? void 0 : u.spanContext(), l = this._idGenerator.generateSpanId(), f, d, p;
      !s || !R.isSpanContextValid(s) ? f = this._idGenerator.generateTraceId() : (f = s.traceId, d = s.traceState, p = s.spanId);
      var _ = (i = r.kind) !== null && i !== void 0 ? i : ye.INTERNAL, h = ((o = r.links) !== null && o !== void 0 ? o : []).map(function(I) {
        return {
          context: I.context,
          attributes: Je(I.attributes)
        };
      }), g = Je(r.attributes), y = this._sampler.shouldSample(n, f, t, _, g, h);
      d = (a = y.traceState) !== null && a !== void 0 ? a : d;
      var m = y.decision === rr.RECORD_AND_SAMPLED ? Q.SAMPLED : Q.NONE, A = { traceId: f, spanId: l, traceFlags: m, traceState: d };
      if (y.decision === rr.NOT_RECORD) {
        v.debug("Recording is off, propagating context in a non-recording span");
        var c = R.wrapSpanContext(A);
        return c;
      }
      var w = Je(Object.assign(g, y.attributes)), L = new Sh(this, n, t, A, _, p, h, r.startTime, void 0, w);
      return L;
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = r : arguments.length === 3 ? (o = r, u = n) : (o = r, a = n, u = i);
        var c = a != null ? a : b.active(), s = this.startSpan(t, o, c), l = R.setSpan(c, s);
        return b.with(l, u, void 0, s);
      }
    }, e.prototype.getGeneralLimits = function() {
      return this._generalLimits;
    }, e.prototype.getSpanLimits = function() {
      return this._spanLimits;
    }, e.prototype.getActiveSpanProcessor = function() {
      return this._tracerProvider.getActiveSpanProcessor();
    }, e;
  }()
);
function Ch() {
  return "unknown_service";
}
var ct = function() {
  return ct = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, ct.apply(this, arguments);
}, Mh = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, xh = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Dh = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, oo = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this, i;
      this._attributes = t, this.asyncAttributesPending = r != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = r == null ? void 0 : r.then(function(o) {
        return n._attributes = Object.assign({}, n._attributes, o), n.asyncAttributesPending = !1, o;
      }, function(o) {
        return v.debug("a resource's async attributes promise rejected: %s", o), n.asyncAttributesPending = !1, {};
      });
    }
    return e.empty = function() {
      return e.EMPTY;
    }, e.default = function() {
      var t;
      return new e((t = {}, t[Lp] = Ch(), t[Un] = Jr[Un], t[Dn] = Jr[Dn], t[Bn] = Jr[Bn], t));
    }, Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var t;
        return this.asyncAttributesPending && v.error("Accessing resource attributes before async attributes settled"), (t = this._attributes) !== null && t !== void 0 ? t : {};
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.waitForAsyncAttributes = function() {
      return Mh(this, void 0, void 0, function() {
        return xh(this, function(t) {
          switch (t.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.merge = function(t) {
      var r = this, n;
      if (!t)
        return this;
      var i = ct(ct({}, this._syncAttributes), (n = t._syncAttributes) !== null && n !== void 0 ? n : t.attributes);
      if (!this._asyncAttributesPromise && !t._asyncAttributesPromise)
        return new e(i);
      var o = Promise.all([
        this._asyncAttributesPromise,
        t._asyncAttributesPromise
      ]).then(function(a) {
        var u, c = Dh(a, 2), s = c[0], l = c[1];
        return ct(ct(ct(ct({}, r._syncAttributes), s), (u = t._syncAttributes) !== null && u !== void 0 ? u : t.attributes), l);
      });
      return new e(i, o);
    }, e.EMPTY = new e({}), e;
  }()
), Be = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ao = (
  /** @class */
  function() {
    function e(t) {
      this._spanProcessors = t;
    }
    return e.prototype.forceFlush = function() {
      var t, r, n = [];
      try {
        for (var i = Be(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.forceFlush());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u) {
        Promise.all(n).then(function() {
          u();
        }).catch(function(c) {
          Ft(c || new Error("MultiSpanProcessor: forceFlush failed")), u();
        });
      });
    }, e.prototype.onStart = function(t, r) {
      var n, i;
      try {
        for (var o = Be(this._spanProcessors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          u.onStart(t, r);
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
    }, e.prototype.onEnd = function(t) {
      var r, n;
      try {
        for (var i = Be(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          a.onEnd(t);
        }
      } catch (u) {
        r = { error: u };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype.shutdown = function() {
      var t, r, n = [];
      try {
        for (var i = Be(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.shutdown());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u, c) {
        Promise.all(n).then(function() {
          u();
        }, c);
      });
    }, e;
  }()
), Uh = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
    }, e.prototype.shutdown = function() {
      return Promise.resolve();
    }, e.prototype.forceFlush = function() {
      return Promise.resolve();
    }, e;
  }()
), Bh = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, kh = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Tt;
(function(e) {
  e[e.resolved = 0] = "resolved", e[e.timeout = 1] = "timeout", e[e.error = 2] = "error", e[e.unresolved = 3] = "unresolved";
})(Tt || (Tt = {}));
var Gh = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r, n;
      this._registeredSpanProcessors = [], this._tracers = /* @__PURE__ */ new Map();
      var i = dh({}, ps(), Ah(t));
      if (this.resource = (r = i.resource) !== null && r !== void 0 ? r : oo.empty(), i.mergeResourceWithDefaults && (this.resource = oo.default().merge(this.resource)), this._config = Object.assign({}, i, {
        resource: this.resource
      }), !((n = t.spanProcessors) === null || n === void 0) && n.length)
        this._registeredSpanProcessors = kh([], Bh(t.spanProcessors), !1), this.activeSpanProcessor = new ao(this._registeredSpanProcessors);
      else {
        var o = this._buildExporterFromEnv();
        if (o !== void 0) {
          var a = new _s(o);
          this.activeSpanProcessor = a;
        } else
          this.activeSpanProcessor = new Uh();
      }
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i = t + "@" + (r || "") + ":" + ((n == null ? void 0 : n.schemaUrl) || "");
      return this._tracers.has(i) || this._tracers.set(i, new Ih({ name: t, version: r, schemaUrl: n == null ? void 0 : n.schemaUrl }, this._config, this)), this._tracers.get(i);
    }, e.prototype.addSpanProcessor = function(t) {
      this._registeredSpanProcessors.length === 0 && this.activeSpanProcessor.shutdown().catch(function(r) {
        return v.error("Error while trying to shutdown current span processor", r);
      }), this._registeredSpanProcessors.push(t), this.activeSpanProcessor = new ao(this._registeredSpanProcessors);
    }, e.prototype.getActiveSpanProcessor = function() {
      return this.activeSpanProcessor;
    }, e.prototype.register = function(t) {
      t === void 0 && (t = {}), R.setGlobalTracerProvider(this), t.propagator === void 0 && (t.propagator = this._buildPropagatorFromEnv()), t.contextManager && b.setGlobalContextManager(t.contextManager), t.propagator && G.setGlobalPropagator(t.propagator);
    }, e.prototype.forceFlush = function() {
      var t = this._config.forceFlushTimeoutMillis, r = this._registeredSpanProcessors.map(function(n) {
        return new Promise(function(i) {
          var o, a = setTimeout(function() {
            i(new Error("Span processor did not completed within timeout period of " + t + " ms")), o = Tt.timeout;
          }, t);
          n.forceFlush().then(function() {
            clearTimeout(a), o !== Tt.timeout && (o = Tt.resolved, i(o));
          }).catch(function(u) {
            clearTimeout(a), o = Tt.error, i(u);
          });
        });
      });
      return new Promise(function(n, i) {
        Promise.all(r).then(function(o) {
          var a = o.filter(function(u) {
            return u !== Tt.resolved;
          });
          a.length > 0 ? i(a) : n();
        }).catch(function(o) {
          return i([o]);
        });
      });
    }, e.prototype.shutdown = function() {
      return this.activeSpanProcessor.shutdown();
    }, e.prototype._getPropagator = function(t) {
      var r;
      return (r = this.constructor._registeredPropagators.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._getSpanExporter = function(t) {
      var r;
      return (r = this.constructor._registeredExporters.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._buildPropagatorFromEnv = function() {
      var t = this, r = Array.from(new Set(me().OTEL_PROPAGATORS)), n = r.map(function(o) {
        var a = t._getPropagator(o);
        return a || v.warn('Propagator "' + o + '" requested through environment variable is unavailable.'), a;
      }), i = n.reduce(function(o, a) {
        return a && o.push(a), o;
      }, []);
      if (i.length !== 0)
        return r.length === 1 ? i[0] : new Up({
          propagators: i
        });
    }, e.prototype._buildExporterFromEnv = function() {
      var t = me().OTEL_TRACES_EXPORTER;
      if (!(t === "none" || t === "")) {
        var r = this._getSpanExporter(t);
        return r || v.error('Exporter "' + t + '" requested through environment variable is unavailable.'), r;
      }
    }, e._registeredPropagators = /* @__PURE__ */ new Map([
      ["tracecontext", function() {
        return new Qp();
      }],
      ["baggage", function() {
        return new Fd();
      }]
    ]), e._registeredExporters = /* @__PURE__ */ new Map(), e;
  }()
), $h = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Hh = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, vs = (
  /** @class */
  function() {
    function e() {
      this._enabled = !1, this._currentContext = yt;
    }
    return e.prototype._bindFunction = function(t, r) {
      t === void 0 && (t = yt);
      var n = this, i = function() {
        for (var o = this, a = [], u = 0; u < arguments.length; u++)
          a[u] = arguments[u];
        return n.with(t, function() {
          return r.apply(o, a);
        });
      };
      return Object.defineProperty(i, "length", {
        enumerable: !1,
        configurable: !0,
        writable: !1,
        value: r.length
      }), i;
    }, e.prototype.active = function() {
      return this._currentContext;
    }, e.prototype.bind = function(t, r) {
      return t === void 0 && (t = this.active()), typeof r == "function" ? this._bindFunction(t, r) : r;
    }, e.prototype.disable = function() {
      return this._currentContext = yt, this._enabled = !1, this;
    }, e.prototype.enable = function() {
      return this._enabled ? this : (this._enabled = !0, this._currentContext = yt, this);
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      var a = this._currentContext;
      this._currentContext = t || yt;
      try {
        return r.call.apply(r, Hh([n], $h(i), !1));
      } finally {
        this._currentContext = a;
      }
    }, e;
  }()
), jh = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Vh = (
  /** @class */
  function(e) {
    jh(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, r) || this;
      if (r.contextManager)
        throw "contextManager should be defined in register method not in constructor";
      if (r.propagator)
        throw "propagator should be defined in register method not in constructor";
      return n;
    }
    return t.prototype.register = function(r) {
      r === void 0 && (r = {}), r.contextManager === void 0 && (r.contextManager = new vs()), r.contextManager && r.contextManager.enable(), e.prototype.register.call(this, r);
    }, t;
  }(Gh)
), T;
(function(e) {
  e.CONNECT_END = "connectEnd", e.CONNECT_START = "connectStart", e.DECODED_BODY_SIZE = "decodedBodySize", e.DOM_COMPLETE = "domComplete", e.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", e.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", e.DOM_INTERACTIVE = "domInteractive", e.DOMAIN_LOOKUP_END = "domainLookupEnd", e.DOMAIN_LOOKUP_START = "domainLookupStart", e.ENCODED_BODY_SIZE = "encodedBodySize", e.FETCH_START = "fetchStart", e.LOAD_EVENT_END = "loadEventEnd", e.LOAD_EVENT_START = "loadEventStart", e.NAVIGATION_START = "navigationStart", e.REDIRECT_END = "redirectEnd", e.REDIRECT_START = "redirectStart", e.REQUEST_START = "requestStart", e.RESPONSE_END = "responseEnd", e.RESPONSE_START = "responseStart", e.SECURE_CONNECTION_START = "secureConnectionStart", e.UNLOAD_EVENT_END = "unloadEventEnd", e.UNLOAD_EVENT_START = "unloadEventStart";
})(T || (T = {}));
var rn;
function Fh() {
  return rn || (rn = document.createElement("a")), rn;
}
function vt(e, t) {
  return t in e;
}
function x(e, t, r, n) {
  var i = void 0, o = void 0;
  vt(r, t) && typeof r[t] == "number" && (i = r[t]);
  var a = T.FETCH_START;
  if (vt(r, a) && typeof r[a] == "number" && (o = r[a]), i !== void 0 && o !== void 0 && i >= o)
    return e.addEvent(t, i), e;
}
function zt(e, t, r) {
  r === void 0 && (r = !1), r || (x(e, T.FETCH_START, t), x(e, T.DOMAIN_LOOKUP_START, t), x(e, T.DOMAIN_LOOKUP_END, t), x(e, T.CONNECT_START, t), vt(t, "name") && t.name.startsWith("https:") && x(e, T.SECURE_CONNECTION_START, t), x(e, T.CONNECT_END, t), x(e, T.REQUEST_START, t), x(e, T.RESPONSE_START, t), x(e, T.RESPONSE_END, t));
  var n = t[T.ENCODED_BODY_SIZE];
  n !== void 0 && e.setAttribute(mp, n);
  var i = t[T.DECODED_BODY_SIZE];
  i !== void 0 && n !== i && e.setAttribute(Tp, i);
}
function Xh(e) {
  return e.slice().sort(function(t, r) {
    var n = t[T.FETCH_START], i = r[T.FETCH_START];
    return n > i ? 1 : n < i ? -1 : 0;
  });
}
function gs() {
  return typeof location != "undefined" ? location.origin : void 0;
}
function ys(e, t, r, n, i, o) {
  i === void 0 && (i = /* @__PURE__ */ new WeakSet());
  var a = it(e);
  e = a.toString();
  var u = qh(e, t, r, n, i, o);
  if (u.length === 0)
    return {
      mainRequest: void 0
    };
  if (u.length === 1)
    return {
      mainRequest: u[0]
    };
  var c = Xh(u);
  if (a.origin !== gs() && c.length > 1) {
    var s = c[0], l = zh(c, s[T.RESPONSE_END], r), f = s[T.RESPONSE_END], d = l[T.FETCH_START];
    return d < f && (l = s, s = void 0), {
      corsPreFlightRequest: s,
      mainRequest: l
    };
  } else
    return {
      mainRequest: u[0]
    };
}
function zh(e, t, r) {
  for (var n = pt(r), i = pt(de(t)), o = e[1], a, u = e.length, c = 1; c < u; c++) {
    var s = e[c], l = pt(de(s[T.FETCH_START])), f = pt(de(s[T.RESPONSE_END])), d = n - f;
    l >= i && (!a || d < a) && (a = d, o = s);
  }
  return o;
}
function qh(e, t, r, n, i, o) {
  var a = pt(t), u = pt(r), c = n.filter(function(s) {
    var l = pt(de(s[T.FETCH_START])), f = pt(de(s[T.RESPONSE_END]));
    return s.initiatorType.toLowerCase() === (o || "xmlhttprequest") && s.name === e && l >= a && f <= u;
  });
  return c.length > 0 && (c = c.filter(function(s) {
    return !i.has(s);
  })), c;
}
function it(e) {
  if (typeof URL == "function")
    return new URL(e, typeof document != "undefined" ? document.baseURI : typeof location != "undefined" ? location.href : void 0);
  var t = Fh();
  return t.href = e, t;
}
function Es(e, t) {
  if (e.nodeType === Node.DOCUMENT_NODE)
    return "/";
  var r = Wh(e, t);
  if (t && r.indexOf("@id") > 0)
    return r;
  var n = "";
  return e.parentNode && (n += Es(e.parentNode, !1)), n += r, n;
}
function Kh(e) {
  if (!e.parentNode)
    return 0;
  var t = [e.nodeType];
  e.nodeType === Node.CDATA_SECTION_NODE && t.push(Node.TEXT_NODE);
  var r = Array.from(e.parentNode.childNodes);
  return r = r.filter(function(n) {
    var i = n.localName;
    return t.indexOf(n.nodeType) >= 0 && i === e.localName;
  }), r.length >= 1 ? r.indexOf(e) + 1 : 0;
}
function Wh(e, t) {
  var r = e.nodeType, n = Kh(e), i = "";
  if (r === Node.ELEMENT_NODE) {
    var o = e.getAttribute("id");
    if (t && o)
      return '//*[@id="' + o + '"]';
    i = e.localName;
  } else if (r === Node.TEXT_NODE || r === Node.CDATA_SECTION_NODE)
    i = "text()";
  else if (r === Node.COMMENT_NODE)
    i = "comment()";
  else
    return "";
  return i && n > 1 ? "/" + i + "[" + n + "]" : "/" + i;
}
function ms(e, t) {
  var r = t || [];
  (typeof r == "string" || r instanceof RegExp) && (r = [r]);
  var n = it(e);
  return n.origin === gs() ? !0 : r.some(function(i) {
    return hh(e, i);
  });
}
var Ts = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), Yh = new Ts(), Jh = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      return new Ts();
    }, e;
  }()
), Ss = new Jh(), Zh = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.emit = function(t) {
      this._getLogger().emit(t);
    }, e.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : Yh;
    }, e;
  }()
), so = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      var i;
      return (i = this.getDelegateLogger(t, r, n)) !== null && i !== void 0 ? i : new Zh(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : Ss;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateLogger = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, r, n);
    }, e;
  }()
), Qh = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, ke = Symbol.for("io.opentelemetry.js.api.logs"), ae = Qh;
function t_(e, t, r) {
  return function(n) {
    return n === e ? t : r;
  };
}
var uo = 1, e_ = (
  /** @class */
  function() {
    function e() {
      this._proxyLoggerProvider = new so();
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return ae[ke] ? this.getLoggerProvider() : (ae[ke] = t_(uo, t, Ss), this._proxyLoggerProvider.setDelegate(t), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, r;
      return (r = (t = ae[ke]) === null || t === void 0 ? void 0 : t.call(ae, uo)) !== null && r !== void 0 ? r : this._proxyLoggerProvider;
    }, e.prototype.getLogger = function(t, r, n) {
      return this.getLoggerProvider().getLogger(t, r, n);
    }, e.prototype.disable = function() {
      delete ae[ke], this._proxyLoggerProvider = new so();
    }, e;
  }()
), r_ = e_.getInstance(), Hn = function() {
  return Hn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Hn.apply(this, arguments);
}, n_ = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = U.wrap, this._unwrap = U.unwrap, this._massWrap = U.massWrap, this._massUnwrap = U.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = R.getTracer(t, r), this._meter = qt.getMeter(t, r), this._logger = r_.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = Hn({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), i_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), o_ = (
  /** @class */
  function(e) {
    i_(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(n_)
);
function co(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
var pe;
(function(e) {
  e.DOCUMENT_LOAD = "documentLoad", e.DOCUMENT_FETCH = "documentFetch", e.RESOURCE_FETCH = "resourceFetch";
})(pe || (pe = {}));
var a_ = "0.44.0", s_ = "@opentelemetry/instrumentation-document-load";
const u_ = "http.url", c_ = "http.user_agent", Vt = u_, l_ = c_;
var cr;
(function(e) {
  e.FIRST_PAINT = "firstPaint", e.FIRST_CONTENTFUL_PAINT = "firstContentfulPaint";
})(cr || (cr = {}));
var f_ = function() {
  var e, t, r = {}, n = (t = (e = or).getEntriesByType) === null || t === void 0 ? void 0 : t.call(e, "navigation")[0];
  if (n) {
    var i = Object.values(T);
    i.forEach(function(u) {
      if (vt(n, u)) {
        var c = n[u];
        typeof c == "number" && (r[u] = c);
      }
    });
  } else {
    var o = or, a = o.timing;
    if (a) {
      var i = Object.values(T);
      i.forEach(function(c) {
        if (vt(a, c)) {
          var s = a[c];
          typeof s == "number" && (r[c] = s);
        }
      });
    }
  }
  return r;
}, lo = {
  "first-paint": cr.FIRST_PAINT,
  "first-contentful-paint": cr.FIRST_CONTENTFUL_PAINT
}, d_ = function(e) {
  var t, r, n = (r = (t = or).getEntriesByType) === null || r === void 0 ? void 0 : r.call(t, "paint");
  n && n.forEach(function(i) {
    var o = i.name, a = i.startTime;
    vt(lo, o) && e.addEvent(lo[o], a);
  });
}, p_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), h_ = (
  /** @class */
  function(e) {
    p_(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, s_, a_, r) || this;
      return n.component = "document-load", n.version = "1", n.moduleName = n.component, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._onDocumentLoaded = function() {
      var r = this;
      window.setTimeout(function() {
        r._collectPerformance();
      });
    }, t.prototype._addResourcesSpans = function(r) {
      var n = this, i, o, a = (o = (i = or).getEntriesByType) === null || o === void 0 ? void 0 : o.call(i, "resource");
      a && a.forEach(function(u) {
        n._initResourceSpan(u, r);
      });
    }, t.prototype._collectPerformance = function() {
      var r = this, n = Array.from(document.getElementsByTagName("meta")).find(function(a) {
        return a.getAttribute("name") === xd;
      }), i = f_(), o = n && n.content || "";
      b.with(G.extract(yt, { traceparent: o }), function() {
        var a, u = r._startSpan(pe.DOCUMENT_LOAD, T.FETCH_START, i);
        u && (b.with(R.setSpan(b.active(), u), function() {
          var c = r._startSpan(pe.DOCUMENT_FETCH, T.FETCH_START, i);
          c && (c.setAttribute(Vt, location.href), b.with(R.setSpan(b.active(), c), function() {
            var s;
            r.getConfig().ignoreNetworkEvents || zt(c, i), r._addCustomAttributesOnSpan(c, (s = r.getConfig().applyCustomAttributesOnSpan) === null || s === void 0 ? void 0 : s.documentFetch), r._endSpan(c, T.RESPONSE_END, i);
          }));
        }), u.setAttribute(Vt, location.href), u.setAttribute(l_, navigator.userAgent), r._addResourcesSpans(u), r.getConfig().ignoreNetworkEvents || (x(u, T.FETCH_START, i), x(u, T.UNLOAD_EVENT_START, i), x(u, T.UNLOAD_EVENT_END, i), x(u, T.DOM_INTERACTIVE, i), x(u, T.DOM_CONTENT_LOADED_EVENT_START, i), x(u, T.DOM_CONTENT_LOADED_EVENT_END, i), x(u, T.DOM_COMPLETE, i), x(u, T.LOAD_EVENT_START, i), x(u, T.LOAD_EVENT_END, i)), r.getConfig().ignorePerformancePaintEvents || d_(u), r._addCustomAttributesOnSpan(u, (a = r.getConfig().applyCustomAttributesOnSpan) === null || a === void 0 ? void 0 : a.documentLoad), r._endSpan(u, T.LOAD_EVENT_END, i));
      });
    }, t.prototype._endSpan = function(r, n, i) {
      r && (vt(i, n) ? r.end(i[n]) : r.end());
    }, t.prototype._initResourceSpan = function(r, n) {
      var i, o = this._startSpan(pe.RESOURCE_FETCH, T.FETCH_START, r, n);
      o && (o.setAttribute(Vt, r.name), this.getConfig().ignoreNetworkEvents || zt(o, r), this._addCustomAttributesOnResourceSpan(o, r, (i = this.getConfig().applyCustomAttributesOnSpan) === null || i === void 0 ? void 0 : i.resourceFetch), this._endSpan(o, T.RESPONSE_END, r));
    }, t.prototype._startSpan = function(r, n, i, o) {
      if (vt(i, n) && typeof i[n] == "number") {
        var a = this.tracer.startSpan(r, {
          startTime: i[n]
        }, o ? R.setSpan(b.active(), o) : void 0);
        return a;
      }
    }, t.prototype._waitForPageLoad = function() {
      window.document.readyState === "complete" ? this._onDocumentLoaded() : (this._onDocumentLoaded = this._onDocumentLoaded.bind(this), window.addEventListener("load", this._onDocumentLoaded));
    }, t.prototype._addCustomAttributesOnSpan = function(r, n) {
      var i = this;
      n && co(function() {
        return n(r);
      }, function(o) {
        o && i._diag.error("addCustomAttributesOnSpan", o);
      });
    }, t.prototype._addCustomAttributesOnResourceSpan = function(r, n, i) {
      var o = this;
      i && co(function() {
        return i(r, n);
      }, function(a) {
        a && o._diag.error("addCustomAttributesOnResourceSpan", a);
      });
    }, t.prototype.enable = function() {
      window.removeEventListener("load", this._onDocumentLoaded), this._waitForPageLoad();
    }, t.prototype.disable = function() {
      window.removeEventListener("load", this._onDocumentLoaded);
    }, t;
  }(o_)
), Os = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), __ = new Os(), v_ = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      return new Os();
    }, e;
  }()
), bs = new v_(), g_ = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.emit = function(t) {
      this._getLogger().emit(t);
    }, e.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : __;
    }, e;
  }()
), fo = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      var i;
      return (i = this.getDelegateLogger(t, r, n)) !== null && i !== void 0 ? i : new g_(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : bs;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateLogger = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, r, n);
    }, e;
  }()
), y_ = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, Ge = Symbol.for("io.opentelemetry.js.api.logs"), se = y_;
function E_(e, t, r) {
  return function(n) {
    return n === e ? t : r;
  };
}
var po = 1, m_ = (
  /** @class */
  function() {
    function e() {
      this._proxyLoggerProvider = new fo();
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return se[Ge] ? this.getLoggerProvider() : (se[Ge] = E_(po, t, bs), this._proxyLoggerProvider.setDelegate(t), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, r;
      return (r = (t = se[Ge]) === null || t === void 0 ? void 0 : t.call(se, po)) !== null && r !== void 0 ? r : this._proxyLoggerProvider;
    }, e.prototype.getLogger = function(t, r, n) {
      return this.getLoggerProvider().getLogger(t, r, n);
    }, e.prototype.disable = function() {
      delete se[Ge], this._proxyLoggerProvider = new fo();
    }, e;
  }()
), T_ = m_.getInstance(), jn = function() {
  return jn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, jn.apply(this, arguments);
}, S_ = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = U.wrap, this._unwrap = U.unwrap, this._massWrap = U.massWrap, this._massUnwrap = U.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = R.getTracer(t, r), this._meter = qt.getMeter(t, r), this._logger = T_.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = jn({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), O_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), b_ = (
  /** @class */
  function(e) {
    O_(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(S_)
);
function A_(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
function w_(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var nn = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, Vn = performance, R_ = "http.method", L_ = "http.url", P_ = "http.host", N_ = "http.scheme", I_ = "http.status_code", C_ = "http.user_agent", M_ = "http.request_content_length_uncompressed", x_ = R_, D_ = L_, U_ = P_, B_ = N_, k_ = I_, G_ = C_, $_ = M_, H_ = 9, j_ = 6, V_ = Math.pow(10, j_), ho = Math.pow(10, H_);
function Fn(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * V_);
  return [r, n];
}
function F_() {
  var e = Vn.timeOrigin;
  if (typeof e != "number") {
    var t = Vn;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function _o(e) {
  var t = Fn(F_()), r = Fn(Vn.now());
  return X_(t, r);
}
function X_(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= ho && (r[1] -= ho, r[0] += 1), r;
}
var z_ = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function q_(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function K_(e, t) {
  var r, n;
  if (!t)
    return !1;
  try {
    for (var i = z_(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (q_(e, a))
        return !0;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var lr;
(function(e) {
  e.COMPONENT = "component", e.HTTP_ERROR_NAME = "http.error_name", e.HTTP_STATUS_TEXT = "http.status_text";
})(lr || (lr = {}));
var W_ = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Y_ = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, J_ = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Z_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, As = v.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-fetch/utils"
});
function Q_() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  if (e[0] instanceof URL || typeof e[0] == "string") {
    var r = e[1];
    if (!(r != null && r.body))
      return Promise.resolve();
    if (r.body instanceof ReadableStream) {
      var n = tv(r.body), i = n.body, o = n.length;
      return r.body = i, o;
    } else
      return Promise.resolve(ev(r.body));
  } else {
    var a = e[0];
    return a != null && a.body ? a.clone().text().then(function(u) {
      return Xn(u);
    }) : Promise.resolve();
  }
}
function tv(e) {
  if (!e.pipeThrough)
    return As.warn("Platform has ReadableStream but not pipeThrough!"), {
      body: e,
      length: Promise.resolve(void 0)
    };
  var t = 0, r, n = new Promise(function(o) {
    r = o;
  }), i = new TransformStream({
    start: function() {
    },
    transform: function(o, a) {
      return W_(this, void 0, void 0, function() {
        var u;
        return Y_(this, function(c) {
          switch (c.label) {
            case 0:
              return [4, o];
            case 1:
              return u = c.sent(), t += u.byteLength, a.enqueue(o), [
                2
                /*return*/
              ];
          }
        });
      });
    },
    flush: function() {
      r(t);
    }
  });
  return {
    body: e.pipeThrough(i),
    length: n
  };
}
function ev(e) {
  if (typeof Document != "undefined" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return nv(e);
  if (e instanceof URLSearchParams)
    return Xn(e.toString());
  if (typeof e == "string")
    return Xn(e);
  As.warn("unknown body type");
}
var rv = new TextEncoder();
function Xn(e) {
  return rv.encode(e).byteLength;
}
function nv(e) {
  var t, r, n = 0;
  try {
    for (var i = J_(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = Z_(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
var vo = "0.57.2", iv = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ov = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, av = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, on, sv = 300, go = typeof process == "object" && ((on = process.release) === null || on === void 0 ? void 0 : on.name) === "node", uv = (
  /** @class */
  function(e) {
    iv(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-fetch", vo, r) || this;
      return n.component = "fetch", n.version = vo, n.moduleName = n.component, n._usedResources = /* @__PURE__ */ new WeakSet(), n._tasksCount = 0, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this.tracer.startSpan("CORS Preflight", {
        startTime: n[T.FETCH_START]
      }, R.setSpan(b.active(), r));
      zt(i, n, this.getConfig().ignoreNetworkEvents), i.end(n[T.RESPONSE_END]);
    }, t.prototype._addFinalSpanAttributes = function(r, n) {
      var i = it(n.url);
      r.setAttribute(k_, n.status), n.statusText != null && r.setAttribute(lr.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(U_, i.host), r.setAttribute(B_, i.protocol.replace(":", "")), typeof navigator != "undefined" && r.setAttribute(G_, navigator.userAgent);
    }, t.prototype._addHeaders = function(r, n) {
      if (!ms(n, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var i = {};
        G.inject(b.active(), i), Object.keys(i).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      if (r instanceof Request)
        G.inject(b.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (r.headers instanceof Headers)
        G.inject(b.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (r.headers instanceof Map)
        G.inject(b.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else {
        var i = {};
        G.inject(b.active(), i), r.headers = Object.assign({}, i, r.headers || {});
      }
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._createSpan = function(r, n) {
      var i;
      if (n === void 0 && (n = {}), K_(r, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var o = (n.method || "GET").toUpperCase(), a = "HTTP " + o;
      return this.tracer.startSpan(a, {
        kind: ye.CLIENT,
        attributes: (i = {}, i[lr.COMPONENT] = this.moduleName, i[x_] = o, i[D_] = r, i)
      });
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i) {
      var o = n.entries;
      if (!o.length) {
        if (!performance.getEntriesByType)
          return;
        o = performance.getEntriesByType("resource");
      }
      var a = ys(n.spanUrl, n.startTime, i, o, this._usedResources, "fetch");
      if (a.mainRequest) {
        var u = a.mainRequest;
        this._markResourceAsUsed(u);
        var c = a.corsPreFlightRequest;
        c && (this._addChildSpan(r, c), this._markResourceAsUsed(c)), zt(r, u, this.getConfig().ignoreNetworkEvents);
      }
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._endSpan = function(r, n, i) {
      var o = this, a = Fn(Date.now()), u = _o();
      this._addFinalSpanAttributes(r, i), setTimeout(function() {
        var c;
        (c = n.observer) === null || c === void 0 || c.disconnect(), o._findResourceAndAddNetworkEvents(r, n, u), o._tasksCount--, o._clearResources(), r.end(a);
      }, sv);
    }, t.prototype._patchConstructor = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = this, s = it(a[0] instanceof Request ? a[0].url : String(a[0])).href, l = a[0] instanceof Request ? a[0] : a[1] || {}, f = i._createSpan(s, l);
          if (!f)
            return n.apply(this, a);
          var d = i._prepareSpanData(s);
          i.getConfig().measureRequestSize && Q_.apply(void 0, av([], ov(a), !1)).then(function(y) {
            y && f.setAttribute($_, y);
          }).catch(function(y) {
            i._diag.warn("getFetchBodyLength", y);
          });
          function p(y, m) {
            i._applyAttributesAfterFetch(y, l, m), i._endSpan(y, d, {
              status: m.status || 0,
              statusText: m.message,
              url: s
            });
          }
          function _(y, m) {
            i._applyAttributesAfterFetch(y, l, m), m.status >= 200 && m.status < 400 ? i._endSpan(y, d, m) : i._endSpan(y, d, {
              status: m.status,
              statusText: m.statusText,
              url: s
            });
          }
          function h(y, m, A) {
            try {
              var w = A.clone(), L = A.clone(), I = w.body;
              if (I) {
                var tt = I.getReader(), M = function() {
                  tt.read().then(function(et) {
                    var Yt = et.done;
                    Yt ? _(y, L) : M();
                  }, function(et) {
                    p(y, et);
                  });
                };
                M();
              } else
                _(y, A);
            } finally {
              m(A);
            }
          }
          function g(y, m, A) {
            try {
              p(y, A);
            } finally {
              m(A);
            }
          }
          return new Promise(function(y, m) {
            return b.with(R.setSpan(b.active(), f), function() {
              return i._addHeaders(l, s), i._tasksCount++, n.apply(c, l instanceof Request ? [l] : [s, l]).then(h.bind(c, f, y), g.bind(c, f, m));
            });
          });
        };
      };
    }, t.prototype._applyAttributesAfterFetch = function(r, n, i) {
      var o = this, a = this.getConfig().applyCustomAttributesOnSpan;
      a && A_(function() {
        return a(r, n, i);
      }, function(u) {
        u && o._diag.error("applyCustomAttributesOnSpan", u);
      });
    }, t.prototype._prepareSpanData = function(r) {
      var n = _o(), i = [];
      if (typeof PerformanceObserver != "function")
        return { entries: i, startTime: n, spanUrl: r };
      var o = new PerformanceObserver(function(a) {
        var u = a.getEntries();
        u.forEach(function(c) {
          c.initiatorType === "fetch" && c.name === r && i.push(c);
        });
      });
      return o.observe({
        entryTypes: ["resource"]
      }), { entries: i, observer: o, startTime: n, spanUrl: r };
    }, t.prototype.enable = function() {
      if (go) {
        this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
        return;
      }
      w_(fetch) && (this._unwrap(nn, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(nn, "fetch", this._patchConstructor());
    }, t.prototype.disable = function() {
      go || (this._unwrap(nn, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t;
  }(b_)
), ws = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), cv = new ws(), lv = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      return new ws();
    }, e;
  }()
), Rs = new lv(), fv = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.emit = function(t) {
      this._getLogger().emit(t);
    }, e.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : cv;
    }, e;
  }()
), yo = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      var i;
      return (i = this.getDelegateLogger(t, r, n)) !== null && i !== void 0 ? i : new fv(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : Rs;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateLogger = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, r, n);
    }, e;
  }()
), dv = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, $e = Symbol.for("io.opentelemetry.js.api.logs"), ue = dv;
function pv(e, t, r) {
  return function(n) {
    return n === e ? t : r;
  };
}
var Eo = 1, hv = (
  /** @class */
  function() {
    function e() {
      this._proxyLoggerProvider = new yo();
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return ue[$e] ? this.getLoggerProvider() : (ue[$e] = pv(Eo, t, Rs), this._proxyLoggerProvider.setDelegate(t), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, r;
      return (r = (t = ue[$e]) === null || t === void 0 ? void 0 : t.call(ue, Eo)) !== null && r !== void 0 ? r : this._proxyLoggerProvider;
    }, e.prototype.getLogger = function(t, r, n) {
      return this.getLoggerProvider().getLogger(t, r, n);
    }, e.prototype.disable = function() {
      delete ue[$e], this._proxyLoggerProvider = new yo();
    }, e;
  }()
), _v = hv.getInstance(), zn = function() {
  return zn = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, zn.apply(this, arguments);
}, vv = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = U.wrap, this._unwrap = U.unwrap, this._massWrap = U.massWrap, this._massUnwrap = U.massUnwrap, this.setConfig(n), this._diag = v.createComponentLogger({
        namespace: t
      }), this._tracer = R.getTracer(t, r), this._meter = qt.getMeter(t, r), this._logger = _v.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = zn({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), gv = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), yv = (
  /** @class */
  function(e) {
    gv(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(vv)
);
function Ev(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
function mo(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var Te = performance, mv = "http.method", Tv = "http.url", Sv = "http.host", Ov = "http.scheme", bv = "http.status_code", Av = "http.user_agent", wv = "http.request_content_length_uncompressed", Rv = mv, Lv = Tv, Pv = Sv, Nv = Ov, Iv = bv, Cv = Av, Mv = wv, xv = 9, Dv = 6, Uv = Math.pow(10, Dv), To = Math.pow(10, xv);
function So(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * Uv);
  return [r, n];
}
function Bv() {
  var e = Te.timeOrigin;
  if (typeof e != "number") {
    var t = Te;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function Oo(e) {
  var t = So(Bv()), r = So(Te.now());
  return kv(t, r);
}
function kv(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= To && (r[1] -= To, r[0] += 1), r;
}
var Gv = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function $v(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function Hv(e, t) {
  var r, n;
  if (!t)
    return !1;
  try {
    for (var i = Gv(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if ($v(e, a))
        return !0;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var nt;
(function(e) {
  e.METHOD_OPEN = "open", e.METHOD_SEND = "send", e.EVENT_ABORT = "abort", e.EVENT_ERROR = "error", e.EVENT_LOAD = "loaded", e.EVENT_TIMEOUT = "timeout";
})(nt || (nt = {}));
var jv = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Vv = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Fv = v.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils"
});
function Xv(e) {
  if (typeof Document != "undefined" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return qv(e);
  if (e instanceof URLSearchParams)
    return bo(e.toString());
  if (typeof e == "string")
    return bo(e);
  Fv.warn("unknown body type");
}
var zv = new TextEncoder();
function bo(e) {
  return zv.encode(e).byteLength;
}
function qv(e) {
  var t, r, n = 0;
  try {
    for (var i = jv(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = Vv(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
var Ao = "0.57.2", qn;
(function(e) {
  e.HTTP_STATUS_TEXT = "http.status_text";
})(qn || (qn = {}));
var Kv = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Wv = 300, Yv = (
  /** @class */
  function(e) {
    Kv(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-xml-http-request", Ao, r) || this;
      return n.component = "xml-http-request", n.version = Ao, n.moduleName = n.component, n._tasksCount = 0, n._xhrMem = /* @__PURE__ */ new WeakMap(), n._usedResources = /* @__PURE__ */ new WeakSet(), n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addHeaders = function(r, n) {
      var i = it(n).href;
      if (!ms(i, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var o = {};
        G.inject(b.active(), o), Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      var a = {};
      G.inject(b.active(), a), Object.keys(a).forEach(function(u) {
        r.setRequestHeader(u, String(a[u]));
      });
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this;
      b.with(R.setSpan(b.active(), r), function() {
        var o = i.tracer.startSpan("CORS Preflight", {
          startTime: n[T.FETCH_START]
        });
        zt(o, n, i.getConfig().ignoreNetworkEvents), o.end(n[T.RESPONSE_END]);
      });
    }, t.prototype._addFinalSpanAttributes = function(r, n, i) {
      if (typeof i == "string") {
        var o = it(i);
        n.status !== void 0 && r.setAttribute(Iv, n.status), n.statusText !== void 0 && r.setAttribute(qn.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(Pv, o.host), r.setAttribute(Nv, o.protocol.replace(":", "")), r.setAttribute(Cv, navigator.userAgent);
      }
    }, t.prototype._applyAttributesAfterXHR = function(r, n) {
      var i = this, o = this.getConfig().applyCustomAttributesOnSpan;
      typeof o == "function" && Ev(function() {
        return o(r, n);
      }, function(a) {
        a && i._diag.error("applyCustomAttributesOnSpan", a);
      });
    }, t.prototype._addResourceObserver = function(r, n) {
      var i = this._xhrMem.get(r);
      !i || typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || (i.createdResources = {
        observer: new PerformanceObserver(function(o) {
          var a = o.getEntries(), u = it(n);
          a.forEach(function(c) {
            c.initiatorType === "xmlhttprequest" && c.name === u.href && i.createdResources && i.createdResources.entries.push(c);
          });
        }),
        entries: []
      }, i.createdResources.observer.observe({
        entryTypes: ["resource"]
      }));
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (Te.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i, o, a) {
      if (!(!i || !o || !a || !r.createdResources)) {
        var u = r.createdResources.entries;
        (!u || !u.length) && (u = Te.getEntriesByType("resource"));
        var c = ys(it(i).href, o, a, u, this._usedResources);
        if (c.mainRequest) {
          var s = c.mainRequest;
          this._markResourceAsUsed(s);
          var l = c.corsPreFlightRequest;
          l && (this._addChildSpan(n, l), this._markResourceAsUsed(l)), zt(n, s, this.getConfig().ignoreNetworkEvents);
        }
      }
    }, t.prototype._cleanPreviousSpanInformation = function(r) {
      var n = this._xhrMem.get(r);
      if (n) {
        var i = n.callbackToRemoveEvents;
        i && i(), this._xhrMem.delete(r);
      }
    }, t.prototype._createSpan = function(r, n, i) {
      var o;
      if (Hv(n, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var a = i.toUpperCase(), u = this.tracer.startSpan(a, {
        kind: ye.CLIENT,
        attributes: (o = {}, o[Rv] = i, o[Lv] = it(n).toString(), o)
      });
      return u.addEvent(nt.METHOD_OPEN), this._cleanPreviousSpanInformation(r), this._xhrMem.set(r, {
        span: u,
        spanUrl: n
      }), u;
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._patchOpen = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], u = 0; u < arguments.length; u++)
            a[u] = arguments[u];
          var c = a[0], s = a[1];
          return i._createSpan(this, s, c), n.apply(this, a);
        };
      };
    }, t.prototype._patchSend = function() {
      var r = this;
      function n(l, f, d, p) {
        var _ = f.callbackToRemoveEvents;
        typeof _ == "function" && _();
        var h = f.span, g = f.spanUrl, y = f.sendStartTime;
        h && (r._findResourceAndAddNetworkEvents(f, h, g, y, d), h.addEvent(l, p), r._addFinalSpanAttributes(h, f, g), h.end(p), r._tasksCount--), r._clearResources();
      }
      function i(l, f) {
        var d = r._xhrMem.get(f);
        if (d) {
          d.status = f.status, d.statusText = f.statusText, r._xhrMem.delete(f), d.span && r._applyAttributesAfterXHR(d.span, f);
          var p = Oo(), _ = Date.now();
          setTimeout(function() {
            n(l, d, p, _);
          }, Wv);
        }
      }
      function o() {
        i(nt.EVENT_ERROR, this);
      }
      function a() {
        i(nt.EVENT_ABORT, this);
      }
      function u() {
        i(nt.EVENT_TIMEOUT, this);
      }
      function c() {
        this.status < 299 ? i(nt.EVENT_LOAD, this) : i(nt.EVENT_ERROR, this);
      }
      function s(l) {
        l.removeEventListener("abort", a), l.removeEventListener("error", o), l.removeEventListener("load", c), l.removeEventListener("timeout", u);
        var f = r._xhrMem.get(l);
        f && (f.callbackToRemoveEvents = void 0);
      }
      return function(l) {
        return function() {
          for (var d = this, p = [], _ = 0; _ < arguments.length; _++)
            p[_] = arguments[_];
          var h = r._xhrMem.get(this);
          if (!h)
            return l.apply(this, p);
          var g = h.span, y = h.spanUrl;
          if (g && y) {
            if (r.getConfig().measureRequestSize && (p != null && p[0])) {
              var m = p[0], A = Xv(m);
              A !== void 0 && g.setAttribute(Mv, A);
            }
            b.with(R.setSpan(b.active(), g), function() {
              r._tasksCount++, h.sendStartTime = Oo(), g.addEvent(nt.METHOD_SEND), d.addEventListener("abort", a), d.addEventListener("error", o), d.addEventListener("load", c), d.addEventListener("timeout", u), h.callbackToRemoveEvents = function() {
                s(d), h.createdResources && h.createdResources.observer.disconnect();
              }, r._addHeaders(d, y), r._addResourceObserver(d, y);
            });
          }
          return l.apply(this, p);
        };
      };
    }, t.prototype.enable = function() {
      this._diag.debug("applying patch to", this.moduleName, this.version), mo(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), mo(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
    }, t.prototype.disable = function() {
      this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
    }, t;
  }(yv)
), Jv = "service.name", Zv = "telemetry.sdk.name", Qv = "telemetry.sdk.language", tg = "telemetry.sdk.version", eg = Jv, wo = Zv, Ro = Qv, Lo = tg;
function rg() {
  return "unknown_service";
}
var lt = function() {
  return lt = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, lt.apply(this, arguments);
}, ng = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, ig = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, og = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Kn = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this, i;
      this._attributes = t, this.asyncAttributesPending = r != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = r == null ? void 0 : r.then(function(o) {
        return n._attributes = Object.assign({}, n._attributes, o), n.asyncAttributesPending = !1, o;
      }, function(o) {
        return v.debug("a resource's async attributes promise rejected: %s", o), n.asyncAttributesPending = !1, {};
      });
    }
    return e.empty = function() {
      return e.EMPTY;
    }, e.default = function() {
      var t;
      return new e((t = {}, t[eg] = rg(), t[Ro] = Fr[Ro], t[wo] = Fr[wo], t[Lo] = Fr[Lo], t));
    }, Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var t;
        return this.asyncAttributesPending && v.error("Accessing resource attributes before async attributes settled"), (t = this._attributes) !== null && t !== void 0 ? t : {};
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.waitForAsyncAttributes = function() {
      return ng(this, void 0, void 0, function() {
        return ig(this, function(t) {
          switch (t.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.merge = function(t) {
      var r = this, n;
      if (!t)
        return this;
      var i = lt(lt({}, this._syncAttributes), (n = t._syncAttributes) !== null && n !== void 0 ? n : t.attributes);
      if (!this._asyncAttributesPromise && !t._asyncAttributesPromise)
        return new e(i);
      var o = Promise.all([
        this._asyncAttributesPromise,
        t._asyncAttributesPromise
      ]).then(function(a) {
        var u, c = og(a, 2), s = c[0], l = c[1];
        return lt(lt(lt(lt({}, r._syncAttributes), s), (u = t._syncAttributes) !== null && u !== void 0 ? u : t.attributes), l);
      });
      return new e(i, o);
    }, e.EMPTY = new e({}), e;
  }()
);
const an = /\b(query|mutation|subscription)\b\s*([A-Za-z_]\w*)?/g;
function ag(e) {
  var s;
  const t = ug(e);
  if (t === null || typeof t != "object")
    return null;
  const r = Array.isArray(t) ? t[0] : t;
  if (!r || typeof r != "object")
    return null;
  const n = r, i = typeof n.query == "string" ? n.query : void 0, o = typeof n.operationName == "string" ? n.operationName : void 0;
  if (i === void 0 && o === void 0)
    return null;
  const a = i ? sg(i, o) : null, u = (s = a == null ? void 0 : a[1]) != null ? s : cg(i), c = o != null ? o : a == null ? void 0 : a[2];
  return c === void 0 && u === void 0 ? null : { name: c, type: u };
}
function sg(e, t) {
  an.lastIndex = 0;
  let r = null;
  for (let n = an.exec(e); n !== null; n = an.exec(e)) {
    if (t === void 0 || n[2] === t)
      return n;
    r === null && (r = n);
  }
  return r;
}
function ug(e) {
  if (e == null)
    return null;
  if (typeof e == "object")
    return e;
  if (typeof e != "string")
    return null;
  try {
    return JSON.parse(e);
  } catch (t) {
    return null;
  }
}
function cg(e) {
  if (e !== void 0 && /^\s*\{/.test(e))
    return "query";
}
const lg = 0, Po = 2e3;
class fg {
  /**
   * @param windowMillis The dedupe window in milliseconds. A value of `0` (or
   * negative) disables deduplication, so every exposure is recorded.
   * @param maxSize The maximum number of exposure keys to track. When exceeded,
   * the least recently recorded keys are evicted. A value of `0` (or negative)
   * falls back to the default.
   */
  constructor(t = lg, r = Po) {
    this.lastRecordedAt = /* @__PURE__ */ new Map(), this.windowMillis = t, this.maxSize = r > 0 ? r : Po;
  }
  /**
   * Returns `true` if an exposure for the given key should be recorded (i.e. no
   * exposure for the same key was recorded within the window). Returns `false`
   * if it should be suppressed.
   *
   * This is a pure query and does NOT update the window. Call
   * {@link markRecorded} only after the exposure has actually been emitted, so
   * that a failure to emit doesn't suppress subsequent exposures.
   *
   * @param key A stable key identifying the exposure (e.g. flag key, value,
   * variation, reason, and context).
   * @param now The current time in milliseconds. Defaults to `Date.now()`.
   */
  shouldRecord(t, r = Date.now()) {
    if (this.windowMillis <= 0)
      return !0;
    const n = this.lastRecordedAt.get(t);
    return n === void 0 || n <= r - this.windowMillis;
  }
  /**
   * Marks an exposure for the given key as recorded at `now`, starting a new
   * dedupe window. Call this only after the exposure has been successfully
   * emitted.
   *
   * @param key A stable key identifying the exposure.
   * @param now The current time in milliseconds. Defaults to `Date.now()`.
   */
  markRecorded(t, r = Date.now()) {
    if (!(this.windowMillis <= 0))
      for (this.lastRecordedAt.delete(t), this.lastRecordedAt.set(t, r); this.lastRecordedAt.size > this.maxSize; ) {
        const n = this.lastRecordedAt.keys().next().value;
        if (n === void 0)
          break;
        this.lastRecordedAt.delete(n);
      }
  }
  /**
   * Clears all recorded exposures. Call when the evaluation context changes
   * (e.g. after `identify`).
   */
  reset() {
    this.lastRecordedAt.clear();
  }
}
const No = (e, t, r) => {
  const n = Er(
    t,
    e.headers,
    r
  );
  return C(E({}, e), {
    headers: n
  });
}, Er = (e, t, r) => {
  var i, o;
  const n = E({}, t);
  return r ? ((i = Object.keys(n)) == null || i.forEach((a) => {
    [...r].includes(a == null ? void 0 : a.toLowerCase()) || (n[a] = "[REDACTED]");
  }), n) : ((o = Object.keys(n)) == null || o.forEach((a) => {
    [...dg, ...e].includes(
      a == null ? void 0 : a.toLowerCase()
    ) && (n[a] = "[REDACTED]");
  }), n);
}, dg = [
  "authorization",
  "cookie",
  "proxy-authorization",
  "set-cookie",
  "token"
], pg = [
  "https://www.googleapis.com/identitytoolkit",
  "https://securetoken.googleapis.com"
], hg = [
  "awsaccesskeyid",
  "signature",
  "sig",
  "x-goog-signature",
  "access_token",
  "id_token",
  "token",
  "code",
  "refresh_token",
  "session_state"
], _g = [
  "access_token",
  "id_token",
  "token",
  "code",
  "refresh_token",
  "session_state"
], Ls = (e) => {
  var t, r;
  try {
    return new URL(e);
  } catch (n) {
    return new URL(e, (r = (t = globalThis.location) == null ? void 0 : t.origin) != null ? r : "http://example.com");
  }
}, vg = (e) => {
  if (!e || e === "#") return "";
  const t = e.slice(1);
  if (!t.includes("=")) return e;
  const r = t.indexOf("?"), n = r >= 0 ? t.slice(r + 1) : t, i = new URLSearchParams(n);
  for (const o of i.keys())
    if (_g.includes(o.toLowerCase()))
      return "";
  return e;
}, Wn = (e) => {
  try {
    const t = Ls(e);
    (t.username || t.password) && (t.username = "REDACTED", t.password = "REDACTED");
    const r = t.searchParams;
    hg.forEach((i) => {
      for (const o of Array.from(r.keys()))
        o.toLowerCase() === i && r.set(o, "REDACTED");
    });
    const n = vg(t.hash);
    if (t.hash = n, !e.includes("://") && !e.startsWith("//"))
      return t.pathname + t.search + n;
    if (e.startsWith("//")) {
      let i = "//";
      return (t.username || t.password) && (i += t.username + ":" + t.password + "@"), i += t.host + t.pathname + t.search + n, i;
    }
    return t.toString();
  } catch (t) {
    return e;
  }
}, gg = new RegExp("sdk\\/evalx\\/[^/]+\\/contexts\\/(?<context>[^/?]*)\\??.*?"), yg = new RegExp("\\/eval\\/[^/]+\\/(?<context>[^/?]*)\\??.*?");
function Eg(e) {
  return !!(e.includes("/sdk/evalx") && e.match(gg) || e.includes("/eval/") && e.match(yg));
}
const Ps = "X-Highlight-Request", Io = (e) => {
  let t = e;
  return !e.startsWith("https://") && !e.startsWith("http://") && (t = `${window.location.origin}${t}`), t.replace(/\/+$/, "");
}, mg = (e, {
  headersToRedact: t,
  headersToRecord: r,
  requestResponseSanitizer: n
}) => {
  var c, s;
  let i = e;
  if (n) {
    let f = !0;
    try {
      i.request.body = JSON.parse(i.request.body);
    } catch (p) {
      f = !1;
    }
    let d = !0;
    try {
      i.response.body = JSON.parse(
        i.response.body
      );
    } catch (p) {
      d = !1;
    }
    try {
      i = n(i);
    } catch (p) {
    } finally {
      f = f && !!((c = i == null ? void 0 : i.request) != null && c.body), d = d && !!((s = i == null ? void 0 : i.response) != null && s.body), f && (i.request.body = JSON.stringify(
        i.request.body
      )), d && (i.response.body = JSON.stringify(
        i.response.body
      ));
    }
    if (!i)
      return null;
  }
  const l = i, { request: o, response: a } = l, u = Rr(l, ["request", "response"]);
  return E({
    request: No(o, t, r),
    response: No(a, t, r)
  }, u);
}, XT = (e, t, r, n) => {
  e.sort((c, s) => c.responseEnd - s.responseEnd);
  const i = {
    xmlhttprequest: {},
    others: {},
    fetch: {}
  }, o = e.reduce((c, s) => {
    const l = Io(s.name);
    return s.initiatorType === r ? c[r][l] = [
      ...c[r][l] || [],
      s
    ] : c.others[l] = [
      ...c.others[l] || [],
      s
    ], c;
  }, i);
  let a = {};
  a = t.reduce(
    (c, s) => {
      const l = Io(s.request.url);
      return c[l] = [...c[l] || [], s], c;
    },
    a
  );
  for (let c in o[r]) {
    const s = o[r][c], l = a[c];
    if (!l)
      continue;
    const f = Math.max(
      s.length - l.length,
      0
    );
    for (let d = f; d < s.length; d++)
      s[d] && (s[d].requestResponsePair = l[d - f]);
  }
  let u = [];
  for (let c in o)
    for (let s in o[c])
      u = u.concat(o[c][s]);
  return u.sort((c, s) => c.fetchStart - s.fetchStart).reduce(
    (c, s) => {
      let l = s.requestResponsePair;
      return l && (l = mg(
        s.requestResponsePair,
        n
      ), !l) || (s.toJSON = function() {
        const f = window.performance.timeOrigin;
        return {
          initiatorType: this.initiatorType,
          startTimeAbs: f + this.startTime,
          connectStartAbs: f + this.connectStart,
          connectEndAbs: f + this.connectEnd,
          domainLookupStartAbs: f + this.domainLookupStart,
          domainLookupEndAbs: f + this.domainLookupEnd,
          fetchStartAbs: f + this.fetchStart,
          redirectStartAbs: f + this.redirectStart,
          redirectEndAbs: f + this.redirectEnd,
          requestStartAbs: f + this.requestStart,
          responseStartAbs: f + this.responseStart,
          responseEndAbs: f + this.responseEnd,
          secureConnectionStartAbs: f + this.secureConnectionStart,
          workerStartAbs: f + this.workerStart,
          name: this.name,
          transferSize: this.transferSize,
          encodedBodySize: this.encodedBodySize,
          decodedBodySize: this.decodedBodySize,
          nextHopProtocol: this.nextHopProtocol,
          requestResponsePairs: l
        };
      }, c.push(s)), c;
    },
    []
  );
}, Tg = (e) => ["events.ld.catamorphic.com", "events.launchdarkly.com"].some(
  (t) => e.toLocaleLowerCase().includes(t)
), Sg = (e) => Eg(e), Og = (e, t) => t.some(
  (r) => e.toLocaleLowerCase().includes(r)
), pi = (e, t, r) => !Og(e, t) && !Sg(e) && !Tg(e), hi = (e, t, r) => {
  var a;
  if (r.some(
    (u) => e.toLowerCase().includes(u)
  ))
    return !1;
  let n = [];
  t === !0 ? (n = ["localhost", /^\//], (a = window == null ? void 0 : window.location) != null && a.host && n.push(Ns(window.location.host))) : t instanceof Array && (n = t);
  const i = Ag(e);
  let o = !1;
  return n.forEach((u) => {
    i.match(u) && (o = !0);
  }), o;
}, bg = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), Ns = (e) => new RegExp("^https?://([^/]+\\.)?" + bg(e) + "([:/?#]|$)"), Ag = (e) => {
  if (e.startsWith("/") && !e.startsWith("//"))
    return e;
  try {
    return new URL(e).origin;
  } catch (t) {
    return e;
  }
};
function wg(e) {
  for (var t = "", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = r.length, i = 0; i < e; i++)
    t += r.charAt(
      Math.floor(Math.random() * n)
    );
  return t;
}
const Is = () => {
  const e = wg(10), t = Vm(), r = t == null ? void 0 : t.spanContext().traceId;
  return [ut(), r != null ? r : e];
}, Cs = (e, t) => e + "/" + t, zT = (e, t, r, n, i, o) => {
  const a = XMLHttpRequest.prototype, u = a.open, c = a.send, s = a.setRequestHeader;
  return a.open = function(l, f) {
    return typeof f == "string" ? this._url = f : this._url = f.toString(), this._method = l, this._requestHeaders = {}, this._shouldRecordHeaderAndBody = !n.some(
      (d) => this._url.toLowerCase().includes(d)
    ), u.apply(this, arguments);
  }, a.setRequestHeader = function(l, f) {
    return this._requestHeaders[l] = f, s.apply(this, arguments);
  }, a.send = function(l) {
    if (!pi(
      this._url,
      t
    ))
      return c.apply(this, arguments);
    const [f, d] = Is();
    hi(
      this._url,
      r,
      n
    ) && this.setRequestHeader(
      Ps,
      Cs(f, d)
    );
    const p = this._shouldRecordHeaderAndBody, _ = {
      sessionSecureID: f,
      id: d,
      url: this._url,
      verb: this._method,
      headers: p ? this._requestHeaders : {},
      body: void 0
    };
    if (p && l) {
      const h = Co(l, _.url);
      h && (this._body = h, _.body = ot(
        h,
        i,
        o,
        _.headers
      ));
    }
    return this.addEventListener("load", function() {
      return B(this, null, function* () {
        const h = {
          status: this.status,
          headers: {},
          body: void 0
        };
        if (p) {
          const m = this.getAllResponseHeaders().trim().split(/[\r\n]+/), A = {};
          if (m.forEach(function(w) {
            const L = w.split(": "), I = L.shift();
            A[I] = L.join(": ");
          }), h.headers = A, l) {
            const w = Co(l, _.url);
            w && (_.body = ot(
              w,
              i,
              o,
              h.headers
            ));
          }
          if (this.responseType === "" || this.responseType === "text")
            h.body = ot(
              this.responseText,
              i,
              o,
              h.headers
            ), h.size = this.responseText.length * 8;
          else if (this.responseType === "blob") {
            if (this.response instanceof Blob)
              try {
                const w = yield this.response.text();
                h.body = ot(
                  w,
                  i,
                  o,
                  h.headers
                ), h.size = this.response.size;
              } catch (w) {
              }
          } else
            try {
              h.body = ot(
                this.response,
                i,
                o,
                h.headers
              );
            } catch (w) {
            }
        }
        e({
          request: _,
          response: h,
          urlBlocked: !p
        });
      });
    }), this.addEventListener("error", function() {
      return B(this, null, function* () {
        const h = {
          status: this.status,
          headers: void 0,
          body: void 0
        };
        e({
          request: _,
          response: h,
          urlBlocked: !1
        });
      });
    }), c.apply(this, arguments);
  }, () => {
    a.open = u, a.send = c, a.setRequestHeader = s;
  };
}, Co = (e, t) => {
  if (typeof e == "string") {
    if (!((t != null && t.includes("localhost") || t != null && t.includes("highlight.run")) && (e.includes("pushPayload") || e.includes("pushSessionEvents"))))
      return e;
  } else if (typeof e == "object" || typeof e == "number" || typeof e == "boolean")
    return _e(e);
  return null;
}, Mo = 64 * 1024, Rg = {
  "application/json": 64 * 1024 * 1024,
  // MB
  "text/plain": 64 * 1024 * 1024
  // MB
}, ot = (e, t, r, n) => {
  var o, a, u;
  let i = Mo;
  if (n) {
    let c = "";
    typeof n.get == "function" ? c = (o = n.get("content-type")) != null ? o : "" : c = (a = n["content-type"]) != null ? a : "";
    try {
      c = c.split(";")[0];
    } catch (s) {
    }
    i = (u = Rg[c]) != null ? u : Mo;
  }
  if (e) {
    if (t)
      try {
        const c = JSON.parse(e);
        Array.isArray(c) ? c.forEach((s) => {
          Object.keys(s).forEach((l) => {
            t.includes(
              l.toLocaleLowerCase()
            ) && (s[l] = "[REDACTED]");
          });
        }) : Object.keys(c).forEach((s) => {
          t.includes(s.toLocaleLowerCase()) && (c[s] = "[REDACTED]");
        }), e = JSON.stringify(c);
      } catch (c) {
      }
    if (r)
      try {
        const c = JSON.parse(e);
        Object.keys(c).forEach((s) => {
          r.includes(s.toLocaleLowerCase()) || (c[s] = "[REDACTED]");
        }), e = JSON.stringify(c);
      } catch (c) {
      }
  }
  try {
    e = e.slice(0, i);
  } catch (c) {
  }
  return e;
}, qT = (e, t, r, n, i, o) => {
  const a = window._fetchProxy;
  return window._fetchProxy = function(u, c) {
    const { method: s, url: l } = Lg(u, c);
    if (!pi(
      l,
      t
    ))
      return a.call(this, u, c);
    const [f, d] = Is();
    if (hi(l, r, n)) {
      c = c || {};
      let g = new Headers(c.headers);
      u instanceof Request && [...u.headers].forEach(
        ([y, m]) => g.set(y, m)
      ), g.set(
        Ps,
        Cs(f, d)
      ), c.headers = Object.fromEntries(g.entries());
    }
    const p = {
      sessionSecureID: f,
      id: d,
      headers: {},
      body: void 0,
      url: l,
      verb: s
    }, _ = !n.some(
      (g) => l.toLowerCase().includes(g)
    );
    _ && (p.headers = Object.fromEntries(
      new Headers(c == null ? void 0 : c.headers).entries()
    ), p.body = ot(
      c == null ? void 0 : c.body,
      i,
      o,
      c == null ? void 0 : c.headers
    ));
    let h = a.call(this, u, c);
    return Pg(
      h,
      p,
      e,
      _,
      i,
      o
    ), h;
  }, () => {
    window._fetchProxy = a;
  };
}, Lg = (e, t) => {
  const r = t && t.method || typeof e == "object" && "method" in e && e.method || "GET";
  let n;
  return typeof e == "object" ? "url" in e && e.url ? n = e.url : n = e.toString() : n = e, {
    method: r,
    url: n
  };
}, Pg = (e, t, r, n, i, o) => {
  const a = (u) => B(void 0, null, function* () {
    let c = {
      body: void 0,
      headers: void 0,
      status: 0,
      size: 0
    }, s = !1, l = !n;
    "stack" in u || u instanceof Error ? (c = C(E({}, c), {
      body: u.message,
      status: 0,
      size: void 0
    }), s = !0) : "status" in u && (c = C(E({}, c), {
      status: u.status
    }), n && (c.body = yield Ms(
      u,
      o,
      i
    ), c.headers = Object.fromEntries(
      u.headers.entries()
    ), c.size = c.body.length * 8), (u.type === "opaque" || u.type === "opaqueredirect") && (l = !0, c = C(E({}, c), {
      body: "CORS blocked request"
    })), s = !0), s && r({
      request: t,
      response: c,
      urlBlocked: l
    });
  });
  e.then(a).catch(() => {
  });
}, Ms = (e, t, r) => B(void 0, null, function* () {
  let n;
  try {
    const o = e.clone().body;
    if (o) {
      let a = o.getReader(), u = new TextDecoder(), c, s = "";
      for (; !(c = yield a.read()).done; ) {
        let l = c.value;
        s += u.decode(l);
      }
      n = s, n = ot(
        n,
        r,
        t,
        e.headers
      );
    } else
      n = "";
  } catch (i) {
    n = `Unable to clone response: ${i}`;
  }
  return n;
});
var xs = (
  /** @class */
  function() {
    function e(t) {
      this._delegate = t;
    }
    return e.prototype.export = function(t, r) {
      this._delegate.export(t, r);
    }, e.prototype.forceFlush = function() {
      return this._delegate.forceFlush();
    }, e.prototype.shutdown = function() {
      return this._delegate.shutdown();
    }, e;
  }()
), Ng = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), xo = (
  /** @class */
  function(e) {
    Ng(t, e);
    function t(r, n, i) {
      var o = e.call(this, r) || this;
      return o.name = "OTLPExporterError", o.data = i, o.code = n, o;
    }
    return t;
  }(Error)
);
function Ig(e) {
  if (!Number.isNaN(e) && Number.isFinite(e) && e > 0)
    return e;
  throw new Error("Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '" + e + "')");
}
function Cg(e) {
  if (e != null)
    return function() {
      return e;
    };
}
function Mg(e, t, r) {
  var n, i, o, a, u, c;
  return {
    timeoutMillis: Ig((i = (n = e.timeoutMillis) !== null && n !== void 0 ? n : t.timeoutMillis) !== null && i !== void 0 ? i : r.timeoutMillis),
    concurrencyLimit: (a = (o = e.concurrencyLimit) !== null && o !== void 0 ? o : t.concurrencyLimit) !== null && a !== void 0 ? a : r.concurrencyLimit,
    compression: (c = (u = e.compression) !== null && u !== void 0 ? u : t.compression) !== null && c !== void 0 ? c : r.compression
  };
}
function xg() {
  return {
    timeoutMillis: 1e4,
    concurrencyLimit: 30,
    compression: "none"
  };
}
var Dg = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Ug = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Bg = (
  /** @class */
  function() {
    function e(t) {
      this._sendingPromises = [], this._concurrencyLimit = t;
    }
    return e.prototype.pushPromise = function(t) {
      var r = this;
      if (this.hasReachedLimit())
        throw new Error("Concurrency Limit reached");
      this._sendingPromises.push(t);
      var n = function() {
        var i = r._sendingPromises.indexOf(t);
        r._sendingPromises.splice(i, 1);
      };
      t.then(n, n);
    }, e.prototype.hasReachedLimit = function() {
      return this._sendingPromises.length >= this._concurrencyLimit;
    }, e.prototype.awaitAll = function() {
      return Dg(this, void 0, void 0, function() {
        return Ug(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, Promise.all(this._sendingPromises)];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function kg(e) {
  return new Bg(e.concurrencyLimit);
}
function Gg(e) {
  return Object.prototype.hasOwnProperty.call(e, "partialSuccess");
}
function $g() {
  return {
    handleResponse: function(e) {
      e == null || !Gg(e) || e.partialSuccess == null || Object.keys(e.partialSuccess).length === 0 || v.warn("Received Partial Success response:", JSON.stringify(e.partialSuccess));
    }
  };
}
var Hg = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, jg = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Vg = (
  /** @class */
  function() {
    function e(t, r, n, i, o) {
      this._transport = t, this._serializer = r, this._responseHandler = n, this._promiseQueue = i, this._timeout = o, this._diagLogger = v.createComponentLogger({
        namespace: "OTLPExportDelegate"
      });
    }
    return e.prototype.export = function(t, r) {
      var n = this;
      if (this._diagLogger.debug("items to be sent", t), this._promiseQueue.hasReachedLimit()) {
        r({
          code: N.FAILED,
          error: new Error("Concurrent export limit reached")
        });
        return;
      }
      var i = this._serializer.serializeRequest(t);
      if (i == null) {
        r({
          code: N.FAILED,
          error: new Error("Nothing to send")
        });
        return;
      }
      this._promiseQueue.pushPromise(this._transport.send(i, this._timeout).then(function(o) {
        if (o.status === "success") {
          if (o.data != null)
            try {
              n._responseHandler.handleResponse(n._serializer.deserializeResponse(o.data));
            } catch (a) {
              n._diagLogger.warn("Export succeeded but could not deserialize response - is the response specification compliant?", a, o.data);
            }
          r({
            code: N.SUCCESS
          });
          return;
        } else if (o.status === "failure" && o.error) {
          r({
            code: N.FAILED,
            error: o.error
          });
          return;
        } else o.status === "retryable" ? r({
          code: N.FAILED,
          error: new xo("Export failed with retryable status")
        }) : r({
          code: N.FAILED,
          error: new xo("Export failed with unknown error")
        });
      }, function(o) {
        return r({
          code: N.FAILED,
          error: o
        });
      }));
    }, e.prototype.forceFlush = function() {
      return this._promiseQueue.awaitAll();
    }, e.prototype.shutdown = function() {
      return Hg(this, void 0, void 0, function() {
        return jg(this, function(t) {
          switch (t.label) {
            case 0:
              return this._diagLogger.debug("shutdown started"), [4, this.forceFlush()];
            case 1:
              return t.sent(), this._transport.shutdown(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function Fg(e, t) {
  return new Vg(e.transport, e.serializer, $g(), e.promiseHandler, t.timeout);
}
function Ds(e, t, r) {
  return Fg({
    transport: r,
    serializer: t,
    promiseHandler: kg(e)
  }, { timeout: e.timeoutMillis });
}
function Us(e) {
  var t = BigInt(1e9);
  return BigInt(e[0]) * t + BigInt(e[1]);
}
function Xg(e) {
  var t = Number(BigInt.asUintN(32, e)), r = Number(BigInt.asUintN(32, e >> BigInt(32)));
  return { low: t, high: r };
}
function Bs(e) {
  var t = Us(e);
  return Xg(t);
}
function zg(e) {
  var t = Us(e);
  return t.toString();
}
var qg = typeof BigInt != "undefined" ? zg : kf;
function Do(e) {
  return e;
}
function ks(e) {
  if (e !== void 0)
    return ci(e);
}
var Kg = {
  encodeHrTime: Bs,
  encodeSpanContext: ci,
  encodeOptionalSpanContext: ks
};
function Gs(e) {
  var t, r;
  if (e === void 0)
    return Kg;
  var n = (t = e.useLongBits) !== null && t !== void 0 ? t : !0, i = (r = e.useHex) !== null && r !== void 0 ? r : !1;
  return {
    encodeHrTime: n ? Bs : qg,
    encodeSpanContext: i ? Do : ci,
    encodeOptionalSpanContext: i ? Do : ks
  };
}
var Wg = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function $s(e) {
  return {
    attributes: Pt(e.attributes),
    droppedAttributesCount: 0
  };
}
function Hs(e) {
  return {
    name: e.name,
    version: e.version
  };
}
function Pt(e) {
  return Object.keys(e).map(function(t) {
    return js(t, e[t]);
  });
}
function js(e, t) {
  return {
    key: e,
    value: Vs(t)
  };
}
function Vs(e) {
  var t = typeof e;
  return t === "string" ? { stringValue: e } : t === "number" ? Number.isInteger(e) ? { intValue: e } : { doubleValue: e } : t === "boolean" ? { boolValue: e } : e instanceof Uint8Array ? { bytesValue: e } : Array.isArray(e) ? { arrayValue: { values: e.map(Vs) } } : t === "object" && e != null ? {
    kvlistValue: {
      values: Object.entries(e).map(function(r) {
        var n = Wg(r, 2), i = n[0], o = n[1];
        return js(i, o);
      })
    }
  } : {};
}
var q;
(function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE";
})(q || (q = {}));
var J;
(function(e) {
  e[e.HISTOGRAM = 0] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 1] = "EXPONENTIAL_HISTOGRAM", e[e.GAUGE = 2] = "GAUGE", e[e.SUM = 3] = "SUM";
})(J || (J = {}));
var Yg = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Uo = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Bo = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Jg = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Zg = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Qg = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function ty(e) {
  return e != null;
}
function Fs(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "" : (t = t.sort(), JSON.stringify(t.map(function(r) {
    return [r, e[r]];
  })));
}
function ey(e) {
  var t, r;
  return e.name + ":" + ((t = e.version) !== null && t !== void 0 ? t : "") + ":" + ((r = e.schemaUrl) !== null && r !== void 0 ? r : "");
}
var Xs = (
  /** @class */
  function(e) {
    Yg(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return Object.setPrototypeOf(n, t.prototype), n;
    }
    return t;
  }(Error)
);
function Se(e, t) {
  var r, n = new Promise(function(o, a) {
    r = setTimeout(function() {
      a(new Xs("Operation timed out."));
    }, t);
  });
  return Promise.race([e, n]).then(function(i) {
    return clearTimeout(r), i;
  }, function(i) {
    throw clearTimeout(r), i;
  });
}
function ry(e) {
  return Uo(this, void 0, void 0, function() {
    var t = this;
    return Bo(this, function(r) {
      return [2, Promise.all(e.map(function(n) {
        return Uo(t, void 0, void 0, function() {
          var i, o;
          return Bo(this, function(a) {
            switch (a.label) {
              case 0:
                return a.trys.push([0, 2, , 3]), [4, n];
              case 1:
                return i = a.sent(), [2, {
                  status: "fulfilled",
                  value: i
                }];
              case 2:
                return o = a.sent(), [2, {
                  status: "rejected",
                  reason: o
                }];
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }))];
    });
  });
}
function ny(e) {
  return e.status === "rejected";
}
function ko(e, t) {
  var r = [];
  return e.forEach(function(n) {
    r.push.apply(r, Zg([], Jg(t(n)), !1));
  }), r;
}
function iy(e, t) {
  var r, n;
  if (e.size !== t.size)
    return !1;
  try {
    for (var i = Qg(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (!t.has(a))
        return !1;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !0;
}
function oy(e, t) {
  for (var r = 0, n = e.length - 1, i = e.length; n >= r; ) {
    var o = r + Math.trunc((n - r) / 2);
    e[o] < t ? r = o + 1 : (i = o, n = o - 1);
  }
  return i;
}
function ay(e, t) {
  return e.toLowerCase() === t.toLowerCase();
}
var wt;
(function(e) {
  e[e.DROP = 0] = "DROP", e[e.SUM = 1] = "SUM", e[e.LAST_VALUE = 2] = "LAST_VALUE", e[e.HISTOGRAM = 3] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 4] = "EXPONENTIAL_HISTOGRAM";
})(wt || (wt = {}));
var sy = (
  /** @class */
  function() {
    function e() {
      this.kind = wt.DROP;
    }
    return e.prototype.createAccumulation = function() {
    }, e.prototype.merge = function(t, r) {
    }, e.prototype.diff = function(t, r) {
    }, e.prototype.toMetricData = function(t, r, n, i) {
    }, e;
  }()
), S;
(function(e) {
  e.COUNTER = "COUNTER", e.GAUGE = "GAUGE", e.HISTOGRAM = "HISTOGRAM", e.UP_DOWN_COUNTER = "UP_DOWN_COUNTER", e.OBSERVABLE_COUNTER = "OBSERVABLE_COUNTER", e.OBSERVABLE_GAUGE = "OBSERVABLE_GAUGE", e.OBSERVABLE_UP_DOWN_COUNTER = "OBSERVABLE_UP_DOWN_COUNTER";
})(S || (S = {}));
function st(e, t, r) {
  var n, i, o, a;
  return fy(e) || v.warn('Invalid metric name: "' + e + '". The metric name should be a ASCII string with a length no greater than 255 characters.'), {
    name: e,
    type: t,
    description: (n = r == null ? void 0 : r.description) !== null && n !== void 0 ? n : "",
    unit: (i = r == null ? void 0 : r.unit) !== null && i !== void 0 ? i : "",
    valueType: (o = r == null ? void 0 : r.valueType) !== null && o !== void 0 ? o : _t.DOUBLE,
    advice: (a = r == null ? void 0 : r.advice) !== null && a !== void 0 ? a : {}
  };
}
function uy(e, t) {
  var r, n;
  return {
    name: (r = e.name) !== null && r !== void 0 ? r : t.name,
    description: (n = e.description) !== null && n !== void 0 ? n : t.description,
    type: t.type,
    unit: t.unit,
    valueType: t.valueType,
    advice: t.advice
  };
}
function cy(e, t) {
  return ay(e.name, t.name) && e.unit === t.unit && e.type === t.type && e.valueType === t.valueType;
}
var ly = /^[a-z][a-z0-9_.\-/]{0,254}$/i;
function fy(e) {
  return e.match(ly) != null;
}
var dy = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function py(e) {
  var t = e.map(function() {
    return 0;
  });
  return t.push(0), {
    buckets: {
      boundaries: e,
      counts: t
    },
    sum: 0,
    count: 0,
    hasMinMax: !1,
    min: 1 / 0,
    max: -1 / 0
  };
}
var sn = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      n === void 0 && (n = !0), i === void 0 && (i = py(r)), this.startTime = t, this._boundaries = r, this._recordMinMax = n, this._current = i;
    }
    return e.prototype.record = function(t) {
      if (!Number.isNaN(t)) {
        this._current.count += 1, this._current.sum += t, this._recordMinMax && (this._current.min = Math.min(t, this._current.min), this._current.max = Math.max(t, this._current.max), this._current.hasMinMax = !0);
        var r = oy(this._boundaries, t);
        this._current.buckets.counts[r] += 1;
      }
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), zs = (
  /** @class */
  function() {
    function e(t, r) {
      this._boundaries = t, this._recordMinMax = r, this.kind = wt.HISTOGRAM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new sn(t, this._boundaries, this._recordMinMax);
    }, e.prototype.merge = function(t, r) {
      for (var n = t.toPointValue(), i = r.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = o[c] + a[c];
      var s = 1 / 0, l = -1 / 0;
      return this._recordMinMax && (n.hasMinMax && i.hasMinMax ? (s = Math.min(n.min, i.min), l = Math.max(n.max, i.max)) : n.hasMinMax ? (s = n.min, l = n.max) : i.hasMinMax && (s = i.min, l = i.max)), new sn(t.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: n.count + i.count,
        sum: n.sum + i.sum,
        hasMinMax: this._recordMinMax && (n.hasMinMax || i.hasMinMax),
        min: s,
        max: l
      });
    }, e.prototype.diff = function(t, r) {
      for (var n = t.toPointValue(), i = r.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = a[c] - o[c];
      return new sn(r.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: i.count - n.count,
        sum: i.sum - n.sum,
        hasMinMax: !1,
        min: 1 / 0,
        max: -1 / 0
      });
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: J.HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = dy(o, 2), u = a[0], c = a[1], s = c.toPointValue(), l = t.type === S.GAUGE || t.type === S.UP_DOWN_COUNTER || t.type === S.OBSERVABLE_GAUGE || t.type === S.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: l ? void 0 : s.sum,
              buckets: s.buckets,
              count: s.count
            }
          };
        })
      };
    }, e;
  }()
), un = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, cn = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Go = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      t === void 0 && (t = new hy()), r === void 0 && (r = 0), n === void 0 && (n = 0), i === void 0 && (i = 0), this.backing = t, this.indexBase = r, this.indexStart = n, this.indexEnd = i;
    }
    return Object.defineProperty(e.prototype, "offset", {
      /**
       * Offset is the bucket index of the smallest entry in the counts array
       * @returns {number}
       */
      get: function() {
        return this.indexStart;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "length", {
      /**
       * Buckets is a view into the backing array.
       * @returns {number}
       */
      get: function() {
        return this.backing.length === 0 || this.indexEnd === this.indexStart && this.at(0) === 0 ? 0 : this.indexEnd - this.indexStart + 1;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.counts = function() {
      var t = this;
      return Array.from({ length: this.length }, function(r, n) {
        return t.at(n);
      });
    }, e.prototype.at = function(t) {
      var r = this.indexBase - this.indexStart;
      return t < r && (t += this.backing.length), t -= r, this.backing.countAt(t);
    }, e.prototype.incrementBucket = function(t, r) {
      this.backing.increment(t, r);
    }, e.prototype.decrementBucket = function(t, r) {
      this.backing.decrement(t, r);
    }, e.prototype.trim = function() {
      for (var t = 0; t < this.length; t++)
        if (this.at(t) !== 0) {
          this.indexStart += t;
          break;
        } else if (t === this.length - 1) {
          this.indexStart = this.indexEnd = this.indexBase = 0;
          return;
        }
      for (var t = this.length - 1; t >= 0; t--)
        if (this.at(t) !== 0) {
          this.indexEnd -= this.length - t - 1;
          break;
        }
      this._rotate();
    }, e.prototype.downscale = function(t) {
      this._rotate();
      for (var r = 1 + this.indexEnd - this.indexStart, n = 1 << t, i = 0, o = 0, a = this.indexStart; a <= this.indexEnd; ) {
        var u = a % n;
        u < 0 && (u += n);
        for (var c = u; c < n && i < r; c++)
          this._relocateBucket(o, i), i++, a++;
        o++;
      }
      this.indexStart >>= t, this.indexEnd >>= t, this.indexBase = this.indexStart;
    }, e.prototype.clone = function() {
      return new e(this.backing.clone(), this.indexBase, this.indexStart, this.indexEnd);
    }, e.prototype._rotate = function() {
      var t = this.indexBase - this.indexStart;
      t !== 0 && (t > 0 ? (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, t), this.backing.reverse(t, this.backing.length)) : (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, this.backing.length + t)), this.indexBase = this.indexStart);
    }, e.prototype._relocateBucket = function(t, r) {
      t !== r && this.incrementBucket(t, this.backing.emptyBucket(r));
    }, e;
  }()
), hy = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = [0]), this._counts = t;
    }
    return Object.defineProperty(e.prototype, "length", {
      /**
       * length returns the physical size of the backing array, which
       * is >= buckets.length()
       */
      get: function() {
        return this._counts.length;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.countAt = function(t) {
      return this._counts[t];
    }, e.prototype.growTo = function(t, r, n) {
      var i = new Array(t).fill(0);
      i.splice.apply(i, cn([
        n,
        this._counts.length - r
      ], un(this._counts.slice(r)), !1)), i.splice.apply(i, cn([0, r], un(this._counts.slice(0, r)), !1)), this._counts = i;
    }, e.prototype.reverse = function(t, r) {
      for (var n = Math.floor((t + r) / 2) - t, i = 0; i < n; i++) {
        var o = this._counts[t + i];
        this._counts[t + i] = this._counts[r - i - 1], this._counts[r - i - 1] = o;
      }
    }, e.prototype.emptyBucket = function(t) {
      var r = this._counts[t];
      return this._counts[t] = 0, r;
    }, e.prototype.increment = function(t, r) {
      this._counts[t] += r;
    }, e.prototype.decrement = function(t, r) {
      this._counts[t] >= r ? this._counts[t] -= r : this._counts[t] = 0;
    }, e.prototype.clone = function() {
      return new e(cn([], un(this._counts), !1));
    }, e;
  }()
), _y = 52, vy = 2146435072, gy = 1048575, _i = 1023, qs = -_i + 1, Ks = _i, Yn = Math.pow(2, -1022);
function Ws(e) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, e);
  var r = t.getUint32(0), n = (r & vy) >> 20;
  return n - _i;
}
function Ys(e) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, e);
  var r = t.getUint32(0), n = t.getUint32(4), i = (r & gy) * Math.pow(2, 32);
  return i + n;
}
function Jn(e, t) {
  return e === 0 || e === Number.POSITIVE_INFINITY || e === Number.NEGATIVE_INFINITY || Number.isNaN(e) ? e : e * Math.pow(2, t);
}
function yy(e) {
  return e--, e |= e >> 1, e |= e >> 2, e |= e >> 4, e |= e >> 8, e |= e >> 16, e++, e;
}
var Ey = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Oe = (
  /** @class */
  function(e) {
    Ey(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Error)
), my = (
  /** @class */
  function() {
    function e(t) {
      this._shift = -t;
    }
    return e.prototype.mapToIndex = function(t) {
      if (t < Yn)
        return this._minNormalLowerBoundaryIndex();
      var r = Ws(t), n = this._rightShift(Ys(t) - 1, _y);
      return r + n >> this._shift;
    }, e.prototype.lowerBoundary = function(t) {
      var r = this._minNormalLowerBoundaryIndex();
      if (t < r)
        throw new Oe("underflow: " + t + " is < minimum lower boundary: " + r);
      var n = this._maxNormalLowerBoundaryIndex();
      if (t > n)
        throw new Oe("overflow: " + t + " is > maximum lower boundary: " + n);
      return Jn(1, t << this._shift);
    }, Object.defineProperty(e.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._shift === 0 ? 0 : -this._shift;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._minNormalLowerBoundaryIndex = function() {
      var t = qs >> this._shift;
      return this._shift < 2 && t--, t;
    }, e.prototype._maxNormalLowerBoundaryIndex = function() {
      return Ks >> this._shift;
    }, e.prototype._rightShift = function(t, r) {
      return Math.floor(t * Math.pow(2, -r));
    }, e;
  }()
), Ty = (
  /** @class */
  function() {
    function e(t) {
      this._scale = t, this._scaleFactor = Jn(Math.LOG2E, t), this._inverseFactor = Jn(Math.LN2, -t);
    }
    return e.prototype.mapToIndex = function(t) {
      if (t <= Yn)
        return this._minNormalLowerBoundaryIndex() - 1;
      if (Ys(t) === 0) {
        var r = Ws(t);
        return (r << this._scale) - 1;
      }
      var n = Math.floor(Math.log(t) * this._scaleFactor), i = this._maxNormalLowerBoundaryIndex();
      return n >= i ? i : n;
    }, e.prototype.lowerBoundary = function(t) {
      var r = this._maxNormalLowerBoundaryIndex();
      if (t >= r) {
        if (t === r)
          return 2 * Math.exp((t - (1 << this._scale)) / this._scaleFactor);
        throw new Oe("overflow: " + t + " is > maximum lower boundary: " + r);
      }
      var n = this._minNormalLowerBoundaryIndex();
      if (t <= n) {
        if (t === n)
          return Yn;
        if (t === n - 1)
          return Math.exp((t + (1 << this._scale)) / this._scaleFactor) / 2;
        throw new Oe("overflow: " + t + " is < minimum lower boundary: " + n);
      }
      return Math.exp(t * this._inverseFactor);
    }, Object.defineProperty(e.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._scale;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._minNormalLowerBoundaryIndex = function() {
      return qs << this._scale;
    }, e.prototype._maxNormalLowerBoundaryIndex = function() {
      return (Ks + 1 << this._scale) - 1;
    }, e;
  }()
), $o = -10, Ho = 20, Sy = Array.from({ length: 31 }, function(e, t) {
  return t > 10 ? new Ty(t - 10) : new my(t - 10);
});
function jo(e) {
  if (e > Ho || e < $o)
    throw new Oe("expected scale >= " + $o + " && <= " + Ho + ", got: " + e);
  return Sy[e + 10];
}
var Oy = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, He = (
  /** @class */
  function() {
    function e(t, r) {
      this.low = t, this.high = r;
    }
    return e.combine = function(t, r) {
      return new e(Math.min(t.low, r.low), Math.max(t.high, r.high));
    }, e;
  }()
), by = 20, Ay = 160, ln = 2, wy = (
  /** @class */
  function() {
    function e(t, r, n, i, o, a, u, c, s, l, f) {
      t === void 0 && (t = t), r === void 0 && (r = Ay), n === void 0 && (n = !0), i === void 0 && (i = 0), o === void 0 && (o = 0), a === void 0 && (a = 0), u === void 0 && (u = Number.POSITIVE_INFINITY), c === void 0 && (c = Number.NEGATIVE_INFINITY), s === void 0 && (s = new Go()), l === void 0 && (l = new Go()), f === void 0 && (f = jo(by)), this.startTime = t, this._maxSize = r, this._recordMinMax = n, this._sum = i, this._count = o, this._zeroCount = a, this._min = u, this._max = c, this._positive = s, this._negative = l, this._mapping = f, this._maxSize < ln && (v.warn("Exponential Histogram Max Size set to " + this._maxSize + ",                 changing to the minimum size of: " + ln), this._maxSize = ln);
    }
    return e.prototype.record = function(t) {
      this.updateByIncrement(t, 1);
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return {
        hasMinMax: this._recordMinMax,
        min: this.min,
        max: this.max,
        sum: this.sum,
        positive: {
          offset: this.positive.offset,
          bucketCounts: this.positive.counts()
        },
        negative: {
          offset: this.negative.offset,
          bucketCounts: this.negative.counts()
        },
        count: this.count,
        scale: this.scale,
        zeroCount: this.zeroCount
      };
    }, Object.defineProperty(e.prototype, "sum", {
      /**
       * @returns {Number} The sum of values recorded by this accumulation
       */
      get: function() {
        return this._sum;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "min", {
      /**
       * @returns {Number} The minimum value recorded by this accumulation
       */
      get: function() {
        return this._min;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "max", {
      /**
       * @returns {Number} The maximum value recorded by this accumulation
       */
      get: function() {
        return this._max;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "count", {
      /**
       * @returns {Number} The count of values recorded by this accumulation
       */
      get: function() {
        return this._count;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "zeroCount", {
      /**
       * @returns {Number} The number of 0 values recorded by this accumulation
       */
      get: function() {
        return this._zeroCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "scale", {
      /**
       * @returns {Number} The scale used by this accumulation
       */
      get: function() {
        return this._count === this._zeroCount ? 0 : this._mapping.scale;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "positive", {
      /**
       * positive holds the positive values
       * @returns {Buckets}
       */
      get: function() {
        return this._positive;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "negative", {
      /**
       * negative holds the negative values by their absolute value
       * @returns {Buckets}
       */
      get: function() {
        return this._negative;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.updateByIncrement = function(t, r) {
      if (!Number.isNaN(t)) {
        if (t > this._max && (this._max = t), t < this._min && (this._min = t), this._count += r, t === 0) {
          this._zeroCount += r;
          return;
        }
        this._sum += t * r, t > 0 ? this._updateBuckets(this._positive, t, r) : this._updateBuckets(this._negative, -t, r);
      }
    }, e.prototype.merge = function(t) {
      this._count === 0 ? (this._min = t.min, this._max = t.max) : t.count !== 0 && (t.min < this.min && (this._min = t.min), t.max > this.max && (this._max = t.max)), this.startTime = t.startTime, this._sum += t.sum, this._count += t.count, this._zeroCount += t.zeroCount;
      var r = this._minScale(t);
      this._downscale(this.scale - r), this._mergeBuckets(this.positive, t, t.positive, r), this._mergeBuckets(this.negative, t, t.negative, r);
    }, e.prototype.diff = function(t) {
      this._min = 1 / 0, this._max = -1 / 0, this._sum -= t.sum, this._count -= t.count, this._zeroCount -= t.zeroCount;
      var r = this._minScale(t);
      this._downscale(this.scale - r), this._diffBuckets(this.positive, t, t.positive, r), this._diffBuckets(this.negative, t, t.negative, r);
    }, e.prototype.clone = function() {
      return new e(this.startTime, this._maxSize, this._recordMinMax, this._sum, this._count, this._zeroCount, this._min, this._max, this.positive.clone(), this.negative.clone(), this._mapping);
    }, e.prototype._updateBuckets = function(t, r, n) {
      var i = this._mapping.mapToIndex(r), o = !1, a = 0, u = 0;
      if (t.length === 0 ? (t.indexStart = i, t.indexEnd = t.indexStart, t.indexBase = t.indexStart) : i < t.indexStart && t.indexEnd - i >= this._maxSize ? (o = !0, u = i, a = t.indexEnd) : i > t.indexEnd && i - t.indexStart >= this._maxSize && (o = !0, u = t.indexStart, a = i), o) {
        var c = this._changeScale(a, u);
        this._downscale(c), i = this._mapping.mapToIndex(r);
      }
      this._incrementIndexBy(t, i, n);
    }, e.prototype._incrementIndexBy = function(t, r, n) {
      if (n !== 0) {
        if (t.length === 0 && (t.indexStart = t.indexEnd = t.indexBase = r), r < t.indexStart) {
          var i = t.indexEnd - r;
          i >= t.backing.length && this._grow(t, i + 1), t.indexStart = r;
        } else if (r > t.indexEnd) {
          var i = r - t.indexStart;
          i >= t.backing.length && this._grow(t, i + 1), t.indexEnd = r;
        }
        var o = r - t.indexBase;
        o < 0 && (o += t.backing.length), t.incrementBucket(o, n);
      }
    }, e.prototype._grow = function(t, r) {
      var n = t.backing.length, i = t.indexBase - t.indexStart, o = n - i, a = yy(r);
      a > this._maxSize && (a = this._maxSize);
      var u = a - i;
      t.backing.growTo(a, o, u);
    }, e.prototype._changeScale = function(t, r) {
      for (var n = 0; t - r >= this._maxSize; )
        t >>= 1, r >>= 1, n++;
      return n;
    }, e.prototype._downscale = function(t) {
      if (t !== 0) {
        if (t < 0)
          throw new Error("impossible change of scale: " + this.scale);
        var r = this._mapping.scale - t;
        this._positive.downscale(t), this._negative.downscale(t), this._mapping = jo(r);
      }
    }, e.prototype._minScale = function(t) {
      var r = Math.min(this.scale, t.scale), n = He.combine(this._highLowAtScale(this.positive, this.scale, r), this._highLowAtScale(t.positive, t.scale, r)), i = He.combine(this._highLowAtScale(this.negative, this.scale, r), this._highLowAtScale(t.negative, t.scale, r));
      return Math.min(r - this._changeScale(n.high, n.low), r - this._changeScale(i.high, i.low));
    }, e.prototype._highLowAtScale = function(t, r, n) {
      if (t.length === 0)
        return new He(0, -1);
      var i = r - n;
      return new He(t.indexStart >> i, t.indexEnd >> i);
    }, e.prototype._mergeBuckets = function(t, r, n, i) {
      for (var o = n.offset, a = r.scale - i, u = 0; u < n.length; u++)
        this._incrementIndexBy(t, o + u >> a, n.at(u));
    }, e.prototype._diffBuckets = function(t, r, n, i) {
      for (var o = n.offset, a = r.scale - i, u = 0; u < n.length; u++) {
        var c = o + u >> a, s = c - t.indexBase;
        s < 0 && (s += t.backing.length), t.decrementBucket(s, n.at(u));
      }
      t.trim();
    }, e;
  }()
), Ry = (
  /** @class */
  function() {
    function e(t, r) {
      this._maxSize = t, this._recordMinMax = r, this.kind = wt.EXPONENTIAL_HISTOGRAM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new wy(t, this._maxSize, this._recordMinMax);
    }, e.prototype.merge = function(t, r) {
      var n = r.clone();
      return n.merge(t), n;
    }, e.prototype.diff = function(t, r) {
      var n = r.clone();
      return n.diff(t), n;
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: J.EXPONENTIAL_HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = Oy(o, 2), u = a[0], c = a[1], s = c.toPointValue(), l = t.type === S.GAUGE || t.type === S.UP_DOWN_COUNTER || t.type === S.OBSERVABLE_GAUGE || t.type === S.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: l ? void 0 : s.sum,
              positive: {
                offset: s.positive.offset,
                bucketCounts: s.positive.bucketCounts
              },
              negative: {
                offset: s.negative.offset,
                bucketCounts: s.negative.bucketCounts
              },
              count: s.count,
              scale: s.scale,
              zeroCount: s.zeroCount
            }
          };
        })
      };
    }, e;
  }()
), Ly = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, fn = (
  /** @class */
  function() {
    function e(t, r, n) {
      r === void 0 && (r = 0), n === void 0 && (n = [0, 0]), this.startTime = t, this._current = r, this.sampleTime = n;
    }
    return e.prototype.record = function(t) {
      this._current = t, this.sampleTime = Ee(Date.now());
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), Py = (
  /** @class */
  function() {
    function e() {
      this.kind = wt.LAST_VALUE;
    }
    return e.prototype.createAccumulation = function(t) {
      return new fn(t);
    }, e.prototype.merge = function(t, r) {
      var n = xe(r.sampleTime) >= xe(t.sampleTime) ? r : t;
      return new fn(t.startTime, n.toPointValue(), n.sampleTime);
    }, e.prototype.diff = function(t, r) {
      var n = xe(r.sampleTime) >= xe(t.sampleTime) ? r : t;
      return new fn(r.startTime, n.toPointValue(), n.sampleTime);
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: J.GAUGE,
        dataPoints: n.map(function(o) {
          var a = Ly(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        })
      };
    }, e;
  }()
), Ny = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ce = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      n === void 0 && (n = 0), i === void 0 && (i = !1), this.startTime = t, this.monotonic = r, this._current = n, this.reset = i;
    }
    return e.prototype.record = function(t) {
      this.monotonic && t < 0 || (this._current += t);
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), Vo = (
  /** @class */
  function() {
    function e(t) {
      this.monotonic = t, this.kind = wt.SUM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new ce(t, this.monotonic);
    }, e.prototype.merge = function(t, r) {
      var n = t.toPointValue(), i = r.toPointValue();
      return r.reset ? new ce(r.startTime, this.monotonic, i, r.reset) : new ce(t.startTime, this.monotonic, n + i);
    }, e.prototype.diff = function(t, r) {
      var n = t.toPointValue(), i = r.toPointValue();
      return this.monotonic && n > i ? new ce(r.startTime, this.monotonic, i, !0) : new ce(r.startTime, this.monotonic, i - n);
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: J.SUM,
        dataPoints: n.map(function(o) {
          var a = Ny(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        }),
        isMonotonic: this.monotonic
      };
    }, e;
  }()
), Nt = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), at = (
  /** @class */
  function() {
    function e() {
    }
    return e.Drop = function() {
      return Js;
    }, e.Sum = function() {
      return Zs;
    }, e.LastValue = function() {
      return Qs;
    }, e.Histogram = function() {
      return tu;
    }, e.ExponentialHistogram = function() {
      return ky;
    }, e.Default = function() {
      return Gy;
    }, e;
  }()
), Iy = (
  /** @class */
  function(e) {
    Nt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new sy(), t;
  }(at)
), Cy = (
  /** @class */
  function(e) {
    Nt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      switch (r.type) {
        case S.COUNTER:
        case S.OBSERVABLE_COUNTER:
        case S.HISTOGRAM:
          return t.MONOTONIC_INSTANCE;
        default:
          return t.NON_MONOTONIC_INSTANCE;
      }
    }, t.MONOTONIC_INSTANCE = new Vo(!0), t.NON_MONOTONIC_INSTANCE = new Vo(!1), t;
  }(at)
), My = (
  /** @class */
  function(e) {
    Nt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new Py(), t;
  }(at)
), xy = (
  /** @class */
  function(e) {
    Nt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new zs([0, 5, 10, 25, 50, 75, 100, 250, 500, 750, 1e3, 2500, 5e3, 7500, 1e4], !0), t;
  }(at)
), Dy = (
  /** @class */
  function(e) {
    Nt(t, e);
    function t(r, n) {
      n === void 0 && (n = !0);
      var i = e.call(this) || this;
      if (i._recordMinMax = n, r == null)
        throw new Error("ExplicitBucketHistogramAggregation should be created with explicit boundaries, if a single bucket histogram is required, please pass an empty array");
      r = r.concat(), r = r.sort(function(u, c) {
        return u - c;
      });
      var o = r.lastIndexOf(-1 / 0), a = r.indexOf(1 / 0);
      return a === -1 && (a = void 0), i._boundaries = r.slice(o + 1, a), i;
    }
    return t.prototype.createAggregator = function(r) {
      return new zs(this._boundaries, this._recordMinMax);
    }, t;
  }(at)
), Uy = (
  /** @class */
  function(e) {
    Nt(t, e);
    function t(r, n) {
      r === void 0 && (r = 160), n === void 0 && (n = !0);
      var i = e.call(this) || this;
      return i._maxSize = r, i._recordMinMax = n, i;
    }
    return t.prototype.createAggregator = function(r) {
      return new Ry(this._maxSize, this._recordMinMax);
    }, t;
  }(at)
), By = (
  /** @class */
  function(e) {
    Nt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype._resolve = function(r) {
      switch (r.type) {
        case S.COUNTER:
        case S.UP_DOWN_COUNTER:
        case S.OBSERVABLE_COUNTER:
        case S.OBSERVABLE_UP_DOWN_COUNTER:
          return Zs;
        case S.GAUGE:
        case S.OBSERVABLE_GAUGE:
          return Qs;
        case S.HISTOGRAM:
          return r.advice.explicitBucketBoundaries ? new Dy(r.advice.explicitBucketBoundaries) : tu;
      }
      return v.warn("Unable to recognize instrument type: " + r.type), Js;
    }, t.prototype.createAggregator = function(r) {
      return this._resolve(r).createAggregator(r);
    }, t;
  }(at)
), Js = new Iy(), Zs = new Cy(), Qs = new My(), tu = new xy(), ky = new Uy(), Gy = new By(), $y = function(e) {
  return at.Default();
}, Hy = function(e) {
  return q.CUMULATIVE;
}, dn = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, pn = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Fo = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, jy = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Vy = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i;
      this._shutdown = !1, this._aggregationSelector = (r = t == null ? void 0 : t.aggregationSelector) !== null && r !== void 0 ? r : $y, this._aggregationTemporalitySelector = (n = t == null ? void 0 : t.aggregationTemporalitySelector) !== null && n !== void 0 ? n : Hy, this._metricProducers = (i = t == null ? void 0 : t.metricProducers) !== null && i !== void 0 ? i : [], this._cardinalitySelector = t == null ? void 0 : t.cardinalitySelector;
    }
    return e.prototype.setMetricProducer = function(t) {
      if (this._sdkMetricProducer)
        throw new Error("MetricReader can not be bound to a MeterProvider again.");
      this._sdkMetricProducer = t, this.onInitialized();
    }, e.prototype.selectAggregation = function(t) {
      return this._aggregationSelector(t);
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._aggregationTemporalitySelector(t);
    }, e.prototype.selectCardinalityLimit = function(t) {
      return this._cardinalitySelector ? this._cardinalitySelector(t) : 2e3;
    }, e.prototype.onInitialized = function() {
    }, e.prototype.collect = function(t) {
      return dn(this, void 0, void 0, function() {
        var r, n, i, o, a, u;
        return pn(this, function(c) {
          switch (c.label) {
            case 0:
              if (this._sdkMetricProducer === void 0)
                throw new Error("MetricReader is not bound to a MetricProducer");
              if (this._shutdown)
                throw new Error("MetricReader is shutdown");
              return [4, Promise.all(jy([
                this._sdkMetricProducer.collect({
                  timeoutMillis: t == null ? void 0 : t.timeoutMillis
                })
              ], Fo(this._metricProducers.map(function(s) {
                return s.collect({
                  timeoutMillis: t == null ? void 0 : t.timeoutMillis
                });
              })), !1))];
            case 1:
              return r = Fo.apply(void 0, [c.sent()]), n = r[0], i = r.slice(1), o = n.errors.concat(ko(i, function(s) {
                return s.errors;
              })), a = n.resourceMetrics.resource, u = n.resourceMetrics.scopeMetrics.concat(ko(i, function(s) {
                return s.resourceMetrics.scopeMetrics;
              })), [2, {
                resourceMetrics: {
                  resource: a,
                  scopeMetrics: u
                },
                errors: o
              }];
          }
        });
      });
    }, e.prototype.shutdown = function(t) {
      return dn(this, void 0, void 0, function() {
        return pn(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (v.error("Cannot call shutdown twice."), [
                2
                /*return*/
              ]) : (t == null ? void 0 : t.timeoutMillis) != null ? [3, 2] : [4, this.onShutdown()];
            case 1:
              return r.sent(), [3, 4];
            case 2:
              return [4, Se(this.onShutdown(), t.timeoutMillis)];
            case 3:
              r.sent(), r.label = 4;
            case 4:
              return this._shutdown = !0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return dn(this, void 0, void 0, function() {
        return pn(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (v.warn("Cannot forceFlush on already shutdown MetricReader."), [
                2
                /*return*/
              ]) : (t == null ? void 0 : t.timeoutMillis) != null ? [3, 2] : [4, this.onForceFlush()];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
            case 2:
              return [4, Se(this.onForceFlush(), t.timeoutMillis)];
            case 3:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
), Fy = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), je = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Ve = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Xy = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, zy = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, qy = (
  /** @class */
  function(e) {
    Fy(t, e);
    function t(r) {
      var n, i, o, a, u = e.call(this, {
        aggregationSelector: (n = r.exporter.selectAggregation) === null || n === void 0 ? void 0 : n.bind(r.exporter),
        aggregationTemporalitySelector: (i = r.exporter.selectAggregationTemporality) === null || i === void 0 ? void 0 : i.bind(r.exporter),
        metricProducers: r.metricProducers
      }) || this;
      if (r.exportIntervalMillis !== void 0 && r.exportIntervalMillis <= 0)
        throw Error("exportIntervalMillis must be greater than 0");
      if (r.exportTimeoutMillis !== void 0 && r.exportTimeoutMillis <= 0)
        throw Error("exportTimeoutMillis must be greater than 0");
      if (r.exportTimeoutMillis !== void 0 && r.exportIntervalMillis !== void 0 && r.exportIntervalMillis < r.exportTimeoutMillis)
        throw Error("exportIntervalMillis must be greater than or equal to exportTimeoutMillis");
      return u._exportInterval = (o = r.exportIntervalMillis) !== null && o !== void 0 ? o : 6e4, u._exportTimeout = (a = r.exportTimeoutMillis) !== null && a !== void 0 ? a : 3e4, u._exporter = r.exporter, u;
    }
    return t.prototype._runOnce = function() {
      return je(this, void 0, void 0, function() {
        var r;
        return Ve(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2, , 3]), [4, Se(this._doRun(), this._exportTimeout)];
            case 1:
              return n.sent(), [3, 3];
            case 2:
              return r = n.sent(), r instanceof Xs ? (v.error("Export took longer than %s milliseconds and timed out.", this._exportTimeout), [
                2
                /*return*/
              ]) : ($i(r), [3, 3]);
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype._doRun = function() {
      var r, n;
      return je(this, void 0, void 0, function() {
        var i, o, a, u, c, s;
        return Ve(this, function(l) {
          switch (l.label) {
            case 0:
              return [4, this.collect({
                timeoutMillis: this._exportTimeout
              })];
            case 1:
              if (i = l.sent(), o = i.resourceMetrics, a = i.errors, a.length > 0 && (s = v).error.apply(s, zy(["PeriodicExportingMetricReader: metrics collection errors"], Xy(a), !1)), !o.resource.asyncAttributesPending) return [3, 5];
              l.label = 2;
            case 2:
              return l.trys.push([2, 4, , 5]), [4, (n = (r = o.resource).waitForAsyncAttributes) === null || n === void 0 ? void 0 : n.call(r)];
            case 3:
              return l.sent(), [3, 5];
            case 4:
              return u = l.sent(), v.debug("Error while resolving async portion of resource: ", u), $i(u), [3, 5];
            case 5:
              return o.scopeMetrics.length === 0 ? [
                2
                /*return*/
              ] : [4, md._export(this._exporter, o)];
            case 6:
              if (c = l.sent(), c.code !== N.SUCCESS)
                throw new Error("PeriodicExportingMetricReader: metrics export failed (error " + c.error + ")");
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onInitialized = function() {
      var r = this;
      this._interval = setInterval(function() {
        r._runOnce();
      }, this._exportInterval);
    }, t.prototype.onForceFlush = function() {
      return je(this, void 0, void 0, function() {
        return Ve(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._runOnce()];
            case 1:
              return r.sent(), [4, this._exporter.forceFlush()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onShutdown = function() {
      return je(this, void 0, void 0, function() {
        return Ve(this, function(r) {
          switch (r.label) {
            case 0:
              return this._interval && clearInterval(this._interval), [4, this.onForceFlush()];
            case 1:
              return r.sent(), [4, this._exporter.shutdown()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }(Vy)
), Ky = (
  /** @class */
  function() {
    function e() {
      this._registeredViews = [];
    }
    return e.prototype.addView = function(t) {
      this._registeredViews.push(t);
    }, e.prototype.findViews = function(t, r) {
      var n = this, i = this._registeredViews.filter(function(o) {
        return n._matchInstrument(o.instrumentSelector, t) && n._matchMeter(o.meterSelector, r);
      });
      return i;
    }, e.prototype._matchInstrument = function(t, r) {
      return (t.getType() === void 0 || r.type === t.getType()) && t.getNameFilter().match(r.name) && t.getUnitFilter().match(r.unit);
    }, e.prototype._matchMeter = function(t, r) {
      return t.getNameFilter().match(r.name) && (r.version === void 0 || t.getVersionFilter().match(r.version)) && (r.schemaUrl === void 0 || t.getSchemaUrlFilter().match(r.schemaUrl));
    }, e;
  }()
), It = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), mr = (
  /** @class */
  function() {
    function e(t, r) {
      this._writableMetricStorage = t, this._descriptor = r;
    }
    return e.prototype._record = function(t, r, n) {
      if (r === void 0 && (r = {}), n === void 0 && (n = b.active()), typeof t != "number") {
        v.warn("non-number value provided to metric " + this._descriptor.name + ": " + t);
        return;
      }
      this._descriptor.valueType === _t.INT && !Number.isInteger(t) && (v.warn("INT value type cannot accept a floating-point value for " + this._descriptor.name + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._writableMetricStorage.record(t, r, n, Ee(Date.now()));
    }, e;
  }()
), Wy = (
  /** @class */
  function(e) {
    It(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n, i) {
      this._record(r, n, i);
    }, t;
  }(mr)
), Yy = (
  /** @class */
  function(e) {
    It(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n, i) {
      if (r < 0) {
        v.warn("negative value provided to counter " + this._descriptor.name + ": " + r);
        return;
      }
      this._record(r, n, i);
    }, t;
  }(mr)
), Jy = (
  /** @class */
  function(e) {
    It(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n, i) {
      this._record(r, n, i);
    }, t;
  }(mr)
), Zy = (
  /** @class */
  function(e) {
    It(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n, i) {
      if (r < 0) {
        v.warn("negative value provided to histogram " + this._descriptor.name + ": " + r);
        return;
      }
      this._record(r, n, i);
    }, t;
  }(mr)
), Tr = (
  /** @class */
  function() {
    function e(t, r, n) {
      this._observableRegistry = n, this._descriptor = t, this._metricStorages = r;
    }
    return e.prototype.addCallback = function(t) {
      this._observableRegistry.addCallback(t, this);
    }, e.prototype.removeCallback = function(t) {
      this._observableRegistry.removeCallback(t, this);
    }, e;
  }()
), Qy = (
  /** @class */
  function(e) {
    It(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Tr)
), tE = (
  /** @class */
  function(e) {
    It(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Tr)
), eE = (
  /** @class */
  function(e) {
    It(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Tr)
);
function Zn(e) {
  return e instanceof Tr;
}
var rE = (
  /** @class */
  function() {
    function e(t) {
      this._meterSharedState = t;
    }
    return e.prototype.createGauge = function(t, r) {
      var n = st(t, S.GAUGE, r), i = this._meterSharedState.registerMetricStorage(n);
      return new Jy(i, n);
    }, e.prototype.createHistogram = function(t, r) {
      var n = st(t, S.HISTOGRAM, r), i = this._meterSharedState.registerMetricStorage(n);
      return new Zy(i, n);
    }, e.prototype.createCounter = function(t, r) {
      var n = st(t, S.COUNTER, r), i = this._meterSharedState.registerMetricStorage(n);
      return new Yy(i, n);
    }, e.prototype.createUpDownCounter = function(t, r) {
      var n = st(t, S.UP_DOWN_COUNTER, r), i = this._meterSharedState.registerMetricStorage(n);
      return new Wy(i, n);
    }, e.prototype.createObservableGauge = function(t, r) {
      var n = st(t, S.OBSERVABLE_GAUGE, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new tE(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.createObservableCounter = function(t, r) {
      var n = st(t, S.OBSERVABLE_COUNTER, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new Qy(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.createObservableUpDownCounter = function(t, r) {
      var n = st(t, S.OBSERVABLE_UP_DOWN_COUNTER, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new eE(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.addBatchObservableCallback = function(t, r) {
      this._meterSharedState.observableRegistry.addBatchCallback(t, r);
    }, e.prototype.removeBatchObservableCallback = function(t, r) {
      this._meterSharedState.observableRegistry.removeBatchCallback(t, r);
    }, e;
  }()
), eu = (
  /** @class */
  function() {
    function e(t) {
      this._instrumentDescriptor = t;
    }
    return e.prototype.getInstrumentDescriptor = function() {
      return this._instrumentDescriptor;
    }, e.prototype.updateDescription = function(t) {
      this._instrumentDescriptor = st(this._instrumentDescriptor.name, this._instrumentDescriptor.type, {
        description: t,
        valueType: this._instrumentDescriptor.valueType,
        unit: this._instrumentDescriptor.unit,
        advice: this._instrumentDescriptor.advice
      });
    }, e;
  }()
), nE = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Xo = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, iE = (
  /** @class */
  function() {
    function e(t) {
      this._hash = t, this._valueMap = /* @__PURE__ */ new Map(), this._keyMap = /* @__PURE__ */ new Map();
    }
    return e.prototype.get = function(t, r) {
      return r != null || (r = this._hash(t)), this._valueMap.get(r);
    }, e.prototype.getOrDefault = function(t, r) {
      var n = this._hash(t);
      if (this._valueMap.has(n))
        return this._valueMap.get(n);
      var i = r();
      return this._keyMap.has(n) || this._keyMap.set(n, t), this._valueMap.set(n, i), i;
    }, e.prototype.set = function(t, r, n) {
      n != null || (n = this._hash(t)), this._keyMap.has(n) || this._keyMap.set(n, t), this._valueMap.set(n, r);
    }, e.prototype.has = function(t, r) {
      return r != null || (r = this._hash(t)), this._valueMap.has(r);
    }, e.prototype.keys = function() {
      var t, r;
      return Xo(this, function(n) {
        switch (n.label) {
          case 0:
            t = this._keyMap.entries(), r = t.next(), n.label = 1;
          case 1:
            return r.done === !0 ? [3, 3] : [4, [r.value[1], r.value[0]]];
          case 2:
            return n.sent(), r = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, e.prototype.entries = function() {
      var t, r;
      return Xo(this, function(n) {
        switch (n.label) {
          case 0:
            t = this._valueMap.entries(), r = t.next(), n.label = 1;
          case 1:
            return r.done === !0 ? [3, 3] : [4, [this._keyMap.get(r.value[0]), r.value[1], r.value[0]]];
          case 2:
            return n.sent(), r = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, Object.defineProperty(e.prototype, "size", {
      get: function() {
        return this._valueMap.size;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
), Ot = (
  /** @class */
  function(e) {
    nE(t, e);
    function t() {
      return e.call(this, Fs) || this;
    }
    return t;
  }(iE)
), oE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ru = (
  /** @class */
  function() {
    function e(t, r) {
      this._aggregator = t, this._activeCollectionStorage = new Ot(), this._cumulativeMemoStorage = new Ot(), this._overflowAttributes = { "otel.metric.overflow": !0 }, this._cardinalityLimit = (r != null ? r : 2e3) - 1, this._overflowHashCode = Fs(this._overflowAttributes);
    }
    return e.prototype.record = function(t, r, n, i) {
      var o = this, a = this._activeCollectionStorage.get(r);
      if (!a) {
        if (this._activeCollectionStorage.size >= this._cardinalityLimit) {
          var u = this._activeCollectionStorage.getOrDefault(this._overflowAttributes, function() {
            return o._aggregator.createAccumulation(i);
          });
          u == null || u.record(t);
          return;
        }
        a = this._aggregator.createAccumulation(i), this._activeCollectionStorage.set(r, a);
      }
      a == null || a.record(t);
    }, e.prototype.batchCumulate = function(t, r) {
      var n = this;
      Array.from(t.entries()).forEach(function(i) {
        var o = oE(i, 3), a = o[0], u = o[1], c = o[2], s = n._aggregator.createAccumulation(r);
        s == null || s.record(u);
        var l = s;
        if (n._cumulativeMemoStorage.has(a, c)) {
          var f = n._cumulativeMemoStorage.get(a, c);
          l = n._aggregator.diff(f, s);
        } else if (n._cumulativeMemoStorage.size >= n._cardinalityLimit && (a = n._overflowAttributes, c = n._overflowHashCode, n._cumulativeMemoStorage.has(a, c))) {
          var f = n._cumulativeMemoStorage.get(a, c);
          l = n._aggregator.diff(f, s);
        }
        if (n._activeCollectionStorage.has(a, c)) {
          var d = n._activeCollectionStorage.get(a, c);
          l = n._aggregator.merge(d, l);
        }
        n._cumulativeMemoStorage.set(a, s, c), n._activeCollectionStorage.set(a, l, c);
      });
    }, e.prototype.collect = function() {
      var t = this._activeCollectionStorage;
      return this._activeCollectionStorage = new Ot(), t;
    }, e;
  }()
), hn = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, zo = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, nu = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this;
      this._aggregator = t, this._unreportedAccumulations = /* @__PURE__ */ new Map(), this._reportHistory = /* @__PURE__ */ new Map(), r.forEach(function(i) {
        n._unreportedAccumulations.set(i, []);
      });
    }
    return e.prototype.buildMetrics = function(t, r, n, i) {
      this._stashAccumulations(n);
      var o = this._getMergedUnreportedAccumulations(t), a = o, u;
      if (this._reportHistory.has(t)) {
        var c = this._reportHistory.get(t), s = c.collectionTime;
        u = c.aggregationTemporality, u === q.CUMULATIVE ? a = e.merge(c.accumulations, o, this._aggregator) : a = e.calibrateStartTime(c.accumulations, o, s);
      } else
        u = t.selectAggregationTemporality(r.type);
      this._reportHistory.set(t, {
        accumulations: a,
        collectionTime: i,
        aggregationTemporality: u
      });
      var l = aE(a);
      if (l.length !== 0)
        return this._aggregator.toMetricData(
          r,
          u,
          l,
          /* endTime */
          i
        );
    }, e.prototype._stashAccumulations = function(t) {
      var r, n, i = this._unreportedAccumulations.keys();
      try {
        for (var o = hn(i), a = o.next(); !a.done; a = o.next()) {
          var u = a.value, c = this._unreportedAccumulations.get(u);
          c === void 0 && (c = [], this._unreportedAccumulations.set(u, c)), c.push(t);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype._getMergedUnreportedAccumulations = function(t) {
      var r, n, i = new Ot(), o = this._unreportedAccumulations.get(t);
      if (this._unreportedAccumulations.set(t, []), o === void 0)
        return i;
      try {
        for (var a = hn(o), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          i = e.merge(i, c, this._aggregator);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          u && !u.done && (n = a.return) && n.call(a);
        } finally {
          if (r) throw r.error;
        }
      }
      return i;
    }, e.merge = function(t, r, n) {
      for (var i = t, o = r.entries(), a = o.next(); a.done !== !0; ) {
        var u = zo(a.value, 3), c = u[0], s = u[1], l = u[2];
        if (t.has(c, l)) {
          var f = t.get(c, l), d = n.merge(f, s);
          i.set(c, d, l);
        } else
          i.set(c, s, l);
        a = o.next();
      }
      return i;
    }, e.calibrateStartTime = function(t, r, n) {
      var i, o;
      try {
        for (var a = hn(t.keys()), u = a.next(); !u.done; u = a.next()) {
          var c = zo(u.value, 2), s = c[0], l = c[1], f = r.get(s, l);
          f == null || f.setStartTime(n);
        }
      } catch (d) {
        i = { error: d };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
      return r;
    }, e;
  }()
);
function aE(e) {
  return Array.from(e.entries());
}
var sE = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), uE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, cE = (
  /** @class */
  function(e) {
    sE(t, e);
    function t(r, n, i, o, a) {
      var u = e.call(this, r) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new ru(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new nu(n, o), u;
    }
    return t.prototype.record = function(r, n) {
      var i = this, o = new Ot();
      Array.from(r.entries()).forEach(function(a) {
        var u = uE(a, 2), c = u[0], s = u[1];
        o.set(i._attributesProcessor.process(c), s);
      }), this._deltaMetricStorage.batchCumulate(o, n);
    }, t.prototype.collect = function(r, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(r, this._instrumentDescriptor, i, n);
    }, t;
  }(eu)
);
function qo(e, t) {
  var r = "";
  return e.unit !== t.unit && (r += "	- Unit '" + e.unit + "' does not match '" + t.unit + `'
`), e.type !== t.type && (r += "	- Type '" + e.type + "' does not match '" + t.type + `'
`), e.valueType !== t.valueType && (r += "	- Value Type '" + e.valueType + "' does not match '" + t.valueType + `'
`), e.description !== t.description && (r += "	- Description '" + e.description + "' does not match '" + t.description + `'
`), r;
}
function lE(e, t) {
  return "	- use valueType '" + e.valueType + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function fE(e, t) {
  return "	- use unit '" + e.unit + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function dE(e, t) {
  var r = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, n = JSON.stringify(r);
  return "	- create a new view with a name other than '" + e.name + "' and InstrumentSelector '" + n + "'";
}
function pE(e, t) {
  var r = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, n = JSON.stringify(r);
  return "	- create a new view with a name other than '" + e.name + "' and InstrumentSelector '" + n + `'
    	- OR - create a new view with the name ` + e.name + " and description '" + e.description + "' and InstrumentSelector " + n + `
    	- OR - create a new view with the name ` + t.name + " and description '" + e.description + "' and InstrumentSelector " + n;
}
function Ko(e, t) {
  return e.valueType !== t.valueType ? lE(e, t) : e.unit !== t.unit ? fE(e, t) : e.type !== t.type ? dE(e, t) : e.description !== t.description ? pE(e, t) : "";
}
var _n = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, hE = (
  /** @class */
  function() {
    function e() {
      this._sharedRegistry = /* @__PURE__ */ new Map(), this._perCollectorRegistry = /* @__PURE__ */ new Map();
    }
    return e.create = function() {
      return new e();
    }, e.prototype.getStorages = function(t) {
      var r, n, i, o, a = [];
      try {
        for (var u = _n(this._sharedRegistry.values()), c = u.next(); !c.done; c = u.next()) {
          var s = c.value;
          a = a.concat(s);
        }
      } catch (p) {
        r = { error: p };
      } finally {
        try {
          c && !c.done && (n = u.return) && n.call(u);
        } finally {
          if (r) throw r.error;
        }
      }
      var l = this._perCollectorRegistry.get(t);
      if (l != null)
        try {
          for (var f = _n(l.values()), d = f.next(); !d.done; d = f.next()) {
            var s = d.value;
            a = a.concat(s);
          }
        } catch (p) {
          i = { error: p };
        } finally {
          try {
            d && !d.done && (o = f.return) && o.call(f);
          } finally {
            if (i) throw i.error;
          }
        }
      return a;
    }, e.prototype.register = function(t) {
      this._registerStorage(t, this._sharedRegistry);
    }, e.prototype.registerForCollector = function(t, r) {
      var n = this._perCollectorRegistry.get(t);
      n == null && (n = /* @__PURE__ */ new Map(), this._perCollectorRegistry.set(t, n)), this._registerStorage(r, n);
    }, e.prototype.findOrUpdateCompatibleStorage = function(t) {
      var r = this._sharedRegistry.get(t.name);
      return r === void 0 ? null : this._findOrUpdateCompatibleStorage(t, r);
    }, e.prototype.findOrUpdateCompatibleCollectorStorage = function(t, r) {
      var n = this._perCollectorRegistry.get(t);
      if (n === void 0)
        return null;
      var i = n.get(r.name);
      return i === void 0 ? null : this._findOrUpdateCompatibleStorage(r, i);
    }, e.prototype._registerStorage = function(t, r) {
      var n = t.getInstrumentDescriptor(), i = r.get(n.name);
      if (i === void 0) {
        r.set(n.name, [t]);
        return;
      }
      i.push(t);
    }, e.prototype._findOrUpdateCompatibleStorage = function(t, r) {
      var n, i, o = null;
      try {
        for (var a = _n(r), u = a.next(); !u.done; u = a.next()) {
          var c = u.value, s = c.getInstrumentDescriptor();
          cy(s, t) ? (s.description !== t.description && (t.description.length > s.description.length && c.updateDescription(t.description), v.warn("A view or instrument with the name ", t.name, ` has already been registered, but has a different description and is incompatible with another registered view.
`, `Details:
`, qo(s, t), `The longer description will be used.
To resolve the conflict:`, Ko(s, t))), o = c) : v.warn("A view or instrument with the name ", t.name, ` has already been registered and is incompatible with another registered view.
`, `Details:
`, qo(s, t), `To resolve the conflict:
`, Ko(s, t));
        }
      } catch (l) {
        n = { error: l };
      } finally {
        try {
          u && !u.done && (i = a.return) && i.call(a);
        } finally {
          if (n) throw n.error;
        }
      }
      return o;
    }, e;
  }()
), _E = (
  /** @class */
  function() {
    function e(t) {
      this._backingStorages = t;
    }
    return e.prototype.record = function(t, r, n, i) {
      this._backingStorages.forEach(function(o) {
        o.record(t, r, n, i);
      });
    }, e;
  }()
), vE = (
  /** @class */
  function() {
    function e(t, r) {
      this._instrumentName = t, this._valueType = r, this._buffer = new Ot();
    }
    return e.prototype.observe = function(t, r) {
      if (r === void 0 && (r = {}), typeof t != "number") {
        v.warn("non-number value provided to metric " + this._instrumentName + ": " + t);
        return;
      }
      this._valueType === _t.INT && !Number.isInteger(t) && (v.warn("INT value type cannot accept a floating-point value for " + this._instrumentName + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._buffer.set(r, t);
    }, e;
  }()
), gE = (
  /** @class */
  function() {
    function e() {
      this._buffer = /* @__PURE__ */ new Map();
    }
    return e.prototype.observe = function(t, r, n) {
      if (n === void 0 && (n = {}), !!Zn(t)) {
        var i = this._buffer.get(t);
        if (i == null && (i = new Ot(), this._buffer.set(t, i)), typeof r != "number") {
          v.warn("non-number value provided to metric " + t._descriptor.name + ": " + r);
          return;
        }
        t._descriptor.valueType === _t.INT && !Number.isInteger(r) && (v.warn("INT value type cannot accept a floating-point value for " + t._descriptor.name + ", ignoring the fractional digits."), r = Math.trunc(r), !Number.isInteger(r)) || i.set(n, r);
      }
    }, e;
  }()
), vn = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, gn = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Wo = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Yo = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, yE = (
  /** @class */
  function() {
    function e() {
      this._callbacks = [], this._batchCallbacks = [];
    }
    return e.prototype.addCallback = function(t, r) {
      var n = this._findCallback(t, r);
      n >= 0 || this._callbacks.push({ callback: t, instrument: r });
    }, e.prototype.removeCallback = function(t, r) {
      var n = this._findCallback(t, r);
      n < 0 || this._callbacks.splice(n, 1);
    }, e.prototype.addBatchCallback = function(t, r) {
      var n = new Set(r.filter(Zn));
      if (n.size === 0) {
        v.error("BatchObservableCallback is not associated with valid instruments", r);
        return;
      }
      var i = this._findBatchCallback(t, n);
      i >= 0 || this._batchCallbacks.push({ callback: t, instruments: n });
    }, e.prototype.removeBatchCallback = function(t, r) {
      var n = new Set(r.filter(Zn)), i = this._findBatchCallback(t, n);
      i < 0 || this._batchCallbacks.splice(i, 1);
    }, e.prototype.observe = function(t, r) {
      return vn(this, void 0, void 0, function() {
        var n, i, o, a;
        return gn(this, function(u) {
          switch (u.label) {
            case 0:
              return n = this._observeCallbacks(t, r), i = this._observeBatchCallbacks(t, r), [4, ry(Yo(Yo([], Wo(n), !1), Wo(i), !1))];
            case 1:
              return o = u.sent(), a = o.filter(ny).map(function(c) {
                return c.reason;
              }), [2, a];
          }
        });
      });
    }, e.prototype._observeCallbacks = function(t, r) {
      var n = this;
      return this._callbacks.map(function(i) {
        var o = i.callback, a = i.instrument;
        return vn(n, void 0, void 0, function() {
          var u, c;
          return gn(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new vE(a._descriptor.name, a._descriptor.valueType), c = Promise.resolve(o(u)), r != null && (c = Se(c, r)), [4, c];
              case 1:
                return s.sent(), a._metricStorages.forEach(function(l) {
                  l.record(u._buffer, t);
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, e.prototype._observeBatchCallbacks = function(t, r) {
      var n = this;
      return this._batchCallbacks.map(function(i) {
        var o = i.callback, a = i.instruments;
        return vn(n, void 0, void 0, function() {
          var u, c;
          return gn(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new gE(), c = Promise.resolve(o(u)), r != null && (c = Se(c, r)), [4, c];
              case 1:
                return s.sent(), a.forEach(function(l) {
                  var f = u._buffer.get(l);
                  f != null && l._metricStorages.forEach(function(d) {
                    d.record(f, t);
                  });
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, e.prototype._findCallback = function(t, r) {
      return this._callbacks.findIndex(function(n) {
        return n.callback === t && n.instrument === r;
      });
    }, e.prototype._findBatchCallback = function(t, r) {
      return this._batchCallbacks.findIndex(function(n) {
        return n.callback === t && iy(n.instruments, r);
      });
    }, e;
  }()
), EE = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), mE = (
  /** @class */
  function(e) {
    EE(t, e);
    function t(r, n, i, o, a) {
      var u = e.call(this, r) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new ru(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new nu(n, o), u;
    }
    return t.prototype.record = function(r, n, i, o) {
      n = this._attributesProcessor.process(n, i), this._deltaMetricStorage.record(r, n, i, o);
    }, t.prototype.collect = function(r, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(r, this._instrumentDescriptor, i, n);
    }, t;
  }(eu)
), iu = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), vi = (
  /** @class */
  function() {
    function e() {
    }
    return e.Noop = function() {
      return SE;
    }, e;
  }()
), TE = (
  /** @class */
  function(e) {
    iu(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.process = function(r, n) {
      return r;
    }, t;
  }(vi)
);
(function(e) {
  iu(t, e);
  function t(r) {
    var n = e.call(this) || this;
    return n._allowedAttributeNames = r, n;
  }
  return t.prototype.process = function(r, n) {
    var i = this, o = {};
    return Object.keys(r).filter(function(a) {
      return i._allowedAttributeNames.includes(a);
    }).forEach(function(a) {
      return o[a] = r[a];
    }), o;
  }, t;
})(vi);
var SE = new TE(), OE = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, bE = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, AE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, wE = (
  /** @class */
  function() {
    function e(t, r) {
      this._meterProviderSharedState = t, this._instrumentationScope = r, this.metricStorageRegistry = new hE(), this.observableRegistry = new yE(), this.meter = new rE(this);
    }
    return e.prototype.registerMetricStorage = function(t) {
      var r = this._registerMetricStorage(t, mE);
      return r.length === 1 ? r[0] : new _E(r);
    }, e.prototype.registerAsyncMetricStorage = function(t) {
      var r = this._registerMetricStorage(t, cE);
      return r;
    }, e.prototype.collect = function(t, r, n) {
      return OE(this, void 0, void 0, function() {
        var i, o, a;
        return bE(this, function(u) {
          switch (u.label) {
            case 0:
              return [4, this.observableRegistry.observe(r, n == null ? void 0 : n.timeoutMillis)];
            case 1:
              return i = u.sent(), o = this.metricStorageRegistry.getStorages(t), o.length === 0 ? [2, null] : (a = o.map(function(c) {
                return c.collect(t, r);
              }).filter(ty), a.length === 0 ? [2, { errors: i }] : [2, {
                scopeMetrics: {
                  scope: this._instrumentationScope,
                  metrics: a
                },
                errors: i
              }]);
          }
        });
      });
    }, e.prototype._registerMetricStorage = function(t, r) {
      var n = this, i = this._meterProviderSharedState.viewRegistry.findViews(t, this._instrumentationScope), o = i.map(function(c) {
        var s = uy(c, t), l = n.metricStorageRegistry.findOrUpdateCompatibleStorage(s);
        if (l != null)
          return l;
        var f = c.aggregation.createAggregator(s), d = new r(s, f, c.attributesProcessor, n._meterProviderSharedState.metricCollectors, c.aggregationCardinalityLimit);
        return n.metricStorageRegistry.register(d), d;
      });
      if (o.length === 0) {
        var a = this._meterProviderSharedState.selectAggregations(t.type), u = a.map(function(c) {
          var s = AE(c, 2), l = s[0], f = s[1], d = n.metricStorageRegistry.findOrUpdateCompatibleCollectorStorage(l, t);
          if (d != null)
            return d;
          var p = f.createAggregator(t), _ = l.selectCardinalityLimit(t.type), h = new r(t, p, vi.Noop(), [l], _);
          return n.metricStorageRegistry.registerForCollector(l, h), h;
        });
        o = o.concat(u);
      }
      return o;
    }, e;
  }()
), RE = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, LE = (
  /** @class */
  function() {
    function e(t) {
      this.resource = t, this.viewRegistry = new Ky(), this.metricCollectors = [], this.meterSharedStates = /* @__PURE__ */ new Map();
    }
    return e.prototype.getMeterSharedState = function(t) {
      var r = ey(t), n = this.meterSharedStates.get(r);
      return n == null && (n = new wE(this, t), this.meterSharedStates.set(r, n)), n;
    }, e.prototype.selectAggregations = function(t) {
      var r, n, i = [];
      try {
        for (var o = RE(this.metricCollectors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          i.push([u, u.selectAggregation(t)]);
        }
      } catch (c) {
        r = { error: c };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
      return i;
    }, e;
  }()
), Fe = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Xe = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, PE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, NE = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, IE = (
  /** @class */
  function() {
    function e(t, r) {
      this._sharedState = t, this._metricReader = r;
    }
    return e.prototype.collect = function(t) {
      return Fe(this, void 0, void 0, function() {
        var r, n, i, o, a = this;
        return Xe(this, function(u) {
          switch (u.label) {
            case 0:
              return r = Ee(Date.now()), n = [], i = [], o = Array.from(this._sharedState.meterSharedStates.values()).map(function(c) {
                return Fe(a, void 0, void 0, function() {
                  var s;
                  return Xe(this, function(l) {
                    switch (l.label) {
                      case 0:
                        return [4, c.collect(this, r, t)];
                      case 1:
                        return s = l.sent(), (s == null ? void 0 : s.scopeMetrics) != null && n.push(s.scopeMetrics), (s == null ? void 0 : s.errors) != null && i.push.apply(i, NE([], PE(s.errors), !1)), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }), [4, Promise.all(o)];
            case 1:
              return u.sent(), [2, {
                resourceMetrics: {
                  resource: this._sharedState.resource,
                  scopeMetrics: n
                },
                errors: i
              }];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return Fe(this, void 0, void 0, function() {
        return Xe(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._metricReader.forceFlush(t)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.shutdown = function(t) {
      return Fe(this, void 0, void 0, function() {
        return Xe(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._metricReader.shutdown(t)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._metricReader.selectAggregationTemporality(t);
    }, e.prototype.selectAggregation = function(t) {
      return this._metricReader.selectAggregation(t);
    }, e.prototype.selectCardinalityLimit = function(t) {
      var r, n, i;
      return (i = (n = (r = this._metricReader).selectCardinalityLimit) === null || n === void 0 ? void 0 : n.call(r, t)) !== null && i !== void 0 ? i : 2e3;
    }, e;
  }()
), Jo = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, Zo = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Qo = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function CE(e, t) {
  var r = t != null ? t : Kn.empty();
  return e ? Kn.default().merge(r) : r;
}
var ME = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i, o, a;
      if (this._shutdown = !1, this._sharedState = new LE(CE((a = t == null ? void 0 : t.mergeResourceWithDefaults) !== null && a !== void 0 ? a : !0, t == null ? void 0 : t.resource)), (t == null ? void 0 : t.views) != null && t.views.length > 0)
        try {
          for (var u = Qo(t.views), c = u.next(); !c.done; c = u.next()) {
            var s = c.value;
            this._sharedState.viewRegistry.addView(s);
          }
        } catch (p) {
          r = { error: p };
        } finally {
          try {
            c && !c.done && (n = u.return) && n.call(u);
          } finally {
            if (r) throw r.error;
          }
        }
      if ((t == null ? void 0 : t.readers) != null && t.readers.length > 0)
        try {
          for (var l = Qo(t.readers), f = l.next(); !f.done; f = l.next()) {
            var d = f.value;
            this.addMetricReader(d);
          }
        } catch (p) {
          i = { error: p };
        } finally {
          try {
            f && !f.done && (o = l.return) && o.call(l);
          } finally {
            if (i) throw i.error;
          }
        }
    }
    return e.prototype.getMeter = function(t, r, n) {
      return r === void 0 && (r = ""), n === void 0 && (n = {}), this._shutdown ? (v.warn("A shutdown MeterProvider cannot provide a Meter"), pl()) : this._sharedState.getMeterSharedState({
        name: t,
        version: r,
        schemaUrl: n.schemaUrl
      }).meter;
    }, e.prototype.addMetricReader = function(t) {
      var r = new IE(this._sharedState, t);
      t.setMetricProducer(r), this._sharedState.metricCollectors.push(r);
    }, e.prototype.shutdown = function(t) {
      return Jo(this, void 0, void 0, function() {
        return Zo(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (v.warn("shutdown may only be called once per MeterProvider"), [
                2
                /*return*/
              ]) : (this._shutdown = !0, [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.shutdown(t);
              }))]);
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return Jo(this, void 0, void 0, function() {
        return Zo(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (v.warn("invalid attempt to force flush after MeterProvider shutdown"), [
                2
                /*return*/
              ]) : [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.forceFlush(t);
              }))];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function xE(e, t) {
  var r = Gs(t);
  return {
    resource: $s(e.resource),
    schemaUrl: void 0,
    scopeMetrics: DE(e.scopeMetrics, r)
  };
}
function DE(e, t) {
  return Array.from(e.map(function(r) {
    return {
      scope: Hs(r.scope),
      metrics: r.metrics.map(function(n) {
        return UE(n, t);
      }),
      schemaUrl: r.scope.schemaUrl
    };
  }));
}
function UE(e, t) {
  var r = {
    name: e.descriptor.name,
    description: e.descriptor.description,
    unit: e.descriptor.unit
  }, n = $E(e.aggregationTemporality);
  switch (e.dataPointType) {
    case J.SUM:
      r.sum = {
        aggregationTemporality: n,
        isMonotonic: e.isMonotonic,
        dataPoints: ta(e, t)
      };
      break;
    case J.GAUGE:
      r.gauge = {
        dataPoints: ta(e, t)
      };
      break;
    case J.HISTOGRAM:
      r.histogram = {
        aggregationTemporality: n,
        dataPoints: kE(e, t)
      };
      break;
    case J.EXPONENTIAL_HISTOGRAM:
      r.exponentialHistogram = {
        aggregationTemporality: n,
        dataPoints: GE(e, t)
      };
      break;
  }
  return r;
}
function BE(e, t, r) {
  var n = {
    attributes: Pt(e.attributes),
    startTimeUnixNano: r.encodeHrTime(e.startTime),
    timeUnixNano: r.encodeHrTime(e.endTime)
  };
  switch (t) {
    case _t.INT:
      n.asInt = e.value;
      break;
    case _t.DOUBLE:
      n.asDouble = e.value;
      break;
  }
  return n;
}
function ta(e, t) {
  return e.dataPoints.map(function(r) {
    return BE(r, e.descriptor.valueType, t);
  });
}
function kE(e, t) {
  return e.dataPoints.map(function(r) {
    var n = r.value;
    return {
      attributes: Pt(r.attributes),
      bucketCounts: n.buckets.counts,
      explicitBounds: n.buckets.boundaries,
      count: n.count,
      sum: n.sum,
      min: n.min,
      max: n.max,
      startTimeUnixNano: t.encodeHrTime(r.startTime),
      timeUnixNano: t.encodeHrTime(r.endTime)
    };
  });
}
function GE(e, t) {
  return e.dataPoints.map(function(r) {
    var n = r.value;
    return {
      attributes: Pt(r.attributes),
      count: n.count,
      min: n.min,
      max: n.max,
      sum: n.sum,
      positive: {
        offset: n.positive.offset,
        bucketCounts: n.positive.bucketCounts
      },
      negative: {
        offset: n.negative.offset,
        bucketCounts: n.negative.bucketCounts
      },
      scale: n.scale,
      zeroCount: n.zeroCount,
      startTimeUnixNano: t.encodeHrTime(r.startTime),
      timeUnixNano: t.encodeHrTime(r.endTime)
    };
  });
}
function $E(e) {
  switch (e) {
    case q.DELTA:
      return 1;
    case q.CUMULATIVE:
      return 2;
  }
}
function HE(e, t) {
  return {
    resourceMetrics: e.map(function(r) {
      return xE(r, t);
    })
  };
}
var jE = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, VE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function FE(e, t) {
  var r, n = e.spanContext(), i = e.status;
  return {
    traceId: t.encodeSpanContext(n.traceId),
    spanId: t.encodeSpanContext(n.spanId),
    parentSpanId: t.encodeOptionalSpanContext(e.parentSpanId),
    traceState: (r = n.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    name: e.name,
    // Span kind is offset by 1 because the API does not define a value for unset
    kind: e.kind == null ? 0 : e.kind + 1,
    startTimeUnixNano: t.encodeHrTime(e.startTime),
    endTimeUnixNano: t.encodeHrTime(e.endTime),
    attributes: Pt(e.attributes),
    droppedAttributesCount: e.droppedAttributesCount,
    events: e.events.map(function(o) {
      return zE(o, t);
    }),
    droppedEventsCount: e.droppedEventsCount,
    status: {
      // API and proto enums share the same values
      code: i.code,
      message: i.message
    },
    links: e.links.map(function(o) {
      return XE(o, t);
    }),
    droppedLinksCount: e.droppedLinksCount
  };
}
function XE(e, t) {
  var r;
  return {
    attributes: e.attributes ? Pt(e.attributes) : [],
    spanId: t.encodeSpanContext(e.context.spanId),
    traceId: t.encodeSpanContext(e.context.traceId),
    traceState: (r = e.context.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function zE(e, t) {
  return {
    attributes: e.attributes ? Pt(e.attributes) : [],
    name: e.name,
    timeUnixNano: t.encodeHrTime(e.time),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function qE(e, t) {
  var r = Gs(t);
  return {
    resourceSpans: WE(e, r)
  };
}
function KE(e) {
  var t, r, n = /* @__PURE__ */ new Map();
  try {
    for (var i = jE(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value, u = n.get(a.resource);
      u || (u = /* @__PURE__ */ new Map(), n.set(a.resource, u));
      var c = a.instrumentationLibrary.name + "@" + (a.instrumentationLibrary.version || "") + ":" + (a.instrumentationLibrary.schemaUrl || ""), s = u.get(c);
      s || (s = [], u.set(c, s)), s.push(a);
    }
  } catch (l) {
    t = { error: l };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function WE(e, t) {
  for (var r = KE(e), n = [], i = r.entries(), o = i.next(); !o.done; ) {
    for (var a = VE(o.value, 2), u = a[0], c = a[1], s = [], l = c.values(), f = l.next(); !f.done; ) {
      var d = f.value;
      if (d.length > 0) {
        var p = d.map(function(h) {
          return FE(h, t);
        });
        s.push({
          scope: Hs(d[0].instrumentationLibrary),
          spans: p,
          schemaUrl: d[0].instrumentationLibrary.schemaUrl
        });
      }
      f = l.next();
    }
    var _ = {
      resource: $s(u),
      scopeSpans: s,
      schemaUrl: void 0
    };
    n.push(_), o = i.next();
  }
  return n;
}
var ou = {
  serializeRequest: function(e) {
    var t = HE([e], {
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, au = {
  serializeRequest: function(e) {
    var t = qE(e, {
      useHex: !0,
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, YE = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, JE = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, ZE = 5, QE = 1e3, tm = 5e3, em = 1.5, ea = 0.2;
function rm() {
  return Math.random() * (2 * ea) - ea;
}
var nm = (
  /** @class */
  function() {
    function e(t) {
      this._transport = t;
    }
    return e.prototype.retry = function(t, r, n) {
      var i = this;
      return new Promise(function(o, a) {
        setTimeout(function() {
          i._transport.send(t, r).then(o, a);
        }, n);
      });
    }, e.prototype.send = function(t, r) {
      var n;
      return YE(this, void 0, void 0, function() {
        var i, o, a, u, c, s, l;
        return JE(this, function(f) {
          switch (f.label) {
            case 0:
              return i = Date.now() + r, [4, this._transport.send(t, r)];
            case 1:
              o = f.sent(), a = ZE, u = QE, f.label = 2;
            case 2:
              return o.status === "retryable" && a > 0 ? (a--, c = Math.max(Math.min(u, tm) + rm(), 0), u = u * em, s = (n = o.retryInMillis) !== null && n !== void 0 ? n : c, l = i - Date.now(), s > l ? [2, o] : [4, this.retry(t, l, s)]) : [3, 4];
            case 3:
              return o = f.sent(), [3, 2];
            case 4:
              return [2, o];
          }
        });
      });
    }, e.prototype.shutdown = function() {
      return this._transport.shutdown();
    }, e;
  }()
);
function su(e) {
  return new nm(e.transport);
}
function im(e) {
  var t = [429, 502, 503, 504];
  return t.includes(e);
}
function om(e) {
  if (e != null) {
    var t = Number.parseInt(e, 10);
    if (Number.isInteger(t))
      return t > 0 ? t * 1e3 : -1;
    var r = new Date(e).getTime() - Date.now();
    return r >= 0 ? r : 0;
  }
}
var am = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, sm = (
  /** @class */
  function() {
    function e(t) {
      this._parameters = t;
    }
    return e.prototype.send = function(t, r) {
      var n = this;
      return new Promise(function(i) {
        var o = new XMLHttpRequest();
        o.timeout = r, o.open("POST", n._parameters.url);
        var a = n._parameters.headers();
        Object.entries(a).forEach(function(u) {
          var c = am(u, 2), s = c[0], l = c[1];
          o.setRequestHeader(s, l);
        }), o.ontimeout = function(u) {
          i({
            status: "failure",
            error: new Error("XHR request timed out")
          });
        }, o.onreadystatechange = function() {
          o.status >= 200 && o.status <= 299 ? (v.debug("XHR success"), i({
            status: "success"
          })) : o.status && im(o.status) ? i({
            status: "retryable",
            retryInMillis: om(o.getResponseHeader("Retry-After"))
          }) : o.status !== 0 && i({
            status: "failure",
            error: new Error("XHR request failed with non-retryable status")
          });
        }, o.onabort = function() {
          i({
            status: "failure",
            error: new Error("XHR request aborted")
          });
        }, o.onerror = function() {
          i({
            status: "failure",
            error: new Error("XHR request errored")
          });
        }, o.send(t);
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function um(e) {
  return new sm(e);
}
var cm = (
  /** @class */
  function() {
    function e(t) {
      this._params = t;
    }
    return e.prototype.send = function(t) {
      var r = this;
      return new Promise(function(n) {
        navigator.sendBeacon(r._params.url, new Blob([t], { type: r._params.blobType })) ? (v.debug("SendBeacon success"), n({
          status: "success"
        })) : n({
          status: "failure",
          error: new Error("SendBeacon failed")
        });
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function lm(e) {
  return new cm(e);
}
function fm(e, t) {
  return Ds(e, t, su({
    transport: um(e)
  }));
}
function dm(e, t) {
  return Ds(e, t, su({
    transport: lm({
      url: e.url,
      blobType: e.headers()["Content-Type"]
    })
  }));
}
var pm = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function hm(e) {
  return function() {
    var t, r = {};
    return Object.entries((t = e == null ? void 0 : e()) !== null && t !== void 0 ? t : {}).forEach(function(n) {
      var i = pm(n, 2), o = i[0], a = i[1];
      typeof a != "undefined" ? r[o] = String(a) : v.warn('Header "' + o + '" has invalid value (' + a + ") and will be ignored");
    }), r;
  };
}
var Rt = function() {
  return Rt = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Rt.apply(this, arguments);
};
function _m(e, t, r) {
  var n = Rt({}, r()), i = {};
  return function() {
    return t != null && Object.assign(i, t()), e != null && Object.assign(i, e()), Object.assign(i, n);
  };
}
function vm(e) {
  if (e != null)
    try {
      return new URL(e), e;
    } catch (t) {
      throw new Error("Configuration: Could not parse user-provided export URL: '" + e + "'");
    }
}
function gm(e, t, r) {
  var n, i, o, a;
  return Rt(Rt({}, Mg(e, t, r)), { headers: _m(hm(e.headers), t.headers, r.headers), url: (i = (n = vm(e.url)) !== null && n !== void 0 ? n : t.url) !== null && i !== void 0 ? i : r.url, agentOptions: (a = (o = e.agentOptions) !== null && o !== void 0 ? o : t.agentOptions) !== null && a !== void 0 ? a : r.agentOptions });
}
function ym(e, t) {
  return Rt(Rt({}, xg()), { headers: function() {
    return e;
  }, url: "http://localhost:4318/" + t, agentOptions: { keepAlive: !0 } });
}
function Em(e, t, r) {
  return gm(
    {
      url: e.url,
      timeoutMillis: e.timeoutMillis,
      headers: Cg(e.headers),
      concurrencyLimit: e.concurrencyLimit
    },
    {},
    // no fallback for browser case
    ym(r, t)
  );
}
function uu(e, t, r, n) {
  var i = !!e.headers || typeof navigator.sendBeacon != "function", o = Em(e, r, n);
  return i ? fm(o, t) : dm(o, t);
}
var mm = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Tm = (
  /** @class */
  function(e) {
    mm(t, e);
    function t(r) {
      return r === void 0 && (r = {}), e.call(this, uu(r, au, "v1/traces", { "Content-Type": "application/json" })) || this;
    }
    return t;
  }(xs)
), fr;
(function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE", e[e.LOWMEMORY = 2] = "LOWMEMORY";
})(fr || (fr = {}));
var Sm = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Qn = function() {
  return q.CUMULATIVE;
}, cu = function(e) {
  switch (e) {
    case S.COUNTER:
    case S.OBSERVABLE_COUNTER:
    case S.GAUGE:
    case S.HISTOGRAM:
    case S.OBSERVABLE_GAUGE:
      return q.DELTA;
    case S.UP_DOWN_COUNTER:
    case S.OBSERVABLE_UP_DOWN_COUNTER:
      return q.CUMULATIVE;
  }
}, lu = function(e) {
  switch (e) {
    case S.COUNTER:
    case S.HISTOGRAM:
      return q.DELTA;
    case S.GAUGE:
    case S.UP_DOWN_COUNTER:
    case S.OBSERVABLE_UP_DOWN_COUNTER:
    case S.OBSERVABLE_COUNTER:
    case S.OBSERVABLE_GAUGE:
      return q.CUMULATIVE;
  }
};
function Om() {
  var e = Tf(), t = e.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE.trim().toLowerCase();
  return t === "cumulative" ? Qn : t === "delta" ? cu : t === "lowmemory" ? lu : (v.warn("OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE is set to '" + e.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE + "', but only 'cumulative' and 'delta' are allowed. Using default ('cumulative') instead."), Qn);
}
function bm(e) {
  return e != null ? e === fr.DELTA ? cu : e === fr.LOWMEMORY ? lu : Qn : Om();
}
function Am(e) {
  return e != null && e.aggregationPreference ? e.aggregationPreference : function(t) {
    return at.Default();
  };
}
var wm = (
  /** @class */
  function(e) {
    Sm(t, e);
    function t(r, n) {
      var i = e.call(this, r) || this;
      return i._aggregationSelector = Am(n), i._aggregationTemporalitySelector = bm(n == null ? void 0 : n.temporalityPreference), i;
    }
    return t.prototype.selectAggregation = function(r) {
      return this._aggregationSelector(r);
    }, t.prototype.selectAggregationTemporality = function(r) {
      return this._aggregationTemporalitySelector(r);
    }, t;
  }(xs)
), Rm = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Lm = (
  /** @class */
  function(e) {
    Rm(t, e);
    function t(r) {
      return e.call(this, uu(r != null ? r : {}, ou, "v1/metrics", { "Content-Type": "application/json" }), r) || this;
    }
    return t;
  }(wm)
);
function Pm(e, t) {
  const r = e.spanContext();
  return {
    name: e.name,
    kind: e.kind,
    spanContext: () => r,
    parentSpanId: e.parentSpanId,
    startTime: e.startTime,
    endTime: e.endTime,
    status: e.status,
    attributes: gd(e.attributes, t),
    links: e.links,
    events: e.events,
    duration: e.duration,
    ended: e.ended,
    resource: e.resource,
    instrumentationLibrary: e.instrumentationLibrary,
    droppedAttributesCount: e.droppedAttributesCount,
    droppedEventsCount: e.droppedEventsCount,
    droppedLinksCount: e.droppedLinksCount
  };
}
function Nm(e, t) {
  if (!t.isSamplingEnabled())
    return e;
  const r = [], n = {}, i = {};
  for (const o of e) {
    o.parentSpanId && (i[o.parentSpanId] = i[o.parentSpanId] || [], i[o.parentSpanId].push(
      o.spanContext().spanId
    ));
    const a = t.shouldSample(o);
    a.sample ? a.attributes ? n[o.spanContext().spanId] = Pm(
      o,
      a.attributes
    ) : n[o.spanContext().spanId] = o : r.push(o.spanContext().spanId);
  }
  for (; r.length > 0; ) {
    const o = r.shift(), a = i[o];
    if (a)
      for (const u of a)
        delete n[u], r.push(u);
  }
  return Object.values(n);
}
const Im = (e, t, r) => {
  if (typeof navigator == "undefined" || !navigator.sendBeacon)
    return !1;
  try {
    const n = new Blob([t], { type: r });
    return navigator.sendBeacon(e, n);
  } catch (n) {
    return !1;
  }
}, fu = (e, t, r, n) => {
  const i = (o) => {
    if (Im(e, t, r))
      return n({ code: N.SUCCESS });
    n({ code: N.FAILED, error: o });
  };
  try {
    const o = new Blob([t], { type: r });
    fetch(e, {
      method: "POST",
      body: o,
      keepalive: !0,
      headers: { "Content-Type": r },
      credentials: "omit"
    }).then(
      (a) => {
        if (a.ok)
          return n({ code: N.SUCCESS });
        n({
          code: N.FAILED,
          error: new Error(
            `keepalive fetch export failed with status ${a.status}`
          )
        });
      },
      // Promise rejection path: keepalive body-size overflow, network
      // error, CORS preflight failure, etc. This is where keepalive's
      // ~64KiB overflow lands — per WHATWG Fetch §4.6 it's an async
      // network error, not a synchronous throw.
      (a) => i(a)
    );
  } catch (o) {
    i(o);
  }
};
class Cm extends Tm {
  constructor(r, n) {
    var i;
    super(C(E({}, r), {
      headers: {}
      // a truthy value enables sending with XHR instead of beacon
    }));
    O(this, "url");
    O(this, "unloading", !1);
    this.sampler = n, this.url = (i = r == null ? void 0 : r.url) != null ? i : "";
  }
  setUnloading(r) {
    this.unloading = r;
  }
  export(r, n) {
    const i = Nm(r, this.sampler);
    if (i.length === 0)
      return;
    if (this.unloading) {
      const u = au.serializeRequest(i);
      if (!u || !this.url)
        return n({
          code: N.FAILED,
          error: new Error(
            "keepalive export failed: serializer returned empty or url missing"
          )
        });
      fu(
        this.url,
        u,
        "application/json",
        n
      );
      return;
    }
    let o = 0;
    const a = (u) => {
      if (u.code === N.SUCCESS)
        return n({
          code: N.SUCCESS
        });
      if (o++, o > Ta)
        return n({
          code: N.FAILED,
          error: u.error
        });
      new Promise(
        (c) => setTimeout(
          c,
          Sa + Oa * Math.pow(2, o)
        )
      ).then(() => {
        super.export(i, a);
      });
    };
    super.export(i, a);
  }
}
class Mm extends Lm {
  constructor(r) {
    var n;
    super(C(E({}, r), {
      headers: {}
    }));
    O(this, "url");
    O(this, "unloading", !1);
    this.url = (n = r == null ? void 0 : r.url) != null ? n : "";
  }
  setUnloading(r) {
    this.unloading = r;
  }
  export(r, n) {
    if (this.unloading) {
      const a = ou.serializeRequest(r);
      if (!a || !this.url)
        return n({
          code: N.FAILED,
          error: new Error(
            "keepalive export failed: serializer returned empty or url missing"
          )
        });
      fu(
        this.url,
        a,
        "application/json",
        n
      );
      return;
    }
    let i = 0;
    const o = (a) => {
      var u;
      if (a.code === N.SUCCESS)
        return n({
          code: N.SUCCESS
        });
      if (i++, i > Ta)
        return console.error(
          `[@launchdarkly/observability] failed to export OTeL metrics: ${(u = a.error) == null ? void 0 : u.message}`,
          a.error
        ), n({
          code: N.FAILED,
          error: a.error
        });
      new Promise(
        (c) => setTimeout(
          c,
          Sa + Oa * Math.pow(2, i)
        )
      ).then(() => {
        var c;
        console.warn(
          `[@launchdarkly/observability] retry ${i}, failed to export OTeL metrics: ${(c = a.error) == null ? void 0 : c.message}`,
          a.error
        ), super.export(r, o);
      });
    };
    super.export(r, o);
  }
}
const xm = "OT_ZONE_CONTEXT", Dm = "Navigation:";
function Um() {
  return !1;
}
const K = class K extends Ja {
  constructor(r = {}) {
    var n, i;
    super(
      K.moduleName,
      K.version,
      r
    );
    O(this, "_spansData", /* @__PURE__ */ new WeakMap());
    O(this, "_zonePatched");
    // for addEventListener/removeEventListener state
    O(this, "_wrappedListeners", /* @__PURE__ */ new WeakMap());
    // for event bubbling
    O(this, "_eventsSpanMap", /* @__PURE__ */ new WeakMap());
    O(this, "_eventNames");
    O(this, "_shouldPreventSpanCreation");
    O(this, "_getLDContextKeyAttributes");
    this._getLDContextKeyAttributes = r.getLDContextKeyAttributes, this._eventNames = new Set((n = r == null ? void 0 : r.eventNames) != null ? n : []), ((i = r.productAnalyticsEvents) == null ? void 0 : i.clicks) !== !1 && this._eventNames.add("click"), this._shouldPreventSpanCreation = typeof (r == null ? void 0 : r.shouldPreventSpanCreation) == "function" ? r.shouldPreventSpanCreation : Um;
  }
  init() {
  }
  /**
   * This will check if last task was timeout and will save the time to
   * fix the user interaction when nothing happens
   * This timeout comes from xhr plugin which is needed to collect information
   * about last xhr main request from observer
   * @param task
   * @param span
   */
  _checkForTimeout(r, n) {
    const i = this._spansData.get(n);
    i && (r.source === "setTimeout" ? i.hrTimeLastTimeout = Bf() : r.source !== "Promise.then" && r.source !== "setTimeout" && (i.hrTimeLastTimeout = void 0));
  }
  /**
   * Controls whether or not to create a span, based on the event type.
   */
  _allowEventName(r) {
    return this._eventNames.has(r);
  }
  /**
   * Creates a new span
   * @param event
   * @param parentSpan
   */
  _createSpan(r, n) {
    var u, c;
    const i = r == null ? void 0 : r.target, o = r == null ? void 0 : r.type;
    if (!(i instanceof HTMLElement) || !i.getAttribute || i.hasAttribute("disabled") || !this._allowEventName(o))
      return;
    const a = Es(i, !0);
    try {
      const s = this.tracer.startSpan(
        o,
        {
          attributes: {
            [ht]: window.location.href,
            "event.type": o,
            "event.tag": i.tagName,
            "event.xpath": a,
            "event.id": i.id,
            "event.classname": i.className,
            "event.text": (u = i.textContent) != null ? u : "",
            "event.url": window.location.href,
            "viewport.width": window.innerWidth,
            "viewport.height": window.innerHeight
          }
        },
        n ? R.setSpan(b.active(), n) : void 0
      );
      r instanceof MouseEvent && (s.setAttribute("event.x", r.clientX), s.setAttribute("event.y", r.clientY), s.setAttribute(
        "event.relativeX",
        r.clientX / window.innerWidth
      ), s.setAttribute(
        "event.relativeY",
        r.clientY / window.innerHeight
      ), o === "scroll" && (s.setAttribute("event.scrollX", window.scrollX), s.setAttribute("event.scrollY", window.scrollY)));
      const l = (c = this._getLDContextKeyAttributes) == null ? void 0 : c.call(this);
      return l && s.setAttributes(l), this._shouldPreventSpanCreation(o, i, s) === !0 ? void 0 : (this._spansData.set(s, {
        taskCount: 0
      }), s);
    } catch (s) {
      this._diag.error(
        "failed to start create new user interaction span",
        s
      );
    }
  }
  /**
   * Decrement number of tasks that left in zone,
   * This is needed to be able to end span when no more tasks left
   * @param span
   */
  _decrementTask(r) {
    const n = this._spansData.get(r);
    n && (n.taskCount--, n.taskCount === 0 && this._tryToEndSpan(r, n.hrTimeLastTimeout));
  }
  /**
   * Return the current span
   * @param zone
   * @private
   */
  _getCurrentSpan(r) {
    const n = r.get(xm);
    return n && R.getSpan(n);
  }
  /**
   * Increment number of tasks that are run within the same zone.
   *     This is needed to be able to end span when no more tasks left
   * @param span
   */
  _incrementTask(r) {
    const n = this._spansData.get(r);
    n && n.taskCount++;
  }
  /**
   * Returns true iff we should use the patched callback; false if it's already been patched
   */
  addPatchedListener(r, n, i, o) {
    let a = this._wrappedListeners.get(i);
    a || (a = /* @__PURE__ */ new Map(), this._wrappedListeners.set(i, a));
    let u = a.get(n);
    return u || (u = /* @__PURE__ */ new Map(), a.set(n, u)), u.has(r) ? !1 : (u.set(r, o), !0);
  }
  /**
   * Returns the patched version of the callback (or undefined)
   */
  removePatchedListener(r, n, i) {
    const o = this._wrappedListeners.get(i);
    if (!o)
      return;
    const a = o.get(n);
    if (!a)
      return;
    const u = a.get(r);
    return u && (a.delete(r), a.size === 0 && (o.delete(n), o.size === 0 && this._wrappedListeners.delete(i))), u;
  }
  // utility method to deal with the Function|EventListener nature of addEventListener
  _invokeListener(r, n, i) {
    return typeof r == "function" ? r.apply(n, i) : r.handleEvent(i[0]);
  }
  /**
   * This patches the addEventListener of HTMLElement to be able to
   * auto instrument the click events
   * This is done when zone is not available
   */
  _patchAddEventListener() {
    const r = this;
    let n = /* @__PURE__ */ new Map();
    return (i) => function(a, u, c) {
      if (!u)
        return i.call(this, a, u, c);
      const s = c && typeof c == "object" && c.once, l = function(...f) {
        var h;
        let d;
        const p = f[0];
        if (!(p != null && p.type))
          return r._invokeListener(u, this, f);
        if (Date.now() - ((h = n.get(p.type)) != null ? h : 0) < 1e3 / 60)
          return r._invokeListener(u, this, f);
        n.set(p.type, Date.now()), p && (d = r._eventsSpanMap.get(p)), s && r.removePatchedListener(this, a, u);
        const _ = r._createSpan(p, d);
        return _ ? (p && r._eventsSpanMap.set(p, _), b.with(
          R.setSpan(b.active(), _),
          () => {
            const g = r._invokeListener(
              u,
              this,
              f
            );
            return _.end(), g;
          }
        )) : r._invokeListener(u, this, f);
      };
      if (r.addPatchedListener(
        this,
        a,
        u,
        l
      ))
        return i.call(
          this,
          a,
          l,
          c
        );
    };
  }
  /**
   * This patches the removeEventListener of HTMLElement to handle the fact that
   * we patched the original callbacks
   * This is done when zone is not available
   */
  _patchRemoveEventListener() {
    const r = this;
    return (n) => function(o, a, u) {
      const c = r.removePatchedListener(
        this,
        o,
        a
      );
      return c ? n.call(
        this,
        o,
        c,
        u
      ) : n.call(this, o, a, u);
    };
  }
  /**
   * Most browser provide event listener api via EventTarget in prototype chain.
   * Exception to this is IE 11 which has it on the prototypes closest to EventTarget:
   *
   * * - has addEventListener in IE
   * ** - has addEventListener in all other browsers
   * ! - missing in IE
   *
   * HTMLElement -> Element -> Node * -> EventTarget **! -> Object
   * Document -> Node * -> EventTarget **! -> Object
   * Window * -> WindowProperties ! -> EventTarget **! -> Object
   */
  _getPatchableEventTargets() {
    return window.EventTarget ? [EventTarget.prototype] : [Node.prototype, Window.prototype];
  }
  /**
   * Patches the history api
   */
  _patchHistoryApi() {
    this._unpatchHistoryApi(), this._wrap(history, "replaceState", this._patchHistoryMethod()), this._wrap(history, "pushState", this._patchHistoryMethod()), this._wrap(history, "back", this._patchHistoryMethod()), this._wrap(history, "forward", this._patchHistoryMethod()), this._wrap(history, "go", this._patchHistoryMethod());
  }
  /**
   * Patches the certain history api method
   */
  _patchHistoryMethod() {
    const r = this;
    return (n) => function(...o) {
      const a = `${location.pathname}${location.hash}${location.search}`, u = n.apply(this, o), c = `${location.pathname}${location.hash}${location.search}`;
      return a !== c && r._updateInteractionName(c), u;
    };
  }
  /**
   * unpatch the history api methods
   */
  _unpatchHistoryApi() {
    k(history.replaceState) && this._unwrap(history, "replaceState"), k(history.pushState) && this._unwrap(history, "pushState"), k(history.back) && this._unwrap(history, "back"), k(history.forward) && this._unwrap(history, "forward"), k(history.go) && this._unwrap(history, "go");
  }
  /**
   * Updates interaction span name
   * @param url
   */
  _updateInteractionName(r) {
    const n = R.getSpan(
      b.active()
    );
    n && typeof n.updateName == "function" && n.updateName(`${Dm} ${r}`);
  }
  /**
   * Patches zone cancel task - this is done to be able to correctly
   * decrement the number of remaining tasks
   */
  _patchZoneCancelTask() {
    const r = this;
    return (n) => function(o) {
      const a = Zone.current, u = r._getCurrentSpan(a);
      return u && r._shouldCountTask(o, a) && r._decrementTask(u), n.call(this, o);
    };
  }
  /**
   * Patches zone schedule task - this is done to be able to correctly
   * increment the number of tasks running within current zone but also to
   * save time in case of timeout running from xhr plugin when waiting for
   * main request from PerformanceResourceTiming
   */
  _patchZoneScheduleTask() {
    const r = this;
    return (n) => function(o) {
      const a = Zone.current, u = r._getCurrentSpan(a);
      return u && r._shouldCountTask(o, a) && (r._incrementTask(u), r._checkForTimeout(o, u)), n.call(this, o);
    };
  }
  /**
   * Patches zone run task - this is done to be able to create a span when
   * user interaction starts
   * @private
   */
  _patchZoneRunTask() {
    const r = this;
    return (n) => function(o, a, u) {
      const c = Array.isArray(u) && u[0] instanceof Event ? u[0] : void 0, s = c == null ? void 0 : c.target;
      let l;
      const f = this;
      if (s) {
        if (l = r._createSpan(c), l)
          return r._incrementTask(l), f.run(() => {
            try {
              return b.with(
                R.setSpan(
                  b.active(),
                  l
                ),
                () => {
                  const d = Zone.current;
                  return o._zone = d, n.call(
                    d,
                    o,
                    a,
                    u
                  );
                }
              );
            } finally {
              r._decrementTask(l);
            }
          });
      } else
        l = r._getCurrentSpan(f);
      try {
        return n.call(f, o, a, u);
      } finally {
        l && r._shouldCountTask(o, f) && r._decrementTask(l);
      }
    };
  }
  /**
   * Decides if task should be counted.
   * @param task
   * @param currentZone
   * @private
   */
  _shouldCountTask(r, n) {
    if (r._zone && (n = r._zone), !n || !r.data || r.data.isPeriodic)
      return !1;
    const i = this._getCurrentSpan(n);
    return !i || !this._spansData.get(i) ? !1 : r.type === "macroTask" || r.type === "microTask";
  }
  /**
   * Will try to end span when such span still exists.
   * @param span
   * @param endTime
   * @private
   */
  _tryToEndSpan(r, n) {
    r && this._spansData.get(r) && (r.end(n), this._spansData.delete(r));
  }
  /**
   * implements enable function
   */
  enable() {
    const r = this._getZoneWithPrototype();
    this._diag.debug(
      "applying patch to",
      K.moduleName,
      K.version,
      "zone:",
      !!r
    ), r ? (k(r.prototype.runTask) && (this._unwrap(r.prototype, "runTask"), this._diag.debug("removing previous patch from method runTask")), k(r.prototype.scheduleTask) && (this._unwrap(r.prototype, "scheduleTask"), this._diag.debug(
      "removing previous patch from method scheduleTask"
    )), k(r.prototype.cancelTask) && (this._unwrap(r.prototype, "cancelTask"), this._diag.debug(
      "removing previous patch from method cancelTask"
    )), this._zonePatched = !0, this._wrap(
      r.prototype,
      "runTask",
      this._patchZoneRunTask()
    ), this._wrap(
      r.prototype,
      "scheduleTask",
      this._patchZoneScheduleTask()
    ), this._wrap(
      r.prototype,
      "cancelTask",
      this._patchZoneCancelTask()
    )) : (this._zonePatched = !1, this._getPatchableEventTargets().forEach((i) => {
      k(i.addEventListener) && (this._unwrap(i, "addEventListener"), this._diag.debug(
        "removing previous patch from method addEventListener"
      )), k(i.removeEventListener) && (this._unwrap(i, "removeEventListener"), this._diag.debug(
        "removing previous patch from method removeEventListener"
      )), this._wrap(
        i,
        "addEventListener",
        this._patchAddEventListener()
      ), this._wrap(
        i,
        "removeEventListener",
        this._patchRemoveEventListener()
      );
    })), this._patchHistoryApi();
  }
  /**
   * implements unpatch function
   */
  disable() {
    const r = this._getZoneWithPrototype();
    this._diag.debug(
      "removing patch from",
      K.moduleName,
      K.version,
      "zone:",
      !!r
    ), r && this._zonePatched ? (k(r.prototype.runTask) && this._unwrap(r.prototype, "runTask"), k(r.prototype.scheduleTask) && this._unwrap(r.prototype, "scheduleTask"), k(r.prototype.cancelTask) && this._unwrap(r.prototype, "cancelTask")) : this._getPatchableEventTargets().forEach((i) => {
      k(i.addEventListener) && this._unwrap(i, "addEventListener"), k(i.removeEventListener) && this._unwrap(i, "removeEventListener");
    }), this._unpatchHistoryApi();
  }
  /**
   * returns Zone
   */
  _getZoneWithPrototype() {
    return window.Zone;
  }
};
O(K, "version", "0.1.1"), O(K, "moduleName", "user-interaction");
let ti = K;
const $t = class $t extends Ja {
  constructor(r = {}) {
    super(
      $t.moduleName,
      $t.version,
      r
    );
    O(this, "_getLDContextKeyAttributes");
    O(this, "_unlisten");
    O(this, "_lastUrl", "");
    this._getLDContextKeyAttributes = r.getLDContextKeyAttributes;
  }
  init() {
  }
  enable() {
    this._lastUrl = window.location.href, this._unlisten = Bu((r) => {
      var i;
      const n = this._lastUrl;
      if (this._lastUrl = r, n !== r)
        try {
          const o = this.tracer.startSpan(ku, {
            attributes: {
              [ht]: r,
              "page_view.previous_url": n,
              "page_view.url": r
            }
          }), a = (i = this._getLDContextKeyAttributes) == null ? void 0 : i.call(this);
          a && o.setAttributes(a), o.end();
        } catch (o) {
          this._diag.error("failed to create page view span", o);
        }
    });
  }
  disable() {
    var r;
    (r = this._unlisten) == null || r.call(this), this._unlisten = void 0;
  }
};
O($t, "version", "0.1.0"), O($t, "moduleName", "location-change");
let ei = $t, D = {}, rt, er;
const bt = "highlight.record", Bm = "highlight.session_id", ri = /* @__PURE__ */ new Map(), du = (e) => `${e.spanContext().traceId}:${e.spanContext().spanId}`, pu = "launchdarkly.js.log", km = "launchdarkly.exception.id", ra = "launchdarkly.sampling.ratio", hu = "log.severity", _u = "log.message", Gm = (e, t) => {
  var h, g, y, m, A, w, L, I, tt, M;
  if (D.tracerProvider || D.meterProvider) {
    console.warn("OTEL already initialized. Skipping...");
    return;
  }
  rt = e;
  const r = e.backendUrl || void 0 || "https://pub.highlight.io", n = [
    ...(g = (h = e.networkRecordingOptions) == null ? void 0 : h.urlBlocklist) != null ? g : [],
    ...pg
  ], i = (y = e.environment) != null ? y : "production", o = {
    url: e.otlpEndpoint + "/v1/traces",
    concurrencyLimit: 10,
    timeoutMillis: 3e4,
    // Using any because we were getting an error importing CompressionAlgorithm
    // from @opentelemetry/otlp-exporter-base.
    compression: "gzip",
    keepAlive: !0,
    httpAgentOptions: {
      timeout: 6e4,
      keepAlive: !0
    }
  }, a = new Cm(
    o,
    t
  ), u = new dr(a, {
    maxExportBatchSize: 1024,
    // Default value from SDK is 512
    maxQueueSize: 2048,
    // Default value from SDK is 2048
    exportTimeoutMillis: o.timeoutMillis,
    // Default value from SDK is 30_000
    scheduledDelayMillis: 5e3
    // OTEL default; shorter window reduces data lost to page unload
  }), c = new Kn({
    [ju]: (m = e.serviceName) != null ? m : "highlight-browser",
    [Hu]: e.serviceVersion,
    "deployment.environment.name": i,
    "highlight.project_id": e.projectId,
    [$u]: navigator.userAgent,
    "browser.language": navigator.language,
    "telemetry.distro.name": "@highlight-run/observability",
    "telemetry.distro.version": Gu
  });
  D.tracerProvider = new Vh({
    resource: c,
    mergeResourceWithDefaults: !0,
    spanProcessors: [u]
  }), R.setGlobalTracerProvider(D.tracerProvider);
  const s = new Mm(C(E({}, o), {
    url: e.otlpEndpoint + "/v1/metrics"
  })), l = new qy({
    exporter: s,
    exportIntervalMillis: o.timeoutMillis,
    exportTimeoutMillis: o.timeoutMillis
  });
  D.meterProvider = new ME({ resource: c, readers: [l] }), qt.setGlobalMeterProvider(D.meterProvider);
  let f = [];
  if (((A = e.instrumentations) == null ? void 0 : A["@opentelemetry/instrumentation-document-load"]) !== !1 && f.push(
    new h_({
      applyCustomAttributesOnSpan: {
        documentLoad: oa,
        documentFetch: oa,
        resourceFetch: Jm
      }
    })
  ), ((w = e.instrumentations) == null ? void 0 : w["@opentelemetry/instrumentation-user-interaction"]) !== !1 && f.push(
    new ti({
      productAnalyticsEvents: e.productAnalyticsEvents,
      getLDContextKeyAttributes: e.getLDContextKeyAttributes
    })
  ), ((L = e.productAnalyticsEvents) == null ? void 0 : L.pageViews) !== !1 && f.push(
    new ei({
      getLDContextKeyAttributes: e.getLDContextKeyAttributes
    })
  ), (I = e.networkRecordingOptions) != null && I.enabled) {
    if (((tt = e.instrumentations) == null ? void 0 : tt["@opentelemetry/instrumentation-fetch"]) !== !1) {
      const gt = new uv({
        propagateTraceHeaderCorsUrls: aa(
          e.tracingOrigins
        ),
        applyCustomAttributesOnSpan: (H, Jt, Mt) => {
          var Qt, te;
          if (!H.attributes)
            return;
          const Zt = H;
          if (Zt.attributes[bt] !== !1) {
            if (ia(
              H,
              Jt.body,
              Jt.headers,
              e.networkRecordingOptions
            ), !(Mt instanceof Response)) {
              H.setAttributes({
                "http.response.error": Mt.message,
                [ba]: Mt.status
              });
              return;
            }
            if (!((Qt = e.networkRecordingOptions) != null && Qt.requestResponseSanitizer && (yn(
              H,
              e.networkRecordingOptions.requestResponseSanitizer
            ), Zt.attributes[bt] === !1)) && (te = e.networkRecordingOptions) != null && te.recordHeadersAndBody) {
              const Ie = B(void 0, null, function* () {
                var Ti, Si, Oi, bi, Ai, wi;
                const Ce = yield Ms(
                  Mt,
                  (Ti = e.networkRecordingOptions) == null ? void 0 : Ti.bodyKeysToRecord,
                  (Si = e.networkRecordingOptions) == null ? void 0 : Si.networkBodyKeysToRedact
                ), Ar = Object.fromEntries(
                  Mt.headers.entries()
                ), Lu = Er(
                  (bi = (Oi = e.networkRecordingOptions) == null ? void 0 : Oi.networkHeadersToRedact) != null ? bi : [],
                  Ar,
                  (Ai = e.networkRecordingOptions) == null ? void 0 : Ai.headerKeysToRecord
                ), Pu = gi(
                  Lu,
                  "http.response.header"
                );
                Object.assign(
                  H.attributes,
                  E({
                    "http.response.body": Ce
                  }, Pu)
                ), (wi = e.networkRecordingOptions) != null && wi.requestResponseSanitizer && yn(
                  H,
                  e.networkRecordingOptions.requestResponseSanitizer
                );
              });
              ri.set(du(H), Ie);
            }
          }
        }
      });
      f.push(gt);
    }
    ((M = e.instrumentations) == null ? void 0 : M["@opentelemetry/instrumentation-xml-http-request"]) !== !1 && f.push(
      new Yv({
        propagateTraceHeaderCorsUrls: aa(
          e.tracingOrigins
        ),
        applyCustomAttributesOnSpan: (gt, H) => {
          var Zt, Qt, te, Ie;
          const Jt = H;
          if (!(!gt.attributes || gt.attributes[bt] === !1)) {
            if (ia(
              gt,
              Jt._body,
              Jt._requestHeaders,
              e.networkRecordingOptions
            ), (Zt = e.networkRecordingOptions) != null && Zt.recordHeadersAndBody) {
              let Ce = "";
              (H.responseType === "" || H.responseType === "text") && (Ce = ot(
                H.responseText,
                (Qt = e.networkRecordingOptions) == null ? void 0 : Qt.networkBodyKeysToRedact,
                (te = e.networkRecordingOptions) == null ? void 0 : te.bodyKeysToRecord,
                void 0
              ));
              const Ar = Xm(
                H.getAllResponseHeaders()
              );
              Wm(
                gt,
                Ar,
                Ce,
                e.networkRecordingOptions
              );
            }
            (Ie = e.networkRecordingOptions) != null && Ie.requestResponseSanitizer && yn(
              gt,
              e.networkRecordingOptions.requestResponseSanitizer
            );
          }
        }
      })
    );
  }
  Pd({ instrumentations: f });
  const _ = new vs();
  return _.enable(), D.tracerProvider.register({
    contextManager: _,
    propagator: new Hf({
      propagators: [
        new Ql(),
        new Hm({
          backendUrl: r,
          otlpEndpoint: e.otlpEndpoint,
          tracingOrigins: e.tracingOrigins,
          urlBlocklist: n
        })
      ]
    })
  }), er = $m(
    a,
    s,
    u,
    () => D
  ), D;
}, $m = (e, t, r, n) => {
  if (typeof document == "undefined" || typeof window == "undefined")
    return () => {
    };
  const i = () => {
    var c, s;
    e.setUnloading(!0), t.setUnloading(!0), r.setSkipPendingOnFlush(!0);
    const u = n();
    (c = u.tracerProvider) == null || c.forceFlush().catch(() => {
    }), (s = u.meterProvider) == null || s.forceFlush().catch(() => {
    });
  }, o = () => {
    document.visibilityState === "hidden" ? i() : document.visibilityState === "visible" && (e.setUnloading(!1), t.setUnloading(!1), r.setSkipPendingOnFlush(!1));
  }, a = () => i();
  return document.addEventListener("visibilitychange", o), window.addEventListener("pagehide", a), () => {
    document.removeEventListener("visibilitychange", o), window.removeEventListener("pagehide", a);
  };
};
class dr extends _s {
  constructor() {
    super(...arguments);
    O(this, "_pendingSpans", /* @__PURE__ */ new Set());
    // When set, forceFlush/shutdown return immediately without waiting for
    // in-flight response-body reads. Used on page unload where waiting risks
    // the browser freezing JS before we hand the spans to the transport.
    O(this, "_skipPendingOnFlush", !1);
  }
  setSkipPendingOnFlush(r) {
    this._skipPendingOnFlush = r;
  }
  onStart(r, n) {
    r.setAttribute(Bm, ut()), super.onStart(r, n);
  }
  onEnd(r) {
    if (r.attributes[bt] === !1)
      return;
    const n = du(r), i = ri.get(n);
    if (i) {
      const o = i.catch((a) => {
        console.warn(
          "[CustomBatchSpanProcessor] Failed to capture response body attributes",
          a
        );
      }).finally(() => {
        ri.delete(n), this._pendingSpans.delete(o), r.attributes[bt] !== !1 && super.onEnd(r);
      });
      this._pendingSpans.add(o);
      return;
    }
    super.onEnd(r);
  }
  shutdown() {
    return B(this, null, function* () {
      return this._skipPendingOnFlush || (yield Promise.allSettled(this._pendingSpans)), Lr(dr.prototype, this, "shutdown").call(this);
    });
  }
  forceFlush() {
    return B(this, null, function* () {
      return this._skipPendingOnFlush || (yield Promise.allSettled(this._pendingSpans)), Lr(dr.prototype, this, "forceFlush").call(this);
    });
  }
}
class Hm extends id {
  constructor(r) {
    super();
    O(this, "highlightEndpoints");
    O(this, "tracingOrigins");
    O(this, "urlBlocklist");
    this.highlightEndpoints = [
      r.backendUrl,
      `${r.otlpEndpoint}/v1/traces`,
      `${r.otlpEndpoint}/v1/logs`,
      `${r.otlpEndpoint}/v1/metrics`
    ], this.tracingOrigins = r.tracingOrigins, this.urlBlocklist = r.urlBlocklist;
  }
  inject(r, n, i) {
    var u;
    const o = R.getSpan(r);
    if (!o || !o.attributes)
      return;
    const a = yu(o);
    typeof a == "string" && (Ym(
      a,
      this.highlightEndpoints,
      this.tracingOrigins,
      this.urlBlocklist
    ) || o.setAttribute(bt, !1), !hi(
      a,
      (u = this.tracingOrigins) != null ? u : [],
      this.urlBlocklist
    )) || super.inject(r, n, i);
  }
}
const vu = "highlight-browser", jm = vu, na = () => {
  var e;
  return (e = D.tracerProvider) == null ? void 0 : e.getTracer(vu);
}, ze = () => {
  var e;
  return (e = D.meterProvider) == null ? void 0 : e.getMeter(jm);
}, Vm = () => R.getActiveSpan(), Fm = () => B(void 0, null, function* () {
  er && (er(), er = void 0), yield Promise.allSettled([
    B(void 0, null, function* () {
      D.tracerProvider ? (yield D.tracerProvider.shutdown(), D.tracerProvider = void 0) : console.warn(
        "OTEL shutdown called without initialized tracerProvider."
      );
    }),
    B(void 0, null, function* () {
      D.meterProvider ? (yield D.meterProvider.shutdown(), D.meterProvider = void 0) : console.warn(
        "OTEL shutdown called without initialized meterProvider."
      );
    })
  ]);
}), ia = (e, t, r, n) => {
  var s;
  if (!e.attributes)
    return;
  const o = yu(e), a = Wn(o), u = Ls(a), c = ag(t);
  if (c && (c.name && e.setAttribute("graphql.operation.name", c.name), c.type && e.setAttribute("graphql.operation.type", c.type)), e.setAttributes({
    "highlight.type": "http.request",
    [Vt]: a,
    // overwrite with sanitized version
    [ht]: a,
    [We]: u.pathname,
    [Fu]: u.search
  }), e.setAttributes(
    zm(
      u.searchParams,
      "url.query_params"
    )
  ), n != null && n.recordHeadersAndBody) {
    const l = ot(
      t,
      n.networkBodyKeysToRedact,
      n.bodyKeysToRecord,
      r
    );
    e.setAttribute("http.request.body", l);
    const f = Er(
      (s = n.networkHeadersToRedact) != null ? s : [],
      r,
      n.headerKeysToRecord
    ), d = gi(
      f,
      "http.request.header"
    );
    e.setAttributes(d);
  }
}, Xm = (e) => {
  const t = {};
  return e && e.trim().split(/[\r\n]+/).forEach((r) => {
    const n = r.split(": "), i = n.shift();
    i && (t[i] = n.join(": "));
  }), t;
}, gi = (e, t) => {
  const r = {};
  return Object.entries(e).forEach(([n, i]) => {
    const o = n.toLowerCase().replace(/_/g, "-"), a = `${t}.${o}`, u = Km(o, i);
    if (r[a]) {
      const c = r[a];
      Array.isArray(c) ? r[a] = [...c, ...u] : r[a] = [c, ...u];
    } else
      r[a] = u.length === 1 ? u[0] : u;
  }), r;
}, zm = (e, t) => {
  const r = {};
  for (const [n, i] of e.entries()) {
    const o = `${t}.${n}`, a = r[o];
    a === void 0 ? r[o] = i : Array.isArray(a) ? a.push(i) : r[o] = [a, i];
  }
  return r;
}, qm = /* @__PURE__ */ new Set([
  "accept",
  "accept-charset",
  "accept-encoding",
  "accept-language",
  "accept-ranges",
  "allow",
  "cache-control",
  "connection",
  "content-encoding",
  "content-language",
  "expect",
  "if-match",
  "if-none-match",
  "pragma",
  "proxy-authenticate",
  "te",
  "trailer",
  "transfer-encoding",
  "upgrade",
  "vary",
  "via",
  "warning",
  "www-authenticate",
  "access-control-allow-headers",
  "access-control-allow-methods",
  "access-control-expose-headers",
  "access-control-request-headers"
]), Km = (e, t) => qm.has(e) ? t.split(",").map((r) => r.trim()).filter((r) => r.length > 0) : [t], Wm = (e, t, r, n) => {
  var a;
  e.setAttribute("http.response.body", r);
  const i = Er(
    (a = n.networkHeadersToRedact) != null ? a : [],
    t,
    n.headerKeysToRecord
  ), o = gi(
    i,
    "http.response.header"
  );
  e.setAttributes(o);
}, yn = (e, t) => {
  var f, d, p, _, h, g, y, m, A, w;
  const n = e.attributes, i = {}, o = {};
  for (const [L, I] of Object.entries(n))
    L.startsWith("http.request.header.") && (i[L.slice(20)] = String(I)), L.startsWith("http.response.header.") && (o[L.slice(21)] = String(I));
  let u = {
    request: {
      sessionSecureID: "",
      id: "",
      url: (d = (f = n[ht]) != null ? f : n[Vt]) != null ? d : "",
      verb: (p = n["http.request.method"]) != null ? p : "GET",
      headers: i,
      body: (_ = n["http.request.body"]) != null ? _ : ""
    },
    response: {
      status: Number(
        (h = n[ba]) != null ? h : 0
      ),
      headers: o,
      body: (g = n["http.response.body"]) != null ? g : ""
    },
    urlBlocked: !1
  }, c = !0;
  try {
    u.request.body = JSON.parse(u.request.body);
  } catch (L) {
    c = !1;
  }
  let s = !0;
  try {
    u.response.body = JSON.parse(u.response.body);
  } catch (L) {
    s = !1;
  }
  let l;
  try {
    l = t(u);
  } catch (L) {
    return;
  }
  if (!l) {
    Object.assign(e.attributes, {
      [bt]: !1
    });
    return;
  }
  c && ((y = l.request) != null && y.body) && (l.request.body = JSON.stringify(l.request.body)), s && ((m = l.response) != null && m.body) && (l.response.body = JSON.stringify(l.response.body)), Object.assign(e.attributes, {
    "http.request.body": (A = l.request.body) != null ? A : "",
    "http.response.body": (w = l.response.body) != null ? w : ""
  });
}, Ym = (e, t, r, n) => n != null && n.some(
  (o) => e.toLowerCase().includes(o)
) ? !1 : pi(
  e,
  t
), oa = (e) => {
  var o, a, u;
  if (!e.events)
    return;
  const r = e.events, n = {
    unload: V("unloadEventStart", "unloadEventEnd", r),
    dom_interactive: V(
      "fetchStart",
      "domInteractive",
      r
    ),
    dom_content_loaded: V(
      "domContentLoadedEventStart",
      "domContentLoadedEventEnd",
      r
    ),
    dom_complete: V("fetchStart", "domComplete", r),
    load_event: V("loadEventStart", "loadEventEnd", r),
    document_load: V("fetchStart", "loadEventEnd", r),
    first_paint: V("fetchStart", "firstPaint", r),
    first_contentful_paint: V(
      "fetchStart",
      "firstContentfulPaint",
      r
    ),
    domain_lookup: V(
      "domainLookupStart",
      "domainLookupEnd",
      r
    ),
    connect: V("connectStart", "connectEnd", r),
    request: V("requestStart", "requestEnd", r),
    response: V("responseStart", "responseEnd", r)
  }, i = (a = (o = rt == null ? void 0 : rt.getIntegrations) == null ? void 0 : o.call(rt)) != null ? a : [];
  if (n.document_load !== void 0)
    for (const c of i)
      c.recordGauge((u = rt == null ? void 0 : rt.sessionSecureId) != null ? u : "", {
        name: Vu,
        value: n.document_load / 1e6
      });
  Object.entries(n).forEach(([c, s]) => {
    s !== void 0 && (e.setAttribute(`timings.${c}.ns`, s), e.setAttribute(
      `timings.${c}.readable`,
      gu(s)
    ));
  });
};
function V(e, t, r) {
  const n = r.find((u) => u.name === e), i = r.find((u) => u.name === t);
  if (!n || !i)
    return;
  const o = n.time[0] * 1e9 + n.time[1];
  return i.time[0] * 1e9 + i.time[1] - o;
}
const Jm = (e, t) => {
  const r = {
    domain_lookup: (t.domainLookupEnd - t.domainLookupStart) * 1e9,
    connect: (t.connectEnd - t.connectStart) * 1e9,
    request: (t.responseEnd - t.requestStart) * 1e9,
    response: (t.responseEnd - t.responseStart) * 1e9
  };
  Object.entries(r).forEach(([n, i]) => {
    e.setAttribute(`timings.${n}.ns`, i), e.setAttribute(`timings.${n}.readable`, gu(i));
  });
}, gu = (e) => {
  if (e >= 36e11) {
    const a = e / 36e11;
    return `${Number(a.toFixed(1))}h`;
  } else if (e >= 6e10) {
    const a = e / 6e10;
    return `${Number(a.toFixed(1))}m`;
  } else if (e >= 1e9) {
    const a = e / 1e9;
    return `${Number(a.toFixed(1))}s`;
  } else if (e >= 1e6) {
    const a = e / 1e6;
    return `${Number(a.toFixed(1))}ms`;
  } else if (e >= 1e3) {
    const a = e / 1e3;
    return `${Number(a.toFixed(1))}µs`;
  } else
    return `${Number(e.toFixed(1))}ns`;
}, aa = (e) => e === !0 ? [
  /localhost/,
  /^\//,
  Ns(window.location.host)
] : Array.isArray(e) ? e.map(
  (t) => typeof t == "string" ? new RegExp(t) : t
) : /^$/, yu = (e) => e.attributes[ht] ? e.attributes[ht] : e.attributes[Vt], Zm = 30, Qm = () => new Promise(
  (e) => requestAnimationFrame(
    (t) => requestAnimationFrame((r) => e(r - t))
  )
), tT = () => B(void 0, null, function* () {
  const e = [];
  for (let t = 0; t < Zm; t++)
    e.push(yield Qm());
  return e.reduce((t, r) => t + r, 0) / e.length;
}), eT = (e, t) => {
  let r = {}, n = 16.666666666666668;
  tT().then((c) => n = c);
  const i = (c) => {
    var s;
    r != null && r.event || (r = {
      event: c,
      location: window.location.href,
      timerStart: (s = window.performance) == null ? void 0 : s.now()
    }, window.requestAnimationFrame(o));
  }, o = () => {
    if (!(r != null && r.timerStart)) return;
    const c = window.performance.now() - r.timerStart - n;
    a(c), r = {};
  }, a = (c) => {
    const s = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3;
    e({
      relativeTimestamp: s,
      jankAmount: c,
      querySelector: u(),
      newLocation: window.location.href != r.location ? window.location.href : void 0
    });
  }, u = () => {
    var c;
    return (c = r == null ? void 0 : r.event) != null && c.target ? Xu(r.event.target) : "";
  };
  return window.addEventListener("click", i, !0), window.addEventListener("keydown", i, !0), () => {
    window.removeEventListener("keydown", i, !0), window.removeEventListener("click", i, !0);
  };
}, rT = typeof window != "undefined", sa = rT && "performance" in window && "memory" in performance ? performance : { memory: {} }, nT = (e, t) => {
  let r = 0, n = 0;
  const i = () => {
    const l = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3, f = sa.memory.jsHeapSizeLimit || 0, d = sa.memory.usedJSHeapSize || 0;
    e({
      jsHeapSizeLimit: f,
      usedJSHeapSize: d,
      relativeTimestamp: l,
      fps: r
    });
  };
  i();
  let o;
  o = setInterval(() => {
    i();
  }, 1e3);
  let a = 0, u = Date.now();
  const c = function() {
    var s = Date.now();
    a++, s > 1e3 + u && (r = Math.round(a * 1e3 / (s - u)), a = 0, u = s), n = requestAnimationFrame(c);
  };
  return c(), () => {
    clearInterval(o), cancelAnimationFrame(n);
  };
};
var ft, he, Eu, pr, ni, Kt = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, be = function(e) {
  if (document.readyState === "loading") return "loading";
  var t = Kt();
  if (t) {
    if (e < t.domInteractive) return "loading";
    if (t.domContentLoadedEventStart === 0 || e < t.domContentLoadedEventStart) return "dom-interactive";
    if (t.domComplete === 0 || e < t.domComplete) return "dom-content-loaded";
  }
  return "complete";
}, iT = function(e) {
  var t = e.nodeName;
  return e.nodeType === 1 ? t.toLowerCase() : t.toUpperCase().replace(/^#/, "");
}, Sr = function(e, t) {
  var r = "";
  try {
    for (; e && e.nodeType !== 9; ) {
      var n = e, i = n.id ? "#" + n.id : iT(n) + (n.classList && n.classList.value && n.classList.value.trim() && n.classList.value.trim().length ? "." + n.classList.value.trim().replace(/\s+/g, ".") : "");
      if (r.length + i.length > 99) return r || i;
      if (r = r ? i + ">" + r : i, n.id) break;
      e = n.parentNode;
    }
  } catch (o) {
  }
  return r;
}, mu = -1, Tu = function() {
  return mu;
}, Ct = function(e) {
  addEventListener("pageshow", function(t) {
    t.persisted && (mu = t.timeStamp, e(t));
  }, !0);
}, Or = function() {
  var e = Kt();
  return e && e.activationStart || 0;
}, X = function(e, t) {
  var r = Kt(), n = "navigate";
  return Tu() >= 0 ? n = "back-forward-cache" : r && (document.prerendering || Or() > 0 ? n = "prerender" : document.wasDiscarded ? n = "restore" : r.type && (n = r.type.replace(/_/g, "-"))), { name: e, value: t === void 0 ? -1 : t, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: n };
}, Wt = function(e, t, r) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      var n = new PerformanceObserver(function(i) {
        Promise.resolve().then(function() {
          t(i.getEntries());
        });
      });
      return n.observe(Object.assign({ type: e, buffered: !0 }, r || {})), n;
    }
  } catch (i) {
  }
}, z = function(e, t, r, n) {
  var i, o;
  return function(a) {
    t.value >= 0 && (a || n) && ((o = t.value - (i || 0)) || i === void 0) && (i = t.value, t.delta = o, t.rating = function(u, c) {
      return u > c[1] ? "poor" : u > c[0] ? "needs-improvement" : "good";
    }(t.value, r), e(t));
  };
}, yi = function(e) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return e();
    });
  });
}, br = function(e) {
  var t = function(r) {
    r.type !== "pagehide" && document.visibilityState !== "hidden" || e(r);
  };
  addEventListener("visibilitychange", t, !0), addEventListener("pagehide", t, !0);
}, Ei = function(e) {
  var t = !1;
  return function(r) {
    t || (e(r), t = !0);
  };
}, Gt = -1, ua = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, hr = function(e) {
  document.visibilityState === "hidden" && Gt > -1 && (Gt = e.type === "visibilitychange" ? e.timeStamp : 0, oT());
}, ca = function() {
  addEventListener("visibilitychange", hr, !0), addEventListener("prerenderingchange", hr, !0);
}, oT = function() {
  removeEventListener("visibilitychange", hr, !0), removeEventListener("prerenderingchange", hr, !0);
}, mi = function() {
  return Gt < 0 && (Gt = ua(), ca(), Ct(function() {
    setTimeout(function() {
      Gt = ua(), ca();
    }, 0);
  })), { get firstHiddenTime() {
    return Gt;
  } };
}, Ne = function(e) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return e();
  }, !0) : e();
}, la = [1800, 3e3], Su = function(e, t) {
  t = t || {}, Ne(function() {
    var r, n = mi(), i = X("FCP"), o = Wt("paint", function(a) {
      a.forEach(function(u) {
        u.name === "first-contentful-paint" && (o.disconnect(), u.startTime < n.firstHiddenTime && (i.value = Math.max(u.startTime - Or(), 0), i.entries.push(u), r(!0)));
      });
    });
    o && (r = z(e, i, la, t.reportAllChanges), Ct(function(a) {
      i = X("FCP"), r = z(e, i, la, t.reportAllChanges), yi(function() {
        i.value = performance.now() - a.timeStamp, r(!0);
      });
    }));
  });
}, fa = [0.1, 0.25], aT = function(e, t) {
  (function(r, n) {
    n = n || {}, Su(Ei(function() {
      var i, o = X("CLS", 0), a = 0, u = [], c = function(l) {
        l.forEach(function(f) {
          if (!f.hadRecentInput) {
            var d = u[0], p = u[u.length - 1];
            a && f.startTime - p.startTime < 1e3 && f.startTime - d.startTime < 5e3 ? (a += f.value, u.push(f)) : (a = f.value, u = [f]);
          }
        }), a > o.value && (o.value = a, o.entries = u, i());
      }, s = Wt("layout-shift", c);
      s && (i = z(r, o, fa, n.reportAllChanges), br(function() {
        c(s.takeRecords()), i(!0);
      }), Ct(function() {
        a = 0, o = X("CLS", 0), i = z(r, o, fa, n.reportAllChanges), yi(function() {
          return i();
        });
      }), setTimeout(i, 0));
    }));
  })(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = n.entries.reduce(function(u, c) {
          return u && u.value > c.value ? u : c;
        });
        if (i && i.sources && i.sources.length) {
          var o = (a = i.sources).find(function(u) {
            return u.node && u.node.nodeType === 1;
          }) || a[0];
          if (o) return void (n.attribution = { largestShiftTarget: Sr(o.node), largestShiftTime: i.startTime, largestShiftValue: i.value, largestShiftSource: o, largestShiftEntry: i, loadState: be(i.startTime) });
        }
      }
      var a;
      n.attribution = {};
    })(r), e(r);
  }, t);
}, sT = function(e, t) {
  Su(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = Kt(), o = n.entries[n.entries.length - 1];
        if (i) {
          var a = i.activationStart || 0, u = Math.max(0, i.responseStart - a);
          return void (n.attribution = { timeToFirstByte: u, firstByteToFCP: n.value - u, loadState: be(n.entries[0].startTime), navigationEntry: i, fcpEntry: o });
        }
      }
      n.attribution = { timeToFirstByte: 0, firstByteToFCP: n.value, loadState: be(Tu()) };
    })(r), e(r);
  }, t);
}, le = { passive: !0, capture: !0 }, uT = /* @__PURE__ */ new Date(), da = function(e, t) {
  ft || (ft = t, he = e, Eu = /* @__PURE__ */ new Date(), bu(removeEventListener), Ou());
}, Ou = function() {
  if (he >= 0 && he < Eu - uT) {
    var e = { entryType: "first-input", name: ft.type, target: ft.target, cancelable: ft.cancelable, startTime: ft.timeStamp, processingStart: ft.timeStamp + he };
    pr.forEach(function(t) {
      t(e);
    }), pr = [];
  }
}, cT = function(e) {
  if (e.cancelable) {
    var t = (e.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - e.timeStamp;
    e.type == "pointerdown" ? function(r, n) {
      var i = function() {
        da(r, n), a();
      }, o = function() {
        a();
      }, a = function() {
        removeEventListener("pointerup", i, le), removeEventListener("pointercancel", o, le);
      };
      addEventListener("pointerup", i, le), addEventListener("pointercancel", o, le);
    }(t, e) : da(t, e);
  }
}, bu = function(e) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(t) {
    return e(t, cT, le);
  });
}, pa = [100, 300], lT = function(e, t) {
  t = t || {}, Ne(function() {
    var r, n = mi(), i = X("FID"), o = function(c) {
      c.startTime < n.firstHiddenTime && (i.value = c.processingStart - c.startTime, i.entries.push(c), r(!0));
    }, a = function(c) {
      c.forEach(o);
    }, u = Wt("first-input", a);
    r = z(e, i, pa, t.reportAllChanges), u && br(Ei(function() {
      a(u.takeRecords()), u.disconnect();
    })), u && Ct(function() {
      var c;
      i = X("FID"), r = z(e, i, pa, t.reportAllChanges), pr = [], he = -1, ft = null, bu(addEventListener), c = o, pr.push(c), Ou();
    });
  });
}, fT = function(e, t) {
  lT(function(r) {
    (function(n) {
      var i = n.entries[0];
      n.attribution = { eventTarget: Sr(i.target), eventType: i.name, eventTime: i.startTime, eventEntry: i, loadState: be(i.startTime) };
    })(r), e(r);
  }, t);
}, Au = 0, En = 1 / 0, qe = 0, dT = function(e) {
  e.forEach(function(t) {
    t.interactionId && (En = Math.min(En, t.interactionId), qe = Math.max(qe, t.interactionId), Au = qe ? (qe - En) / 7 + 1 : 0);
  });
}, wu = function() {
  return ni ? Au : performance.interactionCount || 0;
}, pT = function() {
  "interactionCount" in performance || ni || (ni = Wt("event", dT, { type: "event", buffered: !0, durationThreshold: 0 }));
}, ha = [200, 500], Ru = 0, _a = function() {
  return wu() - Ru;
}, Y = [], mn = {}, va = function(e) {
  var t = Y[Y.length - 1], r = mn[e.interactionId];
  if (r || Y.length < 10 || e.duration > t.latency) {
    if (r) r.entries.push(e), r.latency = Math.max(r.latency, e.duration);
    else {
      var n = { id: e.interactionId, latency: e.duration, entries: [e] };
      mn[n.id] = n, Y.push(n);
    }
    Y.sort(function(i, o) {
      return o.latency - i.latency;
    }), Y.splice(10).forEach(function(i) {
      delete mn[i.id];
    });
  }
}, hT = function(e, t) {
  t = t || {}, Ne(function() {
    var r;
    pT();
    var n, i = X("INP"), o = function(u) {
      u.forEach(function(l) {
        l.interactionId && va(l), l.entryType === "first-input" && !Y.some(function(f) {
          return f.entries.some(function(d) {
            return l.duration === d.duration && l.startTime === d.startTime;
          });
        }) && va(l);
      });
      var c, s = (c = Math.min(Y.length - 1, Math.floor(_a() / 50)), Y[c]);
      s && s.latency !== i.value && (i.value = s.latency, i.entries = s.entries, n());
    }, a = Wt("event", o, { durationThreshold: (r = t.durationThreshold) !== null && r !== void 0 ? r : 40 });
    n = z(e, i, ha, t.reportAllChanges), a && ("interactionId" in PerformanceEventTiming.prototype && a.observe({ type: "first-input", buffered: !0 }), br(function() {
      o(a.takeRecords()), i.value < 0 && _a() > 0 && (i.value = 0, i.entries = []), n(!0);
    }), Ct(function() {
      Y = [], Ru = wu(), i = X("INP"), n = z(e, i, ha, t.reportAllChanges);
    }));
  });
}, _T = function(e, t) {
  hT(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = n.entries.sort(function(o, a) {
          return a.duration - o.duration || a.processingEnd - a.processingStart - (o.processingEnd - o.processingStart);
        })[0];
        n.attribution = { eventTarget: Sr(i.target), eventType: i.name, eventTime: i.startTime, eventEntry: i, loadState: be(i.startTime) };
      } else n.attribution = {};
    })(r), e(r);
  }, t);
}, ga = [2500, 4e3], Tn = {}, vT = function(e, t) {
  (function(r, n) {
    n = n || {}, Ne(function() {
      var i, o = mi(), a = X("LCP"), u = function(l) {
        var f = l[l.length - 1];
        f && f.startTime < o.firstHiddenTime && (a.value = Math.max(f.startTime - Or(), 0), a.entries = [f], i());
      }, c = Wt("largest-contentful-paint", u);
      if (c) {
        i = z(r, a, ga, n.reportAllChanges);
        var s = Ei(function() {
          Tn[a.id] || (u(c.takeRecords()), c.disconnect(), Tn[a.id] = !0, i(!0));
        });
        ["keydown", "click"].forEach(function(l) {
          addEventListener(l, function() {
            return setTimeout(s, 0);
          }, !0);
        }), br(s), Ct(function(l) {
          a = X("LCP"), i = z(r, a, ga, n.reportAllChanges), yi(function() {
            a.value = performance.now() - l.timeStamp, Tn[a.id] = !0, i(!0);
          });
        });
      }
    });
  })(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = Kt();
        if (i) {
          var o = i.activationStart || 0, a = n.entries[n.entries.length - 1], u = a.url && performance.getEntriesByType("resource").filter(function(p) {
            return p.name === a.url;
          })[0], c = Math.max(0, i.responseStart - o), s = Math.max(c, u ? (u.requestStart || u.startTime) - o : 0), l = Math.max(s, u ? u.responseEnd - o : 0), f = Math.max(l, a ? a.startTime - o : 0), d = { element: Sr(a.element), timeToFirstByte: c, resourceLoadDelay: s - c, resourceLoadTime: l - s, elementRenderDelay: f - l, navigationEntry: i, lcpEntry: a };
          return a.url && (d.url = a.url), u && (d.lcpResourceEntry = u), void (n.attribution = d);
        }
      }
      n.attribution = { timeToFirstByte: 0, resourceLoadDelay: 0, resourceLoadTime: 0, elementRenderDelay: n.value };
    })(r), e(r);
  }, t);
}, ya = [800, 1800], gT = function e(t) {
  document.prerendering ? Ne(function() {
    return e(t);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return e(t);
  }, !0) : setTimeout(t, 0);
}, yT = function(e, t) {
  t = t || {};
  var r = X("TTFB"), n = z(e, r, ya, t.reportAllChanges);
  gT(function() {
    var i = Kt();
    if (i) {
      var o = i.responseStart;
      if (o <= 0 || o > performance.now()) return;
      r.value = Math.max(o - Or(), 0), r.entries = [i], n(!0), Ct(function() {
        r = X("TTFB", 0), (n = z(e, r, ya, t.reportAllChanges))(!0);
      });
    }
  });
}, ET = function(e, t) {
  yT(function(r) {
    (function(n) {
      if (n.entries.length) {
        var i = n.entries[0], o = i.activationStart || 0, a = Math.max(i.domainLookupStart - o, 0), u = Math.max(i.connectStart - o, 0), c = Math.max(i.requestStart - o, 0);
        n.attribution = { waitingTime: a, dnsTime: u - a, connectionTime: c - u, requestTime: n.value - c, navigationEntry: i };
      } else n.attribution = { waitingTime: 0, dnsTime: 0, connectionTime: 0, requestTime: 0 };
    })(r), e(r);
  }, t);
};
const mT = (e) => (aT(e), sT(e), fT(e), vT(e), ET(e), _T(e), () => {
}), kt = typeof navigator != "undefined" && "connection" in navigator ? navigator.connection : {}, TT = (e, t) => {
  const r = () => {
    const o = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3;
    e({
      relativeTimestamp: o,
      downlink: kt.downlink,
      downlinkMax: kt.downlinkMax,
      effectiveType: kt.effectiveType,
      rtt: kt.rtt,
      saveData: kt.saveData,
      type: kt.type
    });
  };
  r();
  let n;
  return n = setInterval(() => {
    r();
  }, 1e3), () => {
    clearInterval(n);
  };
}, ST = () => {
  if (!("performance" in window && "memory" in performance))
    return {
      getDeviceDetails: void 0,
      getCurrentDeviceDetails: void 0
    };
  const e = window.performance;
  return {
    getDeviceDetails: () => ({
      deviceMemory: OT(
        navigator.deviceMemory || 0
      )
    }),
    getCurrentDeviceDetails: () => {
      const n = Sn(
        e.memory.jsHeapSizeLimit
      ), i = Sn(
        e.memory.totalJSHeapSize
      ), o = Sn(
        e.memory.usedJSHeapSize
      );
      return {
        jsHeapSizeLimit: n,
        totalJSHeapSize: i,
        usedJSHeapSize: o
      };
    }
  };
}, Sn = (e) => e / Math.pow(1e3, 2), OT = (e) => 1024 * e, bT = {
  TTFB: "ms",
  FCP: "ms",
  LCP: "ms",
  INP: "ms",
  FID: "ms",
  Jank: "ms",
  CLS: "1",
  usedJSHeapSize: "By",
  jsHeapSizeLimit: "By",
  totalJSHeapSize: "By",
  fps: "{frames}/s",
  [j.ViewportHeight]: "{px}",
  [j.ViewportWidth]: "{px}",
  [j.ScreenHeight]: "{px}",
  [j.ScreenWidth]: "{px}",
  [j.ViewportArea]: "{px2}",
  // Value is 1024 * navigator.deviceMemory (GiB → MiB), not decimal megabytes.
  [j.DeviceMemory]: "MiBy",
  downlink: "Mbit/s",
  downlinkMax: "Mbit/s",
  rtt: "ms",
  "long_task.duration": "ms"
};
function Ke(e, t) {
  const r = t != null ? t : bT[e];
  return r ? { unit: r } : void 0;
}
function AT(e) {
  return "regexValue" in e;
}
function wT(e) {
  return "matchValue" in e;
}
function RT(e) {
  const t = Math.trunc(e);
  return t === 1 ? !0 : t === 0 ? !1 : Math.floor(Math.random() * t) === 0;
}
class LT {
  /**
   * @param config The sampling configuration.
   * @param sampler The sampler to use. This is intended to be used for testing purposes.
   */
  constructor(t = RT) {
    O(this, "regexCache", /* @__PURE__ */ new Map());
    O(this, "config");
    this.sampler = t;
  }
  setConfig(t) {
    this.config = t;
  }
  isSamplingEnabled() {
    var t, r, n, i;
    return !!((r = (t = this.config) == null ? void 0 : t.logs) != null && r.length || (i = (n = this.config) == null ? void 0 : n.spans) != null && i.length);
  }
  shouldSample(t) {
    var r, n;
    return t.name === pu ? this.sampleLog((r = this.config) == null ? void 0 : r.logs, t) : this.sampleSpan((n = this.config) == null ? void 0 : n.spans, t);
  }
  /**
   * Check if a value matches a match config.
   */
  matchesValue(t, r) {
    if (!t)
      return !1;
    if (wT(t))
      return t.matchValue === r;
    if (AT(t)) {
      const n = t.regexValue;
      if (n === null)
        return !1;
      this.regexCache.has(n) || this.regexCache.set(n, new RegExp(n));
      const i = this.regexCache.get(n);
      if (typeof r == "string")
        return i.test(r);
    }
    return !1;
  }
  /**
   * Check if the attributes match the attribute configs.
   */
  matchesAttributes(t, r) {
    if (t)
      for (const n of t) {
        let i = !1;
        for (const o of Object.keys(r))
          if (this.matchesValue(n.key, o)) {
            const a = r[o];
            if (this.matchesValue(
              n.attribute,
              a
            )) {
              i = !0;
              break;
            }
          }
        if (!i)
          return !1;
      }
    return !0;
  }
  matchEvent(t, r) {
    return !(t.name && !this.matchesValue(t.name, r.name) || t.attributes && (!r.attributes || !this.matchesAttributes(
      t.attributes,
      r.attributes
    )));
  }
  matchesEvents(t, r) {
    if (t)
      for (const n of t) {
        let i = !1;
        for (const o of r)
          if (this.matchEvent(n, o)) {
            i = !0;
            break;
          }
        if (!i)
          return !1;
      }
    return !0;
  }
  /**
   * Attempts to match the span to the config. The span will match only if all defined conditions are met.
   *
   * @param config The config to match against.
   * @param name The name of the span to match.
   * @param attributes The attributes of the span to match.
   * @returns True if the span matches the config, false otherwise.
   */
  matchesSpanConfig(t, r) {
    return !(t.name && !this.matchesValue(t.name, r.name) || !this.matchesAttributes(t.attributes, r.attributes) || !this.matchesEvents(t.events, r.events));
  }
  matchesLogConfig(t, r) {
    if (t.severityText) {
      const n = r[hu];
      if (!this.matchesValue(t.severityText, n))
        return !1;
    }
    if (t.message) {
      const n = r[_u];
      if (!this.matchesValue(t.message, n))
        return !1;
    }
    return !!this.matchesAttributes(t.attributes, r);
  }
  /**
   * Sample a span based on the sampling configuration.
   *
   * @param configs The sampling configuration.
   * @param name The name of the span to sample.
   * @param attributes The attributes of the span to sample.
   * @returns The sampling result.
   */
  sampleSpan(t, r) {
    if (t) {
      for (const n of t)
        if (this.matchesSpanConfig(n, r))
          return {
            sample: this.sampler(n.samplingRatio),
            attributes: {
              [ra]: n.samplingRatio
            }
          };
    }
    return {
      sample: !0
    };
  }
  /**
   * Sample a log based on the sampling configuration.
   *
   * @param configs The sampling configuration.
   * @param attributes The attributes of the log to sample.
   * @returns The sampling result.
   */
  sampleLog(t, r) {
    if (t) {
      for (const n of t)
        if (this.matchesLogConfig(n, r.attributes))
          return {
            sample: this.sampler(n.samplingRatio),
            attributes: {
              [ra]: n.samplingRatio
            }
          };
    }
    return {
      sample: !0
    };
  }
}
const Ea = () => {
  const e = {
    end: () => {
    },
    spanContext: () => ({
      traceId: "",
      spanId: "",
      traceFlags: 0
    }),
    setAttribute: (t, r) => e,
    setAttributes: (t) => e,
    addEvent: (t, r, n) => e,
    addLinks: (t) => e,
    setStatus: (t) => e,
    recordException: () => {
    },
    addLink: () => e,
    updateName: () => e,
    isRecording: () => !1
  };
  return e;
}, PT = () => {
  if (typeof window == "undefined" || typeof PerformanceObserver == "undefined") return !1;
  const e = PerformanceObserver.supportedEntryTypes;
  return Array.isArray(e) && e.includes("longtask");
}, NT = (e) => {
  if (!PT()) return () => {
  };
  let t;
  try {
    t = new PerformanceObserver((r) => {
      var n;
      for (const i of r.getEntries()) {
        const o = (n = i.attribution) == null ? void 0 : n[0];
        e({
          duration: i.duration,
          name: i.name,
          startTime: i.startTime,
          containerType: o == null ? void 0 : o.containerType,
          containerSrc: o == null ? void 0 : o.containerSrc,
          containerId: o == null ? void 0 : o.containerId,
          containerName: o == null ? void 0 : o.containerName
        });
      }
    }), t.observe({ type: "longtask", buffered: !0 });
  } catch (r) {
    return () => {
    };
  }
  return () => {
    try {
      t.disconnect();
    } catch (r) {
    }
  };
}, IT = /* @__PURE__ */ new Set(["string", "number", "boolean"]), CT = () => typeof window != "undefined" && typeof window.ReportingObserver != "undefined", MT = (e) => {
  const t = {};
  if (!e || typeof e != "object") return t;
  for (const [r, n] of Object.entries(
    e
  ))
    if (n != null)
      if (IT.has(typeof n))
        t[`report.body.${r}`] = n;
      else
        try {
          t[`report.body.${r}`] = JSON.stringify(n);
        } catch (i) {
        }
  return t;
}, xT = (e) => {
  var n;
  const t = (n = e.body) != null ? n : {}, r = t.message || t.reason || t.id || e.type;
  return typeof r == "string" ? r : e.type;
}, DT = (e, t) => {
  if (!CT()) return () => {
  };
  const r = [
    "deprecation",
    "intervention",
    "csp-violation"
  ], n = window.ReportingObserver;
  let i;
  try {
    i = new n(
      (o) => {
        var a, u;
        for (const c of o) {
          const s = (a = c.type) != null ? a : "unknown", l = (u = c.body) != null ? u : {}, f = E({
            "report.type": s,
            "report.url": c.url
          }, MT(l)), d = xT({ type: s, body: l });
          e(s === "deprecation" ? {
            kind: "log",
            level: "warn",
            type: s,
            message: d,
            url: c.url,
            attributes: f
          } : {
            kind: "error",
            type: s,
            message: d,
            url: c.url,
            attributes: f
          });
        }
      },
      { buffered: !0, types: r }
    ), i.observe();
  } catch (o) {
    return () => {
    };
  }
  return () => {
    try {
      i.disconnect();
    } catch (o) {
    }
  };
}, UT = "exception", BT = function(e, t, r) {
  if (!e)
    return;
  const n = E({}, r);
  typeof t == "string" ? n[Nr] = t : t && (t.code ? n[Pr] = t.code.toString() : t.name && (n[Pr] = t.name), t.message && (n[Nr] = t.message), t.stack && (n[zu] = t.stack)), n[Pr] || n[Nr] ? e.addEvent(UT, n) : gc(
    "otel",
    "recordException",
    "warn",
    `Failed to record an exception ${t}`
  );
};
var Ae;
class kT {
  constructor(t) {
    /** Verbose project ID that is exposed to users. Legacy users may still be using ints. */
    O(this, "organizationID");
    O(this, "_options");
    O(this, "_integrations", []);
    O(this, "_gauges", /* @__PURE__ */ new Map());
    O(this, "_counters", /* @__PURE__ */ new Map());
    O(this, "_histograms", /* @__PURE__ */ new Map());
    O(this, "_up_down_counters", /* @__PURE__ */ new Map());
    O(this, "sampler", new LT());
    O(this, "_started", !1);
    O(this, "_ldContextKeys");
    // ECMAScript-private (#) so the internal GraphQL SDK type — which
    // references graphql-request / graphql — does not leak into the published
    // declaration file and break consumer type-checking.
    Ci(this, Ae);
    this._options = t, this.organizationID = t.projectId;
  }
  _productAnalyticsEvents() {
    var n;
    const t = (n = this._options) == null ? void 0 : n.productAnalytics;
    if (t === !1)
      return {};
    const r = {
      clicks: !0,
      pageViews: !0,
      trackEvents: !0
    };
    if (t === void 0 || t === !0)
      return r;
    for (const i of Object.keys(t))
      t[i] === !1 && (r[i] = !1);
    return r;
  }
  setLDContextKeyAttributes(t) {
    t && (this._ldContextKeys = Object.fromEntries(
      Object.entries(t).map(([r, n]) => [
        `${qu}.${r}`,
        n
      ])
    ));
  }
  getLDContextKeyAttributes() {
    return this._ldContextKeys;
  }
  start() {
    return B(this, null, function* () {
      var r, n, i, o, a, u, c, s, l, f, d, p, _, h, g;
      if (this._started)
        return;
      this._started = !0, Gm(
        {
          backendUrl: (n = (r = this._options) == null ? void 0 : r.backendUrl) != null ? n : "https://pub.observability.app.launchdarkly.com",
          otlpEndpoint: (a = (o = (i = this._options) == null ? void 0 : i.otel) == null ? void 0 : o.otlpEndpoint) != null ? a : "https://otel.observability.app.launchdarkly.com",
          projectId: this._options.projectId,
          sessionSecureId: this._options.sessionSecureId,
          environment: (c = (u = this._options) == null ? void 0 : u.environment) != null ? c : "production",
          networkRecordingOptions: typeof ((s = this._options) == null ? void 0 : s.networkRecording) == "object" ? this._options.networkRecording : void 0,
          tracingOrigins: (l = this._options) == null ? void 0 : l.tracingOrigins,
          serviceName: (d = (f = this._options) == null ? void 0 : f.serviceName) != null ? d : "browser",
          serviceVersion: (p = this._options) == null ? void 0 : p.version,
          instrumentations: (h = (_ = this._options) == null ? void 0 : _.otel) == null ? void 0 : h.instrumentations,
          productAnalyticsEvents: this._productAnalyticsEvents(),
          getLDContextKeyAttributes: () => this.getLDContextKeyAttributes(),
          getIntegrations: () => this._integrations
        },
        this.sampler
      ), this._gauges.clear(), this._counters.clear(), this._histograms.clear(), this._up_down_counters.clear();
      const t = new Yu(
        (g = this._options.backendUrl) != null ? g : "https://pub.observability.app.launchdarkly.com",
        {
          headers: {}
        }
      );
      Mi(this, Ae, Ku(t, Wu())), yield this.configureSampling(), this.setupListeners();
    });
  }
  stop() {
    return B(this, null, function* () {
      this._started && (this._started = !1, yield Fm());
    });
  }
  configureSampling() {
    return B(this, null, function* () {
      try {
        const t = yield Ii(this, Ae).GetSamplingConfig({
          organization_verbose_id: `${this.organizationID}`
        });
        this.sampler.setConfig(t.sampling);
      } catch (t) {
        Aa(
          "sampling",
          "warn",
          `LaunchDarkly Observability: Failed to configure sampling: ${t}`
        );
      }
    });
  }
  _recordLog(t, r, n, i) {
    this.startSpan(pu, (o) => {
      var c, s, l, f, d;
      const a = typeof t == "string" ? t : _e(t), u = i ? i.map((p) => p.toString()).join(`
`) : void 0;
      if (o == null || o.addEvent("log", E(E({
        [hu]: r,
        [_u]: a,
        "code.stacktrace": u
      }, (c = this._ldContextKeys) != null ? c : {}), n)), this._options.reportConsoleErrors && r === "error") {
        const p = new Error(a);
        o == null || o.recordException(p), o == null || o.setStatus({
          code: nr.ERROR,
          message: a
        }), i ? this._recordErrorMessage({
          error: p,
          event: p.message,
          type: "custom",
          url: window.location.href,
          source: "frontend",
          lineNumber: (l = (s = i[0]) == null ? void 0 : s.lineNumber) != null ? l : 0,
          columnNumber: (d = (f = i[0]) == null ? void 0 : f.columnNumber) != null ? d : 0,
          stackTrace: i,
          timestamp: (/* @__PURE__ */ new Date()).toISOString(),
          id: bn()
        }) : this.recordError(p);
      }
    });
  }
  _recordErrorMessage(t, r) {
    try {
      t.payload && (r = E(E({}, JSON.parse(t.payload)), r || {}));
    } catch (a) {
    }
    this.startSpan("highlight.exception", (a) => {
      var u;
      BT(a, (u = t.error) != null ? u : new Error(t.event), {
        [km]: t.id
      }), a == null || a.setAttributes(E({
        event: t.event,
        type: t.type,
        url: t.url,
        source: t.source,
        lineNumber: t.lineNumber,
        columnNumber: t.columnNumber
      }, r));
    });
    const o = t, { payload: n } = o, i = Rr(o, ["payload"]);
    for (const a of this._integrations)
      a.error(ut(), C(E({}, i), {
        payload: JSON.stringify(r)
      }));
  }
  recordError(t, r, n, i, o) {
    var s, l, f, d;
    t = t || new Error("Unknown error"), t instanceof Error && t.cause && (n = C(E({}, n), {
      "exception.cause": JSON.stringify(t.cause)
    }));
    let a = r ? r + ":" + t.message : t.message;
    o === "React.ErrorBoundary" && (a = "ErrorBoundary: " + a);
    const u = _r(t), c = {
      error: t,
      event: a,
      type: o != null ? o : "custom",
      url: window.location.href,
      source: i != null ? i : "frontend",
      lineNumber: (s = u[0]) != null && s.lineNumber ? (l = u[0]) == null ? void 0 : l.lineNumber : 0,
      columnNumber: (f = u[0]) != null && f.columnNumber ? (d = u[0]) == null ? void 0 : d.columnNumber : 0,
      stackTrace: u,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      id: bn()
    };
    this._recordErrorMessage(c, n);
  }
  recordCount(t) {
    var n, i;
    let r = this._counters.get(t.name);
    if (!r) {
      if (r = (n = ze()) == null ? void 0 : n.createCounter(
        t.name,
        Ke(t.name, t.unit)
      ), !r) return;
      this._counters.set(t.name, r);
    }
    r.add(t.value, C(E(E({}, (i = this._ldContextKeys) != null ? i : {}), t.attributes), {
      "highlight.session_id": ut()
    }));
  }
  recordGauge(t) {
    var o, a, u;
    let r = this._gauges.get(t.name);
    if (!r) {
      if (r = (o = ze()) == null ? void 0 : o.createGauge(
        t.name,
        Ke(t.name, t.unit)
      ), !r) return;
      this._gauges.set(t.name, r);
    }
    const n = E(E({}, (a = this._ldContextKeys) != null ? a : {}), t.attributes);
    r.record(t.value, C(E({}, n), {
      "highlight.session_id": ut()
    }));
    const i = {
      name: t.name,
      value: t.value,
      unit: t.unit,
      category: n.category,
      group: (u = n.group) == null ? void 0 : u.toString(),
      tags: Object.entries(n).map(([c, s]) => {
        var l;
        return {
          name: c != null ? c : "",
          value: (l = s == null ? void 0 : s.toString()) != null ? l : ""
        };
      })
    };
    for (const c of this._integrations)
      c.recordGauge(
        ut(),
        i
      );
  }
  recordIncr(t) {
    this.recordCount(C(E({}, t), { value: 1 }));
  }
  recordHistogram(t) {
    var n, i;
    let r = this._histograms.get(t.name);
    if (!r) {
      if (r = (n = ze()) == null ? void 0 : n.createHistogram(
        t.name,
        Ke(t.name, t.unit)
      ), !r) return;
      this._histograms.set(t.name, r);
    }
    r.record(t.value, C(E(E({}, (i = this._ldContextKeys) != null ? i : {}), t.attributes), {
      "highlight.session_id": ut()
    }));
  }
  recordUpDownCounter(t) {
    var n, i;
    let r = this._up_down_counters.get(t.name);
    if (!r) {
      if (r = (n = ze()) == null ? void 0 : n.createUpDownCounter(
        t.name,
        Ke(t.name, t.unit)
      ), !r) return;
      this._up_down_counters.set(t.name, r);
    }
    r.add(t.value, C(E(E({}, (i = this._ldContextKeys) != null ? i : {}), t.attributes), {
      "highlight.session_id": ut()
    }));
  }
  startSpan(t, r, n, i) {
    const o = na();
    if (!o) {
      const u = Ea();
      return i === void 0 && n === void 0 ? r(u) : i === void 0 ? n(u) : i(u);
    }
    const a = (u, c) => {
      this._ldContextKeys && u.setAttributes(this._ldContextKeys);
      const s = c(u);
      return s instanceof Promise ? s.finally(() => u.end()) : (u.end(), s);
    };
    return i === void 0 && n === void 0 ? o.startActiveSpan(
      t,
      (u) => a(u, r)
    ) : i === void 0 ? o.startActiveSpan(
      t,
      r,
      (u) => a(u, n)
    ) : o.startActiveSpan(
      t,
      r,
      n,
      (u) => a(u, i)
    );
  }
  startManualSpan(t, r, n, i) {
    const o = na();
    if (!o) {
      const a = Ea();
      return i === void 0 && n === void 0 ? r(a) : i === void 0 ? n(a) : i(a);
    }
    return i === void 0 && n === void 0 ? o.startActiveSpan(t, r) : i === void 0 ? o.startActiveSpan(
      t,
      r,
      n
    ) : o.startActiveSpan(
      t,
      r,
      n,
      i
    );
  }
  register(t, r) {
    this._integrations.push(new Ju(t, r));
  }
  getHooks(t) {
    return this._integrations.flatMap((r) => {
      var n, i;
      return (i = (n = r.getHooks) == null ? void 0 : n.call(r, t)) != null ? i : [];
    });
  }
  submitViewportMetrics({
    height: t,
    width: r,
    availHeight: n,
    availWidth: i
  }) {
    this.recordGauge({
      name: j.ViewportHeight,
      value: t,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: j.ViewportWidth,
      value: r,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: j.ScreenHeight,
      value: n,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: j.ScreenWidth,
      value: i,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: j.ViewportArea,
      value: t * r,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    });
  }
  setupListeners() {
    var r;
    this._options.disableConsoleRecording || Tc(
      (n) => {
        var i;
        this._recordLog(
          (i = n.value) == null ? void 0 : i.join(" "),
          n.type,
          n.attributes ? JSON.parse(n.attributes) : {},
          n.trace
        );
      },
      {
        level: (r = this._options.consoleMethodsToRecord) != null ? r : [
          ...wa
        ],
        logger: "console",
        stringifyOptions: {
          depthOfLimit: 10,
          numOfKeysLimit: 100,
          stringLengthLimit: 1e3
        }
      }
    ), this._options.enablePerformanceRecording !== !1 && (nT((n) => {
      Object.entries(n).filter(([i]) => i !== "relativeTimestamp").forEach(
        ([i, o]) => o && this.recordGauge({
          name: i,
          value: o,
          attributes: {
            category: F.Performance,
            group: window.location.href
          }
        })
      );
    }, 0), eT((n) => {
      this.recordGauge({
        name: "Jank",
        value: n.jankAmount,
        attributes: {
          category: F.WebVital,
          group: n.querySelector
        }
      });
    }, 0)), Nc(
      (n) => {
        var a;
        if (Cc.includes(n.event) || Mc.some(
          (u) => n.event.includes(u)
        ))
          return;
        const i = new Error(n.event);
        i.stack = _e(n.stackTrace.map((u) => u.toString()));
        let o = {};
        try {
          n.payload && (o = JSON.parse(n.payload));
        } catch (u) {
        }
        this._recordErrorMessage(
          C(E({}, n), { error: (a = n.error) != null ? a : i }),
          o
        );
      },
      { enablePromisePatch: !!this._options.enablePromisePatch }
    ), mT((n) => {
      const { name: i, value: o } = n, { hostname: a, pathname: u, href: c } = window.location, s = {
        group: window.location.pathname,
        category: F.WebVital,
        [ht]: Wn(c),
        [We]: u,
        [tc]: a
      };
      switch (n.name) {
        case "LCP": {
          const l = n.attribution;
          l.element && (s["web_vital.element"] = l.element), l.url && (s["web_vital.attribution.url"] = Wn(
            l.url
          ));
          break;
        }
        case "CLS": {
          const l = n.attribution;
          l.largestShiftTarget && (s["web_vital.element"] = l.largestShiftTarget), l.loadState && (s["web_vital.load_state"] = l.loadState);
          break;
        }
        case "INP": {
          const l = n.attribution;
          l.eventTarget && (s["web_vital.element"] = l.eventTarget), l.eventType && (s["web_vital.event_type"] = l.eventType), l.loadState && (s["web_vital.load_state"] = l.loadState);
          break;
        }
        case "FID": {
          const l = n.attribution;
          l.eventTarget && (s["web_vital.element"] = l.eventTarget), l.eventType && (s["web_vital.event_type"] = l.eventType);
          break;
        }
        case "FCP": {
          const l = n.attribution;
          l.loadState && (s["web_vital.load_state"] = l.loadState);
          break;
        }
      }
      this.recordGauge({
        name: i,
        value: o,
        attributes: s
      });
    }), Zu((n) => {
      this.submitViewportMetrics(n);
    }), TT((n) => {
      const i = {
        category: F.Performance,
        group: window.location.href
      };
      n.saveData !== void 0 && (i.saveData = n.saveData.toString()), n.effectiveType !== void 0 && (i.effectiveType = n.effectiveType.toString()), n.type !== void 0 && (i.type = n.type.toString()), Object.entries(n).filter(([o]) => o !== "relativeTimestamp").forEach(([o, a]) => {
        Qu(a) && this.recordGauge({
          name: o,
          value: a,
          attributes: i
        });
      });
    }, (/* @__PURE__ */ new Date()).getTime());
    const { getDeviceDetails: t } = ST();
    t && this.recordGauge({
      name: j.DeviceMemory,
      value: t().deviceMemory,
      attributes: {
        category: F.Device,
        group: window.location.href
      }
    }), this._options.enableLongtaskRecording !== !1 && NT((n) => {
      const i = {
        category: F.Performance,
        name: n.name,
        [We]: window.location.pathname
      };
      n.containerType && (i.container_type = n.containerType), n.containerSrc && (i.container_src = n.containerSrc), n.containerId && (i.container_id = n.containerId), n.containerName && (i.container_name = n.containerName), this.recordHistogram({
        name: "long_task.duration",
        value: n.duration,
        attributes: i
      });
    }), this._options.enableReportingObserver !== !1 && DT((n) => {
      var o;
      const i = C(E({}, n.attributes), {
        [We]: window.location.pathname
      });
      if (n.kind === "log")
        this._recordLog(
          n.message,
          (o = n.level) != null ? o : "warn",
          i
        );
      else {
        const a = new Error(n.message);
        this.recordError(
          a,
          void 0,
          Object.fromEntries(
            Object.entries(i).map(([u, c]) => [
              u,
              c === void 0 ? "" : String(c)
            ])
          ),
          "reporting-observer",
          "custom"
        );
      }
    });
  }
  recordLog(t, r, n) {
    return this._recordLog(t, r, n);
  }
}
Ae = new WeakMap();
class KT extends ec {
  constructor(r) {
    super(r);
    O(this, "observe");
    O(this, "options");
    O(this, "exposureDeduper");
    this.options = r, this.exposureDeduper = new fg(
      r == null ? void 0 : r.flagExposureDedupeWindowMillis,
      r == null ? void 0 : r.flagExposureDedupeMaxSize
    );
  }
  initialize(r, n) {
    try {
      if (typeof window == "undefined" || typeof document == "undefined") {
        console.warn(
          "@launchdarkly/observability is not initializing because it is not supported in this environment."
        );
        return;
      }
      if (!r) {
        console.warn(
          "@launchdarkly/observability is not initializing because the SDK credential is undefined."
        );
        return;
      }
      this.configureSession(r, n), this.observe = new kT(C(E({}, n), {
        projectId: r,
        sessionSecureId: this.sessionSecureID
      })), n != null && n.manualStart || this.observe.start(), yc.load(this.observe);
    } catch (i) {
      Aa(
        "Error initializing @launchdarkly/observability SDK",
        "error",
        i
      );
    }
  }
  getMetadata() {
    return {
      name: "@launchdarkly/observability"
    };
  }
  register(r, n) {
    var i;
    (i = this.observe) == null || i.register(r, n);
  }
  getHooks(r) {
    var i, o, a, u;
    const n = E(E({
      [fc]: r.sdk.name,
      [lc]: r.sdk.version,
      [cc]: r.clientSideId,
      [uc]: "LaunchDarkly"
    }, (i = r.application) != null && i.id ? { [sc]: r.application.id } : {}), (o = r.application) != null && o.version ? {
      [ac]: r.application.version
    } : {});
    return this.initialize(
      (u = (a = r.sdkKey) != null ? a : r.mobileKey) != null ? u : r.clientSideId,
      this.options
    ), [
      {
        getMetadata: () => ({
          name: "@launchdarkly/observability/hooks"
        }),
        afterIdentify: (c, s, l) => {
          var d, p, _, h, g, y, m, A, w;
          for (const L of (_ = (p = (d = this.observe) == null ? void 0 : d.getHooks) == null ? void 0 : p.call(d, r)) != null ? _ : [])
            (h = L.afterIdentify) == null || h.call(L, c, s, l);
          const f = xi(c.context);
          if ((g = this.observe) == null || g.setLDContextKeyAttributes(f), l.status === "completed") {
            this.exposureDeduper.reset();
            const L = C(E({}, f), {
              key: (A = (m = (y = this.options) == null ? void 0 : y.contextFriendlyName) == null ? void 0 : m.call(
                y,
                c.context
              )) != null ? A : Ir(c.context),
              timeout: c.timeout,
              canonicalKey: Ir(c.context),
              [vc]: l.status
            });
            (w = this.observe) == null || w.recordLog("LD.identify", "info", E(E({}, n), L));
          }
          return s;
        },
        afterEvaluation: (c, s, l) => {
          var h, g, y, m, A, w, L, I, tt;
          for (const M of (y = (g = (h = this.observe) == null ? void 0 : h.getHooks) == null ? void 0 : g.call(h, r)) != null ? y : [])
            (m = M.afterEvaluation) == null || m.call(M, c, s, l);
          const f = E({
            [pc]: c.flagKey,
            [nc]: JSON.stringify(l.value)
          }, l.variationIndex ? {
            [dc]: l.variationIndex
          } : {});
          if (l.reason)
            for (const M in Di) {
              const et = M, Yt = l.reason[et];
              Yt && (f[Di[et]] = Yt);
            }
          const d = c.context ? Ir(c.context) : void 0;
          c.context && (f[hc] = JSON.stringify(xi(c.context)), f[_c] = d);
          const p = [
            c.flagKey,
            JSON.stringify(l.value),
            (A = l.variationIndex) != null ? A : "",
            (L = (w = l.reason) == null ? void 0 : w.kind) != null ? L : "",
            (tt = (I = l.reason) == null ? void 0 : I.ruleId) != null ? tt : "",
            d != null ? d : ""
          ].join("|");
          if (!this.observe || !this.exposureDeduper.shouldRecord(p))
            return s;
          const _ = E(E({}, n), f);
          return this.observe.startSpan(ic, (M) => {
            M != null && M.isRecording() && (M.addEvent(oc, _), this.exposureDeduper.markRecorded(p));
          }), s;
        },
        afterTrack: (c) => {
          var f, d, p, _, h, g, y, m, A;
          for (const w of (p = (d = (f = this.observe) == null ? void 0 : f.getHooks) == null ? void 0 : d.call(f, r)) != null ? p : [])
            (_ = w.afterTrack) == null || _.call(w, c);
          if (!(((h = this.options) == null ? void 0 : h.productAnalytics) !== !1 && (typeof ((g = this.options) == null ? void 0 : g.productAnalytics) != "object" || this.options.productAnalytics.trackEvents !== !1)))
            return;
          const l = E(C(E(E({
            [ht]: window.location.href
          }, (m = (y = this.observe) == null ? void 0 : y.getLDContextKeyAttributes()) != null ? m : {}), n), {
            key: c.key,
            value: c.metricValue
          }), typeof c.data == "object" ? c.data : {});
          (A = this.observe) == null || A.startSpan(rc, (w) => {
            w && w.setAttributes(l);
          });
        }
      }
    ];
  }
}
export {
  wa as A,
  Tc as C,
  pg as D,
  Nc as E,
  qT as F,
  eT as J,
  F as M,
  TT as N,
  KT as O,
  nT as P,
  mT as W,
  zT as X,
  pi as a,
  Cc as b,
  Mc as c,
  VT as d,
  Sc as e,
  Gm as f,
  LT as g,
  j as h,
  ze as i,
  Ke as j,
  ST as k,
  Wn as l,
  XT as m,
  Is as n,
  na as o,
  _r as p,
  Ea as q,
  bn as r,
  Fm as s
};
//# sourceMappingURL=observe-UPObm6g-.js.map
